/**
 * UniversalReport
 * v3.2.1
 * @author jeffjnfeng 2021-07-14 15:12:33
 */

var proxy = {
    get: function () {
        return function () { }; // 返回函数
    },
};
var handlers = [];
var targetObj = {
    window: typeof window,
    document: typeof document,
    navigator: typeof navigator,
    Image: typeof Image,
    location: typeof location,
};
// 在服务端环境中增加对window、document、navigator、Image的代理
var setProxys = function () {
    Object.keys(targetObj).forEach(setProxy);
};
var setProxy = function (key) {
    if (targetObj[key] !== 'undefined')
        return;
    global[key] = key === 'navigator' ? {
        userAgent: '',
    } : new Proxy(function () { }, proxy);
    handlers.push(function () {
        global[key] = undefined;
    });
};
setProxys();
// 对 window.location 做单独的处理，兼容 node 环境中本身有 window 的场景
if (typeof window.location === 'undefined') {
    window.location = {};
}
function removeProxy() {
    handlers.forEach(function (h) {
        h();
    });
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

/**
 * 上报标准事件
 */
var STANDARD_EVENTS;
(function (STANDARD_EVENTS) {
    STANDARD_EVENTS["PGIN"] = "dt_pgin";
    STANDARD_EVENTS["PGOUT"] = "dt_pgout";
    STANDARD_EVENTS["IMP"] = "dt_imp";
    STANDARD_EVENTS["IMPEND"] = "dt_imp_end";
    STANDARD_EVENTS["CLCK"] = "dt_clck";
})(STANDARD_EVENTS || (STANDARD_EVENTS = {}));
/**
 * 公共参数
 */
// 默认账号信息
var defAccountInfo = {
    dt_qq_h5: '',
    dt_qqopenid_h5: '',
    dt_wxopenid_h5: '',
    dt_wbopenid_h5: '',
    dt_mainlogin_h5: '',
};

/* eslint-disable */
/*!
 * UAParser.js v0.7.21
 * Lightweight JavaScript-based User-Agent string parser
 * https://github.com/faisalman/ua-parser-js
 */
var EMPTY = '', UNKNOWN = '?', FUNC_TYPE = 'function', OBJ_TYPE = 'object', STR_TYPE = 'string', MODEL = 'model', NAME = 'name', TYPE = 'type', VENDOR = 'vendor', VERSION = 'version', CONSOLE = 'console', MOBILE = 'phone', TABLET = 'tablet', SMARTTV = 'tv', WEARABLE = 'wearable';
var util = {
    extend: function (regexes, extensions) {
        var mergedRegexes = {};
        for (var i in regexes) {
            if (extensions[i] && extensions[i].length % 2 === 0) {
                mergedRegexes[i] = extensions[i].concat(regexes[i]);
            }
            else {
                mergedRegexes[i] = regexes[i];
            }
        }
        return mergedRegexes;
    },
    has: function (str1, str2) {
        if (typeof str1 === 'string') {
            return str2.toLowerCase().indexOf(str1.toLowerCase()) !== -1;
        }
        else {
            return false;
        }
    },
    lowerize: function (str) {
        return str.toLowerCase();
    },
    major: function (version) {
        return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, '').split('.')[0] : undefined;
    },
    trim: function (str) {
        return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
    }
};
var mapper = {
    rgx: function (ua, arrays) {
        var i = 0, j, k, p, q, matches, match;
        // loop through all regexes maps
        while (i < arrays.length && !matches) {
            var regex = arrays[i], // even sequence (0,2,4,..)
            props = arrays[i + 1]; // odd sequence (1,3,5,..)
            j = k = 0;
            // try matching uastring with regexes
            while (j < regex.length && !matches) {
                matches = regex[j++].exec(ua);
                if (!!matches) {
                    for (p = 0; p < props.length; p++) {
                        match = matches[++k];
                        q = props[p];
                        // check if given property is actually array
                        if (typeof q === OBJ_TYPE && q.length > 0) {
                            if (q.length == 2) {
                                if (typeof q[1] == FUNC_TYPE) {
                                    // assign modified match
                                    this[q[0]] = q[1].call(this, match);
                                }
                                else {
                                    // assign given value, ignore regex match
                                    this[q[0]] = q[1];
                                }
                            }
                            else if (q.length == 3) {
                                // check whether function or regex
                                if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                                    // call function (usually string mapper)
                                    this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                                }
                                else {
                                    // sanitize match using given regex
                                    this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                                }
                            }
                            else if (q.length == 4) {
                                this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                            }
                        }
                        else {
                            this[q] = match ? match : undefined;
                        }
                    }
                }
            }
            i += 2;
        }
    },
    str: function (str, map) {
        for (var i in map) {
            // check if array
            if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
                for (var j = 0; j < map[i].length; j++) {
                    if (util.has(map[i][j], str)) {
                        return i === UNKNOWN ? undefined : i;
                    }
                }
            }
            else if (util.has(map[i], str)) {
                return i === UNKNOWN ? undefined : i;
            }
        }
        return str;
    }
};
var maps = {
    device: {
        amazon: {
            model: {
                'Fire Phone': ['SD', 'KF']
            }
        },
        sprint: {
            model: {
                'Evo Shift 4G': '7373KT'
            },
            vendor: {
                HTC: 'APA',
                Sprint: 'Sprint'
            }
        }
    },
    os: {
        windows: {
            version: {
                ME: '4.90',
                'NT 3.11': 'NT3.51',
                'NT 4.0': 'NT4.0',
                '2000': 'NT 5.0',
                XP: ['NT 5.1', 'NT 5.2'],
                Vista: 'NT 6.0',
                '7': 'NT 6.1',
                '8': 'NT 6.2',
                '8.1': 'NT 6.3',
                '10': ['NT 6.4', 'NT 10.0'],
                RT: 'ARM'
            }
        }
    }
};
var regexes = {
    device: [[
            /\((ipad|playbook);[\w\s\),;-]+(rim|apple)/i // iPad/PlayBook
        ], [MODEL, VENDOR, [TYPE, TABLET]], [
            /applecoremedia\/[\w\.]+ \((ipad)/ // iPad
        ], [MODEL, [VENDOR, 'Apple'], [TYPE, TABLET]], [
            /(apple\s{0,1}tv)/i // Apple TV
        ], [[MODEL, 'Apple TV'], [VENDOR, 'Apple'], [TYPE, SMARTTV]], [
            /(archos)\s(gamepad2?)/i,
            /(hp).+(touchpad)/i,
            /(hp).+(tablet)/i,
            /(kindle)\/([\w\.]+)/i,
            /\s(nook)[\w\s]+build\/(\w+)/i,
            /(dell)\s(strea[kpr\s\d]*[\dko])/i // Dell Streak
        ], [VENDOR, MODEL, [TYPE, TABLET]], [
            /(kf[A-z]+)(\sbuild\/|\)).+silk\//i // Kindle Fire HD
        ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [
            /(sd|kf)[0349hijorstuw]+(\sbuild\/|\)).+silk\//i // Fire Phone
        ], [[MODEL, mapper.str, maps.device.amazon.model], [VENDOR, 'Amazon'], [TYPE, MOBILE]], [
            /android.+aft([bms])\sbuild/i // Fire TV
        ], [MODEL, [VENDOR, 'Amazon'], [TYPE, SMARTTV]], [
            /\((ip[honed|\s\w*]+);.+(apple)/i // iPod/iPhone
        ], [MODEL, VENDOR, [TYPE, MOBILE]], [
            /\((ip[honed|\s\w*]+);/i // iPod/iPhone
        ], [MODEL, [VENDOR, 'Apple'], [TYPE, MOBILE]], [
            /(blackberry)[\s-]?(\w+)/i,
            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]*)/i,
            // BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
            /(hp)\s([\w\s]+\w)/i,
            /(asus)-?(\w+)/i // Asus
        ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /\(bb10;\s(\w+)/i // BlackBerry 10
        ], [MODEL, [VENDOR, 'BlackBerry'], [TYPE, MOBILE]], [
            // Asus Tablets
            /android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone|p00c)/i
        ], [MODEL, [VENDOR, 'Asus'], [TYPE, TABLET]], [
            /(sony)\s(tablet\s[ps])\sbuild\//i,
            /(sony)?(?:sgp.+)\sbuild\//i
        ], [[VENDOR, 'Sony'], [MODEL, 'Xperia Tablet'], [TYPE, TABLET]], [
            /android.+\s([c-g]\d{4}|so[-l]\w+)(?=\sbuild\/|\).+chrome\/(?![1-6]{0,1}\d\.))/i
        ], [MODEL, [VENDOR, 'Sony'], [TYPE, MOBILE]], [
            /\s(ouya)\s/i,
            /(nintendo)\s([wids3u]+)/i // Nintendo
        ], [VENDOR, MODEL, [TYPE, CONSOLE]], [
            /android.+;\s(shield)\sbuild/i // Nvidia
        ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [
            /(playstation\s[34portablevi]+)/i // Playstation
        ], [MODEL, [VENDOR, 'Sony'], [TYPE, CONSOLE]], [
            /(sprint\s(\w+))/i // Sprint Phones
        ], [[VENDOR, mapper.str, maps.device.sprint.vendor], [MODEL, mapper.str, maps.device.sprint.model], [TYPE, MOBILE]], [
            /(htc)[;_\s-]{1,2}([\w\s]+(?=\)|\sbuild)|\w+)/i,
            /(zte)-(\w*)/i,
            /(alcatel|geeksphone|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]*)/i
            // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
        ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [
            /(nexus\s9)/i // HTC Nexus 9
        ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [
            /d\/huawei([\w\s-]+)[;\)]/i,
            /android.+\s(nexus\s6p|vog-[at]?l\d\d|ane-[at]?l[x\d]\d|eml-a?l\d\da?|lya-[at]?l\d[\dc]|clt-a?l\d\di?)/i
        ], [MODEL, [VENDOR, 'Huawei'], [TYPE, MOBILE]], [
            /android.+(bah2?-a?[lw]\d{2})/i // Huawei MediaPad
        ], [MODEL, [VENDOR, 'Huawei'], [TYPE, TABLET]], [
            /(microsoft);\s(lumia[\s\w]+)/i // Microsoft Lumia
        ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /[\s\(;](xbox(?:\sone)?)[\s\);]/i // Microsoft Xbox
        ], [MODEL, [VENDOR, 'Microsoft'], [TYPE, CONSOLE]], [
            /(kin\.[onetw]{3})/i // Microsoft Kin
        ], [[MODEL, /\./g, ' '], [VENDOR, 'Microsoft'], [TYPE, MOBILE]], [
            // Motorola
            /\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?:?(\s4g)?)[\w\s]+build\//i,
            /mot[\s-]?(\w*)/i,
            /(XT\d{3,4}) build\//i,
            /(nexus\s6)/i
        ], [MODEL, [VENDOR, 'Motorola'], [TYPE, MOBILE]], [
            /android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i
        ], [MODEL, [VENDOR, 'Motorola'], [TYPE, TABLET]], [
            /hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i // HbbTV devices
        ], [[VENDOR, util.trim], [MODEL, util.trim], [TYPE, SMARTTV]], [
            /hbbtv.+maple;(\d+)/i
        ], [[MODEL, /^/, 'SmartTV'], [VENDOR, 'Samsung'], [TYPE, SMARTTV]], [
            /\(dtv[\);].+(aquos)/i // Sharp
        ], [MODEL, [VENDOR, 'Sharp'], [TYPE, SMARTTV]], [
            /android.+((sch-i[89]0\d|shw-m380s|SM-P605|SM-P610|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i,
            /((SM-T\w+))/i
        ], [[VENDOR, 'Samsung'], MODEL, [TYPE, TABLET]], [
            /smart-tv.+(samsung)/i
        ], [VENDOR, [TYPE, SMARTTV], MODEL], [
            /((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i,
            /(sam[sung]*)[\s-]*(\w+-?[\w-]*)/i,
            /sec-((sgh\w+))/i
        ], [[VENDOR, 'Samsung'], MODEL, [TYPE, MOBILE]], [
            /sie-(\w*)/i // Siemens
        ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [
            /(maemo|nokia).*(n900|lumia\s\d+)/i,
            /(nokia)[\s_-]?([\w-]*)/i
        ], [[VENDOR, 'Nokia'], MODEL, [TYPE, MOBILE]], [
            /android[x\d\.\s;]+\s([ab][1-7]\-?[0178a]\d\d?)/i // Acer
        ], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [
            /android.+([vl]k\-?\d{3})\s+build/i // LG Tablet
        ], [MODEL, [VENDOR, 'LG'], [TYPE, TABLET]], [
            /android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i // LG Tablet
        ], [[VENDOR, 'LG'], MODEL, [TYPE, TABLET]], [
            /linux;\snetcast.+smarttv/i,
            /lg\snetcast\.tv-201\d/i
        ], [[VENDOR, 'LG'], MODEL, [TYPE, SMARTTV]], [
            /(nexus\s[45])/i,
            /lg[e;\s\/-]+(\w*)/i,
            /android.+lg(\-?[\d\w]+)\s+build/i
        ], [MODEL, [VENDOR, 'LG'], [TYPE, MOBILE]], [
            /(lenovo)\s?(s(?:5000|6000)(?:[\w-]+)|tab(?:[\s\w]+))/i // Lenovo tablets
        ], [VENDOR, MODEL, [TYPE, TABLET]], [
            /android.+(ideatab[a-z0-9\-\s]+)/i // Lenovo
        ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [
            /(lenovo)[_\s-]?([\w-]+)/i
        ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /linux;.+((jolla));/i // Jolla
        ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /((pebble))app\/[\d\.]+\s/i // Pebble
        ], [VENDOR, MODEL, [TYPE, WEARABLE]], [
            /android.+;\s(oppo)\s?([\w\s]+)\sbuild/i // OPPO
        ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /crkey/i // Google Chromecast
        ], [[MODEL, 'Chromecast'], [VENDOR, 'Google'], [TYPE, SMARTTV]], [
            /android.+;\s(glass)\s\d/i // Google Glass
        ], [MODEL, [VENDOR, 'Google'], [TYPE, WEARABLE]], [
            /android.+;\s(pixel c)[\s)]/i // Google Pixel C
        ], [MODEL, [VENDOR, 'Google'], [TYPE, TABLET]], [
            /android.+;\s(pixel( [2-9]a?)?( xl)?)[\s)]/i // Google Pixel
        ], [MODEL, [VENDOR, 'Google'], [TYPE, MOBILE]], [
            /android.+;\s(\w+)\s+build\/hm\1/i,
            /android.+(hm[\s\-_]?note?[\s_]?(?:\d\w)?)\sbuild/i,
            /android.+(redmi[\s\-_]?(?:note|k)?(?:[\s_]?[\w\s]+))(?:\sbuild|\))/i,
            // Xiaomi Redmi
            /android.+(mi[\s\-_]?(?:a\d|one|one[\s_]plus|note lte)?[\s_]?(?:\d?\w?)[\s_]?(?:plus)?)\sbuild/i
            // Xiaomi Mi
        ], [[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, MOBILE]], [
            /android.+(mi[\s\-_]?(?:pad)(?:[\s_]?[\w\s]+))(?:\sbuild|\))/i // Mi Pad tablets
        ], [[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, TABLET]], [
            /android.+;\s(m[1-5]\snote)\sbuild/i // Meizu
        ], [MODEL, [VENDOR, 'Meizu'], [TYPE, MOBILE]], [
            /(mz)-([\w-]{2,})/i
        ], [[VENDOR, 'Meizu'], MODEL, [TYPE, MOBILE]], [
            /android.+a000(1)\s+build/i,
            /android.+oneplus\s(a\d{4})[\s)]/i
        ], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [
            /android.+[;\/]\s*(RCT[\d\w]+)\s+build/i // RCA Tablets
        ], [MODEL, [VENDOR, 'RCA'], [TYPE, TABLET]], [
            /android.+[;\/\s](Venue[\d\s]{2,7})\s+build/i // Dell Venue Tablets
        ], [MODEL, [VENDOR, 'Dell'], [TYPE, TABLET]], [
            /android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i // Verizon Tablet
        ], [MODEL, [VENDOR, 'Verizon'], [TYPE, TABLET]], [
            /android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i // Barnes & Noble Tablet
        ], [[VENDOR, 'Barnes & Noble'], MODEL, [TYPE, TABLET]], [
            /android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i // Barnes & Noble Tablet
        ], [MODEL, [VENDOR, 'NuVision'], [TYPE, TABLET]], [
            /android.+;\s(k88)\sbuild/i // ZTE K Series Tablet
        ], [MODEL, [VENDOR, 'ZTE'], [TYPE, TABLET]], [
            /android.+[;\/]\s*(gen\d{3})\s+build.*49h/i // Swiss GEN Mobile
        ], [MODEL, [VENDOR, 'Swiss'], [TYPE, MOBILE]], [
            /android.+[;\/]\s*(zur\d{3})\s+build/i // Swiss ZUR Tablet
        ], [MODEL, [VENDOR, 'Swiss'], [TYPE, TABLET]], [
            /android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i // Zeki Tablets
        ], [MODEL, [VENDOR, 'Zeki'], [TYPE, TABLET]], [
            /(android).+[;\/]\s+([YR]\d{2})\s+build/i,
            /android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(\w{5})\sbuild/i // Dragon Touch Tablet
        ], [[VENDOR, 'Dragon Touch'], MODEL, [TYPE, TABLET]], [
            /android.+[;\/]\s*(NS-?\w{0,9})\sbuild/i // Insignia Tablets
        ], [MODEL, [VENDOR, 'Insignia'], [TYPE, TABLET]], [
            /android.+[;\/]\s*((NX|Next)-?\w{0,9})\s+build/i // NextBook Tablets
        ], [MODEL, [VENDOR, 'NextBook'], [TYPE, TABLET]], [
            /android.+[;\/]\s*(Xtreme\_)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i
        ], [[VENDOR, 'Voice'], MODEL, [TYPE, MOBILE]], [
            /android.+[;\/]\s*(LVTEL\-)?(V1[12])\s+build/i // LvTel Phones
        ], [[VENDOR, 'LvTel'], MODEL, [TYPE, MOBILE]], [
            /android.+;\s(PH-1)\s/i
        ], [MODEL, [VENDOR, 'Essential'], [TYPE, MOBILE]], [
            /android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i // Envizen Tablets
        ], [MODEL, [VENDOR, 'Envizen'], [TYPE, TABLET]], [
            /android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(\w{1,9})\s+build/i // Le Pan Tablets
        ], [VENDOR, MODEL, [TYPE, TABLET]], [
            /android.+[;\/]\s*(Trio[\s\w\-\.]+)\s+build/i // MachSpeed Tablets
        ], [MODEL, [VENDOR, 'MachSpeed'], [TYPE, TABLET]], [
            /android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i // Trinity Tablets
        ], [VENDOR, MODEL, [TYPE, TABLET]], [
            /android.+[;\/]\s*TU_(1491)\s+build/i // Rotor Tablets
        ], [MODEL, [VENDOR, 'Rotor'], [TYPE, TABLET]], [
            //android.+(KS(.+))\s+build/i                                        // Amazon Kindle Tablets
            //], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [
            /android.+(Gigaset)[\s\-]+(Q\w{1,9})\s+build/i // Gigaset Tablets
        ], [VENDOR, MODEL, [TYPE, TABLET]], [
            // Android Phones from Unidentified Vendors
            /android .+?; ([^;]+?)(?: build|\) applewebkit).+? mobile safari/i
        ], [MODEL, [TYPE, MOBILE]], [
            // Android Tablets from Unidentified Vendors
            /android .+?;\s([^;]+?)(?: build|\) applewebkit).+?(?! mobile) safari/i
        ], [MODEL, [TYPE, TABLET]], [
            /\s(tablet|tab)[;\/]/i,
            /\s(mobile)(?:[;\/]|\ssafari)/i // Unidentifiable Mobile
        ], [[TYPE, util.lowerize], VENDOR, MODEL], [
            /[\s\/\(](smart-?tv)[;\)]/i // SmartTV
        ], [[TYPE, SMARTTV]], [
            /(android[\w\.\s\-]{0,9});.+build/i // Generic Android Device
        ], [MODEL, [VENDOR, 'Generic']]
    ],
    engine: [
        [
            /windows.+\sedge\/([\w\.]+)/i // EdgeHTML
        ],
        [VERSION, [NAME, 'EdgeHTML']],
        [
            /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i // Blink
        ],
        [VERSION, [NAME, 'Blink']],
        [
            /(presto)\/([\w\.]+)/i,
            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
            // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
            /(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,
            /(icab)[\/\s]([23]\.[\d\.]+)/i // iCab
        ],
        [NAME, VERSION],
        [
            /rv\:([\w\.]{1,9}).+(gecko)/i // Gecko
        ],
        [VERSION, NAME]
    ],
    os: [
        [
            // Windows based
            /microsoft\s(windows)\s(vista|xp)/i // Windows (iTunes)
        ],
        [NAME, VERSION],
        [
            /(windows)\snt\s6\.2;\s(arm)/i,
            /(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s\w]*)/i,
            /(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i
        ],
        [NAME, [VERSION, mapper.str, maps.os.windows.version]],
        [/(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i],
        [
            [NAME, 'windows'],
            [VERSION, mapper.str, maps.os.windows.version]
        ],
        [/(android)[\/\s-]?([\w\.]*)/i],
        [NAME, VERSION],
        [
            // android
            /cfnetwork\/.+darwin/i,
            /ip[honead]{2,4}(?:.*os\s([\w]+)\slike\smac|;\sopera)/i // ios
        ],
        [
            [VERSION, /_/g, '.'],
            [NAME, 'ios']
        ],
        [
            /(mac\sos\sx)\s?([\w\s\.]*)/i,
            /(macintosh|mac(?=_powerpc)\s)/i // macos
        ],
        [
            [NAME, 'macos'],
            [VERSION, /_/g, '.']
        ]
    ]
};
var UAparser = /** @class */ (function () {
    function UAparser(uastring, extensions) {
        this.ua =
            uastring ||
                (window && window.navigator && window.navigator.userAgent
                    ? window.navigator.userAgent
                    : EMPTY);
        this.rgxmap = extensions ? util.extend(regexes, extensions) : regexes;
    }
    UAparser.prototype.getDevice = function () {
        var device = { vendor: undefined, model: undefined, type: undefined };
        mapper.rgx.call(device, this.ua, this.rgxmap.device);
        return device;
    };
    UAparser.prototype.getEngine = function () {
        var engine = { name: undefined, version: undefined };
        mapper.rgx.call(engine, this.ua, this.rgxmap.engine);
        return engine;
    };
    UAparser.prototype.getOS = function () {
        var os = { name: undefined, version: undefined };
        mapper.rgx.call(os, this.ua, this.rgxmap.os);
        return os;
    };
    UAparser.prototype.getResult = function () {
        return {
            engine: this.getEngine(),
            os: this.getOS(),
            device: this.getDevice()
        };
    };
    return UAparser;
}());

/**
 * UUID
 */
var uuid = function () {
    var s4 = function () {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    };
    return s4() + s4() + "-" + s4() + "-" + s4() + "-" + s4() + "-" + s4() + s4() + s4();
};
/**
 * 获取 URL 参数
 */
var getUrlParameter = function (key) {
    var name = key.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
    var results = regex.exec(window.location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};
/**
 * 反选对象属性
 * @description 去除对象的某些属性返回一个新的对象
 * @param {object} obj  对象
 * @param {array}  keys 属性数组
 * @return {object}
 */
var reject = function (obj, keys) {
    return Object.keys(obj)
        .filter(function (k) { return !keys.includes(k); })
        .map(function (k) {
        var _a;
        return (k in obj ? (_a = {}, _a[k] = obj[k], _a) : {});
    })
        .reduce(function (res, o) { return Object.assign(res, o); }, {});
};
/**
 * 判断是否为 DOM
 */
var isDom = function (dom) {
    return typeof HTMLElement === 'object'
        ? dom instanceof HTMLElement
        : dom && typeof dom === 'object' && dom.nodeType === 1 && typeof dom.nodeName === 'string';
};
/**
 * 获取 DOM 节点
 * @param {HTMLElement | string} [param] 节点或选择器
 */
var getDom = function (param) {
    var $param = param;
    if (typeof $param === 'string') {
        $param = document.querySelector($param);
    }
    return isDom($param) ? $param : null;
};
/**
 * 动态加载 JS
 * @param {string} url 请求资源地址
 * @param {string} id  js id，如果已经存在则不再重复加载，默认为时间戳+随机数
 */
var loadScript = function (url, id) {
    if (id === void 0) { id = Date.now() + "-" + Math.random(); }
    return new Promise(function (resolve, reject) {
        // 避免重复加载
        if (document.getElementById(id)) {
            resolve(null);
            return;
        }
        var head = document.getElementsByTagName('head')[0];
        var script = document.createElement('script');
        var onloadHandler = function () {
            script.onload = null;
            script.onreadystatechange = null;
            if (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete') {
                resolve(null);
            }
        };
        script.onload = onloadHandler;
        script.onreadystatechange = onloadHandler;
        script.onerror = function (err) {
            script.onerror = null;
            head.removeChild(script);
            reject(err);
        };
        script.src = url;
        script.id = id;
        head.appendChild(script);
    });
};
/**
 * 获取 DPI
 * 每英寸点数，下面的方法不准确，仅供参考
 */
var getDPI = function () {
    if (!document.body)
        return 0;
    var div = document.createElement('div');
    div.style.height = '1in';
    div.style.width = '1in';
    div.style.top = '-100%';
    div.style.left = '-100%';
    div.style.position = 'absolute';
    document.body.appendChild(div);
    var result = div.offsetHeight;
    document.body.removeChild(div);
    return result;
};
/**
 * 获取网络连接类型
 */
var getNetworkType = function () {
    if (!navigator.connection)
        return '';
    return navigator.connection.effectiveType;
};
/**
 * 获取终端类型
 */
var getPlatform = function (clientInfo) {
    if (clientInfo.device.type === undefined) {
        return 'pc';
    }
    return clientInfo.device.type;
};
/**
 * 场景平台及版本号
 */
var getScenePlat = function (scenePlat) {
    if (scenePlat === void 0) { scenePlat = {}; }
    var sceneMap = __assign({ qq: /qq\/([\d.]+)/i, wx: /MicroMessenger\/([\w.]+)/i, qqvideo: /QQLive(?:HD)?Browser\/([\d.]+)/, qqnews: /qqnews\/(\d+\.\d+\.\d+)/i, qqreading: /qnreading\/(\d+\.\d+\.\d+)/i, qqbrowser: /MQQBrowser\/(\d+\.\d+)/i, qzone: /Qzone\/[\w\d_]*(\d\.\d)[.\w\d_]*/i, kuaibao: /qnreading\/(\d+\.\d+\.\d+)/i, weibo: /Weibo/i }, scenePlat);
    var sceneName = '';
    var sceneVersion = '';
    var hasScene = Object.keys(sceneMap).some(function (name) {
        sceneName = name;
        var matchResult = navigator.userAgent.match(sceneMap[name]);
        if (matchResult && matchResult.length === 2) { // 获取版本号
            sceneVersion = matchResult[1];
        }
        return matchResult;
    });
    return { scenePlat: hasScene ? sceneName : '', sceneVersion: sceneVersion };
};
/**
 * 判断是否为合法灯塔参数
 * @description 灯塔参数可以是 appkey 或者灯塔实例
 * @param {string | object} beacon 灯塔参数
 */
var isLegalBeacon = function (beacon) {
    var _a;
    if (typeof beacon === 'string'
        || (typeof beacon === 'object'
            && ((_a = beacon.baseInfo) === null || _a === void 0 ? void 0 : _a.appkey)
            && beacon.onUserAction
            && beacon.onDirectUserAction)) {
        return true;
    }
};
/**
 * 大同上报数据格式化
 * @description 上报参数包括公共参数、页面信息、业务参数
 * @params {Context} context        上报上下文
 * @params {string}  [key='udf_kv'] 业务参数上报字段名
 */
var formatData = function (context, key) {
    var _a, _b;
    if (key === void 0) { key = 'udf_kv'; }
    if ([STANDARD_EVENTS.PGIN, STANDARD_EVENTS.PGOUT].includes(context.eventName)) {
        // 页面上报
        return __assign(__assign({}, context.publicParams), (_a = {}, _a[key] = JSON.stringify(__assign({}, context.pageParams)), _a));
    }
    return __assign(__assign({}, context.publicParams), (_b = {}, _b[key] = JSON.stringify(__assign({ cur_pg: __assign({}, context.pageParams) }, context.businessParams)), _b));
};
/**
 * 获取元素路径参数
 * @description 元素上报需要携带父元素参数，非打平模式，上报元素路径；打平模式合并参数上报
 * @param {object} node           上报节点
 * @param {number} [formatMode=1] 元素上报路径格式，0 - 非打平模式，1 - 打平模式
 * @param {object} [params={}]    元素参数，手动上报节点为父元素节点，需要传入元素自身参数
 */
var getElementPath = function (node, formatMode, params) {
    var _a;
    if (formatMode === void 0) { formatMode = 1; }
    if (params === void 0) { params = {}; }
    var elementPath = params.eid ? [params.eid] : [];
    var elementParams = params.eid ? [params] : [];
    var businessParams = params;
    var parent = node;
    while (parent) {
        var eid = (_a = parent.data) === null || _a === void 0 ? void 0 : _a.eid;
        if (eid) {
            if (formatMode) {
                // 打平模式
                businessParams = __assign(__assign({ eid: eid }, parent.data.params), businessParams);
            }
            else {
                // 非打平模式
                elementPath.push(eid);
                elementParams.push(__assign({ eid: eid }, parent.data.params));
            }
        }
        parent = parent.parent;
    }
    return formatMode
        ? businessParams
        : {
            element_path: elementPath,
            element_params: elementParams,
        };
};
/**
 * 参数重命名
 * @description 公参中部分参数和 udf_kv 中参数需要同步，方便解析 (ˉ▽ˉ；)...
 * udf_kv 内层参数不需要以 `dt` 开头，外层以 `dt` 开头
 * @param {object} obj 需要修改的对象
 */
var renameParams = function (obj) {
    if (!obj || Object.prototype.toString.call(obj) !== '[object Object]')
        return {};
    return Object.entries(obj).reduce(function (res, itemArr) {
        var _a;
        var key = itemArr[0].substring(3);
        return Object.assign(res, (_a = {},
            _a[key] = itemArr[1],
            _a));
    }, {});
};
/**
 * 计算元素结束曝光参数
 * @description 手动上报元素没有生成上报节点，简单计算参数
 */
var calculateImpEndParams = function (element) {
    if (!element)
        return {};
    var elementArea = element.scrollWidth * element.scrollHeight; // 元素面积
    var eleImpArea = (element.scrollLeft + element.clientWidth)
        * (element.scrollTop + element.clientHeight);
    var impRate = elementArea ? Math.min(eleImpArea / elementArea, 1) : 0; // 曝光周期内最大曝光比例
    var showTime = element.showTime;
    return {
        dt_element_area: elementArea.toFixed(2),
        dt_ele_imp_area: eleImpArea.toFixed(2),
        dt_element_lvtm: showTime ? Date.now() - showTime : 0,
        dt_ele_imp_rate: impRate.toFixed(2),
    };
};
/**
 * 检测 VR 上报
 * @description 旧 VR 上报必须在 `body` 上加上 `_eid` 属性，利用这个检测是否存在 VR 上报，
 * 如果大同和 VR 上报同时存在，提示用户迁移 VR 上报，避免同时上报导致的页面性能开销等问题
 */
var detectVideoReport = function () {
    var _a;
    var hasVideoReporter = (_a = document === null || document === void 0 ? void 0 : document.body) === null || _a === void 0 ? void 0 : _a.hasAttribute('_eid');
    if (hasVideoReporter) {
        console.error('[universalReport] 大同上报和 VR 上报不能同时初始化，请尽快改造 VR 上报，'
            + '参考文档：http://v.oa.com/universal-report/vr.html');
    }
};
/**
 * 终端相关信息
 * @description 根据userAgent获取终端相关信息
 */
var CLIENT_INFO = new UAparser(navigator.userAgent).getResult();

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var beacon_web_min = createCommonjsModule(function (module, exports) {
!function(t,e){module.exports=e();}(commonjsGlobal,(function(){var t=function(e,n){return (t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e;}||function(t,e){for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);})(e,n)};var e=function(){return (e=Object.assign||function(t){for(var e,n=1,r=arguments.length;n<r;n++)for(var o in e=arguments[n])Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t}).apply(this,arguments)};function n(t,e,n,r){return new(n||(n=Promise))((function(o,i){function s(t){try{u(r.next(t));}catch(t){i(t);}}function a(t){try{u(r.throw(t));}catch(t){i(t);}}function u(t){var e;t.done?o(t.value):(e=t.value,e instanceof n?e:new n((function(t){t(e);}))).then(s,a);}u((r=r.apply(t,e||[])).next());}))}function r(t,e){var n,r,o,i,s={label:0,sent:function(){if(1&o[0])throw o[1];return o[1]},trys:[],ops:[]};return i={next:a(0),throw:a(1),return:a(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function a(i){return function(a){return function(i){if(n)throw new TypeError("Generator is already executing.");for(;s;)try{if(n=1,r&&(o=2&i[0]?r.return:i[0]?r.throw||((o=r.return)&&o.call(r),0):r.next)&&!(o=o.call(r,i[1])).done)return o;switch(r=0,o&&(i=[2&i[0],o.value]),i[0]){case 0:case 1:o=i;break;case 4:return s.label++,{value:i[1],done:!1};case 5:s.label++,r=i[1],i=[0];continue;case 7:i=s.ops.pop(),s.trys.pop();continue;default:if(!(o=s.trys,(o=o.length>0&&o[o.length-1])||6!==i[0]&&2!==i[0])){s=0;continue}if(3===i[0]&&(!o||i[1]>o[0]&&i[1]<o[3])){s.label=i[1];break}if(6===i[0]&&s.label<o[1]){s.label=o[1],o=i;break}if(o&&s.label<o[2]){s.label=o[2],s.ops.push(i);break}o[2]&&s.ops.pop(),s.trys.pop();continue}i=e.call(t,s);}catch(t){i=[6,t],r=0;}finally{n=o=0;}if(5&i[0])throw i[1];return {value:i[0]?i[1]:void 0,done:!0}}([i,a])}}}var o="__BEACON_deviceId",i="last_report_time",s="sending_event_ids",a="beacon_config",u="beacon_config_request_time",c=function(){function t(){var t=this;this.emit=function(e,n){if(t){var r,o=t.__EventsList[e];if(null==o?void 0:o.length){o=o.slice();for(var i=0;i<o.length;i++){r=o[i];try{var s=r.callback.apply(t,[n]);if(1===r.type&&t.remove(e,r.callback),!1===s)break}catch(t){throw t}}}return t}},this.__EventsList={};}return t.prototype.indexOf=function(t,e){for(var n=0;n<t.length;n++)if(t[n].callback===e)return n;return -1},t.prototype.on=function(t,e,n){if(void 0===n&&(n=0),this){var r=this.__EventsList[t];if(r||(r=this.__EventsList[t]=[]),-1===this.indexOf(r,e)){var o={name:t,type:n||0,callback:e};return r.push(o),this}return this}},t.prototype.one=function(t,e){this.on(t,e,1);},t.prototype.remove=function(t,e){if(this){var n=this.__EventsList[t];if(!n)return null;if(!e){try{delete this.__EventsList[t];}catch(t){}return null}if(n.length){var r=this.indexOf(n,e);n.splice(r,1);}return this}},t}();function l(t,e){for(var n={},r=0,o=Object.keys(t);r<o.length;r++){var i=o[r],s=t[i];if("string"==typeof s)n[p(i)]=p(s);else {if(e)throw new Error("value mast be string  !!!!");n[p(String(i))]=p(String(s));}}return n}function p(t){if("string"!=typeof t)return t;try{return t.replace(new RegExp("\\|","g"),"%7C").replace(new RegExp("\\&","g"),"%26").replace(new RegExp("\\=","g"),"%3D").replace(new RegExp("\\+","g"),"%2B")}catch(t){return ""}}function f(t){return String(t.A99)+String(t.A100)}var h=function(){};var d=function(){function t(t){var n=this;this.lifeCycle=new c,this.uploadJobQueue=[],this.additionalParams={},this.delayTime=0,this._normalLogPipeline=function(t){if(!t||!t.reduce||!t.length)throw new TypeError("createPipeline 方法需要传入至少有一个 pipe 的数组");return 1===t.length?function(e,n){t[0](e,n||h);}:t.reduce((function(t,e){return function(n,r){return void 0===r&&(r=h),t(n,(function(t){return null==e?void 0:e(t,r)}))}}))}([function(t){n.send({url:n.strategy.getUploadUrl(),data:t,method:"post",contentType:"application/json;charset=UTF-8"},(function(){var e=n.config.onReportSuccess;"function"==typeof e&&e(JSON.stringify(t.events));}),(function(){var e=n.config.onReportFail;"function"==typeof e&&e(JSON.stringify(t.events));}));}]),function(t,e){if(!t)throw e instanceof Error?e:new Error(e)}(Boolean(t.appkey),"appkey must be initial"),this.config=e({},t);}return t.prototype.onUserAction=function(t,e){this.preReport(t,e,!1);},t.prototype.onDirectUserAction=function(t,e){this.preReport(t,e,!0);},t.prototype.preReport=function(t,e,n){t?this.strategy.isEventUpOnOff()&&(this.strategy.isBlackEvent(t)||this.strategy.isSampleEvent(t)||this.onReport(t,e,n)):this.errorReport.reportError("602"," no eventCode");},t.prototype.addAdditionalParams=function(t){for(var e=0,n=Object.keys(t);e<n.length;e++){var r=n[e];this.additionalParams[r]=t[r];}},t.prototype.setChannelId=function(t){this.commonInfo.channelID=String(t);},t.prototype.setOpenId=function(t){this.commonInfo.openid=String(t);},t.prototype.setUnionid=function(t){this.commonInfo.unid=String(t);},t.prototype.getDeviceId=function(){return this.commonInfo.deviceId},t.prototype.getCommonInfo=function(){return this.commonInfo},t.prototype.removeSendingId=function(t){try{var e=JSON.parse(this.storage.getItem(s)),n=e.indexOf(t);-1!=n&&(e.splice(n,1),this.storage.setItem(s,JSON.stringify(e)));}catch(t){}},t}(),v=function(){function t(t,e,n,r){this.requestParams={},this.network=r,this.requestParams.attaid="00400014144",this.requestParams.token="6478159937",this.requestParams.product_id=t.appkey,this.requestParams.platform=n,this.requestParams.uin=e.deviceId,this.requestParams.model="",this.requestParams.os=n,this.requestParams.app_version=t.appVersion,this.requestParams.sdk_version=e.sdkVersion,this.requestParams.error_stack="";}return t.prototype.reportError=function(t,e){this.requestParams._dc=Math.random(),this.requestParams.error_msg=e,this.requestParams.error_code=t,this.network.get("https://h.trace.qq.com/kv",{params:this.requestParams}).catch((function(t){}));},t}(),y=function(){function t(t,e,n,r){this.strategy={isEventUpOnOff:!0,httpsUploadUrl:"https://otheve.beacon.qq.com/analytics/v2_upload",requestInterval:30,blacklist:[],samplelist:[]},this.realSample={},this.appkey="",this.appkey=t.appkey,this.storage=n;try{var o=JSON.parse(this.storage.getItem(a));o&&this.processData(o);}catch(t){}this.needRequestConfig()&&this.requestConfig(t.appVersion,e,r);}return t.prototype.requestConfig=function(t,e,n){var r=this;this.storage.setItem(u,Date.now().toString()),n.post("https://oth.str.beacon.qq.com/trpc.beacon.configserver.BeaconConfigService/QueryConfig",{platformId:"undefined"==typeof wx?"3":"4",mainAppKey:this.appkey,appVersion:t,sdkVersion:e.sdkVersion,osVersion:e.userAgent,model:"",packageName:"",params:{A3:e.deviceId}}).then((function(t){if(0==t.data.ret)try{var e=JSON.parse(t.data.beaconConfig);e&&(r.processData(e),r.storage.setItem(a,t.data.beaconConfig));}catch(t){}else r.processData(null),r.storage.setItem(a,"");})).catch((function(t){}));},t.prototype.processData=function(t){var e,n,r,o,i;this.strategy.isEventUpOnOff=null!==(e=null==t?void 0:t.isEventUpOnOff)&&void 0!==e?e:this.strategy.isEventUpOnOff,this.strategy.httpsUploadUrl=null!==(n=null==t?void 0:t.httpsUploadUrl)&&void 0!==n?n:this.strategy.httpsUploadUrl,this.strategy.requestInterval=null!==(r=null==t?void 0:t.requestInterval)&&void 0!==r?r:this.strategy.requestInterval,this.strategy.blacklist=null!==(o=null==t?void 0:t.blacklist)&&void 0!==o?o:this.strategy.blacklist,this.strategy.samplelist=null!==(i=null==t?void 0:t.samplelist)&&void 0!==i?i:this.strategy.samplelist;for(var s=0,a=this.strategy.samplelist;s<a.length;s++){var u=a[s].split(",");2==u.length&&(this.realSample[u[0]]=u[1]);}},t.prototype.needRequestConfig=function(){var t=Number(this.storage.getItem(u));return Date.now()-t>60*this.strategy.requestInterval*1e3},t.prototype.getUploadUrl=function(){return this.strategy.httpsUploadUrl+"?appkey="+this.appkey},t.prototype.isBlackEvent=function(t){return -1!=this.strategy.blacklist.indexOf(t)},t.prototype.isEventUpOnOff=function(){return this.strategy.isEventUpOnOff},t.prototype.isSampleEvent=function(t){return !!Object.prototype.hasOwnProperty.call(this.realSample,t)&&this.realSample[t]<Math.floor(Math.random()*Math.floor(1e4))},t}(),g="session_storage_key",m=function(){function t(t,e,n){this.beacon=n,this.storage=t,this.duration=e,this.appkey=n.config.appkey;}return t.prototype.getSession=function(){var t=this.storage.getItem(g);if(!t)return this.createSession();var e=JSON.parse(t)||{sessionId:void 0,sessionStart:void 0};if(!e.sessionId||!e.sessionStart)return this.createSession();var n=Number(this.storage.getItem(i));return Date.now()-n>this.duration?this.createSession():{sessionId:e.sessionId,sessionStart:e.sessionStart}},t.prototype.createSession=function(){var t=Date.now(),e={sessionId:this.appkey+"_"+t.toString(),sessionStart:t};this.storage.setItem(g,JSON.stringify(e)),this.storage.setItem(i,t.toString());var n="is_new_user",r=this.storage.getItem(n);return this.beacon.onDirectUserAction("rqd_applaunched",{A21:r?"N":"Y"}),this.storage.setItem(n,JSON.stringify(!1)),e},t}();function w(){var t=navigator.userAgent,e=t.indexOf("compatible")>-1&&t.indexOf("MSIE")>-1,n=t.indexOf("Edge")>-1&&!e,r=t.indexOf("Trident")>-1&&t.indexOf("rv:11.0")>-1;if(e){new RegExp("MSIE (\\d+\\.\\d+);").test(t);var o=parseFloat(RegExp.$1);return 7==o?7:8==o?8:9==o?9:10==o?10:6}return n?-2:r?11:-1}var b=function(){return (b=Object.assign||function(t){for(var e,n=1,r=arguments.length;n<r;n++)for(var o in e=arguments[n])Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t}).apply(this,arguments)};function I(t){var e=new Image(1,1),n=b({attaid:"0f400053130",token:"6552374442",comps:"@tencent/tvf-indexed-db",version:"1.0.2",ua:navigator.userAgent,url:location.href,_dc:Math.random()},t),r=Object.keys(n).map((function(t){return t+"="+encodeURIComponent(n[t])})).join("&");e.src="https://h.trace.qq.com/kv?"+r;}var S,O,E,k,_,x=function(){function t(t,e){void 0===e&&(e={}),this.reportOptions={},this.config=t,this.reportOptions=e;}return t.canUseDB=function(){return !!(null===window||void 0===window?void 0:window.indexedDB)},t.prototype.openDB=function(){var e=this;return new Promise((function(n,r){if(!t.canUseDB())return r({message:"当前不支持 indexeddb"});var o=e.config,i=o.name,s=o.version,a=o.stores,u=indexedDB.open(i,s);u.onsuccess=function(){e.db=u.result,n(),I(b({result:1,func:"open",params:JSON.stringify(e.config)},e.reportOptions));},u.onerror=function(t){var n,o;r(t),I(b({result:0,func:"open",params:JSON.stringify(e.config),error_msg:null===(o=null===(n=t.target)||void 0===n?void 0:n.error)||void 0===o?void 0:o.message},e.reportOptions));},u.onupgradeneeded=function(){e.db=u.result;try{null==a||a.forEach((function(t){e.createStore(t);}));}catch(t){I(b({result:0,func:"open",params:JSON.stringify(e.config),error_msg:t.message},e.reportOptions)),r(t);}};}))},t.prototype.useStore=function(t){return this.storeName=t,this},t.prototype.deleteDB=function(){var t=this;return this.closeDB(),new Promise((function(e,n){var r=indexedDB.deleteDatabase(t.config.name);r.onsuccess=function(){return e()},r.onerror=n;}))},t.prototype.closeDB=function(){var t;null===(t=this.db)||void 0===t||t.close(),this.db=null;},t.prototype.getStoreCount=function(){var t=this;return new Promise((function(e,n){var r=t.getStore("readonly").count();r.onsuccess=function(){return e(r.result)},r.onerror=n;}))},t.prototype.clearStore=function(){var t=this;return new Promise((function(e,n){var r=t.getStore("readwrite").clear();r.onsuccess=function(){return e()},r.onerror=n;}))},t.prototype.add=function(t,e){var n=this;return new Promise((function(r,o){var i=n.getStore("readwrite").add(t,e);i.onsuccess=function(){r(i.result);},i.onerror=o;}))},t.prototype.put=function(t,e){var n=this;return new Promise((function(r,o){var i=n.getStore("readwrite").put(t,e);i.onsuccess=function(){r(i.result);},i.onerror=o;}))},t.prototype.getStoreAllData=function(){var t=this;return new Promise((function(e,n){var r=t.getStore("readonly").openCursor(),o=[];r.onsuccess=function(){var t;if(null===(t=r.result)||void 0===t?void 0:t.value){var n=r.result.value;o.push(n),r.result.continue();}else e(o);},r.onerror=n;}))},t.prototype.getDataRangeByIndex=function(t,e,n,r,o){var i=this;return new Promise((function(s,a){var u=i.getStore().index(t),c=IDBKeyRange.bound(e,n,r,o),l=[],p=u.openCursor(c);p.onsuccess=function(){var t;(null===(t=null==p?void 0:p.result)||void 0===t?void 0:t.value)?(l.push(null==p?void 0:p.result.value),null==p||p.result.continue()):s(l);},p.onerror=a;}))},t.prototype.removeDataByIndex=function(t,e,n,r,o){var i=this;return new Promise((function(s,a){var u=i.getStore("readwrite").index(t),c=IDBKeyRange.bound(e,n,r,o),l=u.openCursor(c),p=0;l.onsuccess=function(t){var e=t.target.result;e?(p+=1,e.delete(),e.continue()):s(p);},l.onerror=a;}))},t.prototype.createStore=function(t){var e=t.name,n=t.indexes,r=void 0===n?[]:n,o=t.options;if(this.db){this.db.objectStoreNames.contains(e)&&this.db.deleteObjectStore(e);var i=this.db.createObjectStore(e,o);r.forEach((function(t){i.createIndex(t.indexName,t.keyPath,t.options);}));}},t.prototype.getStore=function(t){var e;return void 0===t&&(t="readonly"),null===(e=this.db)||void 0===e?void 0:e.transaction(this.storeName,t).objectStore(this.storeName)},t}(),P="event_table_v3",D="eventId",j=function(){function t(t){this.isReady=!1,this.taskQueue=Promise.resolve(),this.db=new x({name:"Beacon_"+t+"_V3",version:1,stores:[{name:P,options:{keyPath:D},indexes:[{indexName:D,keyPath:D,options:{unique:!0}}]}]}),this.open();}return t.prototype.setItem=function(t,e){var n=this;return this.readyExec((function(){return n.db.add({eventId:t,value:e})}))},t.prototype.getItem=function(t){return n(this,void 0,void 0,(function(){var e=this;return r(this,(function(n){return [2,this.readyExec((function(){return e.db.getDataRangeByIndex(D,t,t)}))]}))}))},t.prototype.removeItem=function(t){var e=this;return this.readyExec((function(){return e.db.removeDataByIndex(D,t,t)}))},t.prototype.updateItem=function(t,e){var n=this;return this.readyExec((function(){return n.db.put({eventId:t,value:e})}))},t.prototype.iterate=function(t){var e=this;return this.readyExec((function(){return e.db.getStoreAllData().then((function(e){e.forEach((function(e){t(e.value);}));}))}))},t.prototype.open=function(){return n(this,void 0,void 0,(function(){var t=this;return r(this,(function(e){switch(e.label){case 0:return this.taskQueue=this.taskQueue.then((function(){return t.db.openDB()})),[4,this.taskQueue];case 1:return e.sent(),this.isReady=!0,this.db.useStore(P),[2]}}))}))},t.prototype.readyExec=function(t){return this.isReady?t():(this.taskQueue=this.taskQueue.then((function(){return t()})),this.taskQueue)},t}(),q=function(){function t(t){this.keyObject={},this.storage=t;}return t.prototype.removeItem=function(t){this.storage.removeItem(t),delete this.keyObject[t];},t.prototype.setItem=function(t,e){var n=JSON.stringify(e);this.storage.setItem(t,n),this.keyObject[t]=e;},t.prototype.iterate=function(t){for(var e=Object.keys(this.keyObject),n=0;n<e.length;n++){var r=this.storage.getItem(e[n]);t(JSON.parse(r));}},t}(),T=function(){function t(t,e){var n=w();this.store=n>0?new q(e):new j(t);}return t.prototype.insertEvent=function(t,e){return n(this,void 0,void 0,(function(){var n,o;return r(this,(function(r){switch(r.label){case 0:n=f(t.mapValue),r.label=1;case 1:return r.trys.push([1,3,,4]),[4,this.store.setItem(n,t)];case 2:return [2,r.sent()];case 3:return o=r.sent(),e&&e(o,t),[2,Promise.reject()];case 4:return [2]}}))}))},t.prototype.getEvents=function(){return n(this,void 0,void 0,(function(){var t;return r(this,(function(e){switch(e.label){case 0:t=[],e.label=1;case 1:return e.trys.push([1,3,,4]),[4,this.store.iterate((function(e){t.push(e);}))];case 2:return e.sent(),[2,Promise.all(t)];case 3:return e.sent(),[2,Promise.all(t)];case 4:return [2]}}))}))},t.prototype.removeEvent=function(t){return n(this,void 0,void 0,(function(){var e;return r(this,(function(n){switch(n.label){case 0:e=f(t.mapValue),n.label=1;case 1:return n.trys.push([1,3,,4]),[4,this.store.removeItem(e)];case 2:return [2,n.sent()];case 3:return n.sent(),[2,Promise.reject()];case 4:return [2]}}))}))},t}(),A=function(){return (A=Object.assign||function(t){for(var e,n=1,r=arguments.length;n<r;n++)for(var o in e=arguments[n])Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t}).apply(this,arguments)};function U(t){try{return decodeURIComponent(t.replace(/\+/g," "))}catch(t){return null}}function C(t,e){var n=[null,void 0,"",NaN].includes(t);if(e.isSkipEmpty&&n)return null;var r=!e.isSkipEmpty&&n?"":t;try{return e.encode?encodeURIComponent(r):r}catch(t){return null}}function R(t){var e=t.split("#"),n=e[0],r=e[1],o=void 0===r?"":r,i=n.split("?"),s=i[0],a=i[1],u=void 0===a?"":a,c=U(o),l=Object.create(null);return u.split("&").forEach((function(t){var e=t.split("="),n=e[0],r=e[1],o=void 0===r?"":r,i=U(n),s=U(o);null===i||null===s||""===i&&""===s||l[i]||(l[i]=s);})),{url:s,query:l,hash:c}}function N(t,e){void 0===e&&(e={encode:!0,isSkipEmpty:!1});var n=t.url,r=t.query,o=void 0===r?{}:r,i=t.hash,s=n.split("#"),a=s[0],u=s[1],c=void 0===u?"":u,l=a.split("?")[0],p=[],f=C(i||c,e),h=A(A({},R(n).query),o);return Object.keys(h).forEach((function(t){var n=C(t,e),r=C(h[t],e);null!==n&&null!==r&&p.push(n+"="+r);})),l+(p.length?"?"+p.join("&"):"")+(f?"#"+f:"")}function B(t,e){return new Promise((function(n,r){if(e&&document.querySelectorAll("script[data-tag="+e+"]").length)return n();var o=document.createElement("script"),i=A({type:"text/javascript",charset:"utf-8"},t);Object.keys(i).forEach((function(t){return function(t,e,n){if(t)return void 0===n?t.getAttribute(e):t.setAttribute(e,n)}(o,t,i[t])})),e&&(o.dataset.tag=e),o.onload=function(){return n()},o.onreadystatechange=function(){var t=o.readyState;["complete","loaded"].includes(t)&&(o.onreadystatechange=null,n());},o.onerror=r,document.body.appendChild(o);}))}!function(t){t[t.equal=0]="equal",t[t.low=-1]="low",t[t.high=1]="high";}(S||(S={})),O={func:"init",result:1},E=new Image(1,1),k=A({attaid:"0f400053130",token:"6552374442",comps:"@tencent/tvf-utils",version:"1.0.19",ua:navigator.userAgent,url:location.href,_dc:Math.random()},O),_=Object.keys(k).map((function(t){return t+"="+encodeURIComponent(k[t])})).join("&"),E.src="https://h.trace.qq.com/kv?"+_;var J=function(){return (J=Object.assign||function(t){for(var e,n=1,r=arguments.length;n<r;n++)for(var o in e=arguments[n])Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t}).apply(this,arguments)};function V(t,e,n,r){return new(n||(n=Promise))((function(o,i){function s(t){try{u(r.next(t));}catch(t){i(t);}}function a(t){try{u(r.throw(t));}catch(t){i(t);}}function u(t){var e;t.done?o(t.value):(e=t.value,e instanceof n?e:new n((function(t){t(e);}))).then(s,a);}u((r=r.apply(t,e||[])).next());}))}function M(t,e){var n,r,o,i,s={label:0,sent:function(){if(1&o[0])throw o[1];return o[1]},trys:[],ops:[]};return i={next:a(0),throw:a(1),return:a(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function a(i){return function(a){return function(i){if(n)throw new TypeError("Generator is already executing.");for(;s;)try{if(n=1,r&&(o=2&i[0]?r.return:i[0]?r.throw||((o=r.return)&&o.call(r),0):r.next)&&!(o=o.call(r,i[1])).done)return o;switch(r=0,o&&(i=[2&i[0],o.value]),i[0]){case 0:case 1:o=i;break;case 4:return s.label++,{value:i[1],done:!1};case 5:s.label++,r=i[1],i=[0];continue;case 7:i=s.ops.pop(),s.trys.pop();continue;default:if(!((o=(o=s.trys).length>0&&o[o.length-1])||6!==i[0]&&2!==i[0])){s=0;continue}if(3===i[0]&&(!o||i[1]>o[0]&&i[1]<o[3])){s.label=i[1];break}if(6===i[0]&&s.label<o[1]){s.label=o[1],o=i;break}if(o&&s.label<o[2]){s.label=o[2],s.ops.push(i);break}o[2]&&s.ops.pop(),s.trys.pop();continue}i=e.call(t,s);}catch(t){i=[6,t],r=0;}finally{n=o=0;}if(5&i[0])throw i[1];return {value:i[0]?i[1]:void 0,done:!0}}([i,a])}}}function L(t){var e=new Image(1,1),n=J({attaid:"0f400053130",token:"6552374442",comps:"@tencent/tvf-request",version:"1.1.4",ua:navigator.userAgent,url:location.href,_dc:Math.random()},t),r=Object.keys(n).map((function(t){return t+"="+encodeURIComponent(n[t])})).join("&");e.src="https://h.trace.qq.com/kv?"+r;}var K=/^([a-z][a-z\d+\-.]*:)?\/\//i,Q=Object.prototype.toString;function G(t){return V(this,void 0,void 0,(function(){var e;return M(this,(function(n){switch(n.label){case 0:if(window.fetch)return [2];n.label=1;case 1:return n.trys.push([1,3,,4]),[4,B({src:t})];case 2:return n.sent(),[3,4];case 3:throw e=n.sent(),L({func:"loadPolyfill",result:0,params:t,error_msg:e.message}),new Error("加载 polyfill "+t+" 失败: "+e.message);case 4:return [2]}}))}))}var z=function(){function t(){this.interceptors=[];}return t.prototype.use=function(t,e){return this.interceptors.push({resolved:t,rejected:e}),this.interceptors.length-1},t.prototype.traverse=function(t,e){void 0===e&&(e=!1);var n=Promise.resolve(t);return (e?Array.prototype.reduceRight:Array.prototype.reduce).call(this.interceptors,(function(t,e){if(e){var r=e.resolved,o=e.rejected;n=n.then(r,o);}return t}),""),n},t.prototype.eject=function(t){this.interceptors[t]&&(this.interceptors[t]=null);},t}(),F={defaults:{timeout:0,method:"GET",cache:"no-cache",mode:"cors",redirect:"follow",credentials:"same-origin"},headers:{common:{Accept:"application/json, text/plain, */*"},POST:{"Content-Type":"application/x-www-form-urlencoded"},PUT:{"Content-Type":"application/x-www-form-urlencoded"},PATCH:{"Content-Type":"application/x-www-form-urlencoded"}},baseURL:"",polyfillUrl:"https://vm.gtimg.cn/comps/script/fetch.min.js",interceptors:{request:new z,response:new z}};function H(t){return V(this,void 0,void 0,(function(){var e,n,r,o,i,s,a,u,c,l,p,f,h,d,v,y;return M(this,(function(g){switch(g.label){case 0:return e=F.baseURL,n=F.polyfillUrl,r=F.defaults,o=F.interceptors,[4,G(n)];case 1:return g.sent(),(i=J(J({},r),t)).headers||(i.headers=function(t){var e=F.headers[t]||{};return J(J({},F.headers.common),e)}(i.method)),[4,o.request.traverse(i,!0)];case 2:if((s=g.sent())instanceof Error)throw s;return s.url=function(t,e){return !t||K.test(e)?e:t.replace(/\/+$/,"")+"/"+e.replace(/^\/+/,"")}(e,s.url),a=s.url,u=s.timeout,c=s.params,l=s.method,p=["GET","DELETE","OPTIONS","HEAD"].includes(void 0===l?"GET":l)&&!!c,f=p?N({url:a,query:c}):a,h=[],u&&!s.signal&&(y=new Promise((function(t){d=setTimeout((function(){t(new Error("timeout"));}),u);})),h.push(y),v=new AbortController,s.signal=v.signal),h.push(fetch(f,s).catch((function(t){return t}))),[2,new Promise((function(t,e){Promise.race(h).then((function(t){return d&&clearTimeout(d),o.response.traverse(t)})).then((function(n){return n instanceof Error?(null==v||v.abort(),void e(n)):n.ok?t(n):void e(new Error(n.status+" "+n.statusText))}));}))]}}))}))}F.interceptors.request.use((function(t){return ["Accept","Content-Type"].forEach((function(e){return n=e,void((r=t.headers)&&Object.keys(r).forEach((function(t){t!==n&&t.toUpperCase()===n.toUpperCase()&&(r[n]=r[t],delete r[t]);})));var n,r;})),function(t){if("[object Object]"!==Q.call(t))return !1;var e=Object.getPrototypeOf(t);return null===e||e===Object.prototype}(t.body)&&(t.body=JSON.stringify(t.body),t.headers&&(t.headers["Content-Type"]="application/json;charset=utf-8")),t})),L({func:"init",result:1});var Y=function(){function t(t){F.interceptors.request.use((function(n){var r=n.url,o=n.method,i=n.body,s=i;if(t.onReportBeforeSend){var a=t.onReportBeforeSend({url:r,method:o,data:i});s=(null==a?void 0:a.data)||null;}if("GET"!==o&&!s)throw new Error("No data for sdk, cancel.");return e(e({},n),{body:s})}));}return t.prototype.get=function(t,o){return n(this,void 0,void 0,(function(){var n,i;return r(this,(function(r){switch(r.label){case 0:return [4,H(e({url:t},o))];case 1:return [4,(n=r.sent()).json()];case 2:return i=r.sent(),[2,Promise.resolve({data:i,status:n.status,statusText:n.statusText,headers:n.headers})]}}))}))},t.prototype.post=function(t,o,i){return n(this,void 0,void 0,(function(){var n,s;return r(this,(function(r){switch(r.label){case 0:return [4,H(e({url:t,body:o,method:"POST"},i))];case 1:return [4,(n=r.sent()).json()];case 2:return s=r.sent(),[2,Promise.resolve({data:s,status:n.status,statusText:n.statusText,headers:n.headers})]}}))}))},t}(),$=function(){function t(t){this.appkey=t;}return t.prototype.getItem=function(t){try{return window.localStorage.getItem(this.getStoreKey(t))}catch(t){return ""}},t.prototype.removeItem=function(t){try{window.localStorage.removeItem(this.getStoreKey(t));}catch(t){}},t.prototype.setItem=function(t,e){try{window.localStorage.setItem(this.getStoreKey(t),e);}catch(t){}},t.prototype.setSessionItem=function(t,e){try{window.sessionStorage.setItem(this.getStoreKey(t),e);}catch(t){}},t.prototype.getSessionItem=function(t){try{return window.sessionStorage.getItem(this.getStoreKey(t))}catch(t){return ""}},t.prototype.getStoreKey=function(t){return "__BEACON_"+this.appkey+"_"+t},t.prototype.createDeviceId=function(){try{var t=window.localStorage.getItem(o);return t||(t=function(t){for(var e="ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz0123456789",n="",r=0;r<t;r++)n+=e.charAt(Math.floor(Math.random()*e.length));return n}(32),window.localStorage.setItem(o,t)),t}catch(t){return ""}},t}(),W="logid_start",X="4.4.1-web";return function(n){function r(t){var e=n.call(this,t)||this;e.send=function(t,n,r){e.storage.setItem(i,Date.now().toString()),e.network.post(e.strategy.getUploadUrl(),t.data).then((function(r){var o;100==(null===(o=null==r?void 0:r.data)||void 0===o?void 0:o.result)?e.delayTime=1e3*r.data.delayTime:e.delayTime=0,n&&n(t.data),t.data.events.forEach((function(t){e.store.removeEvent(t).then((function(){e.removeSendingId(f(t.mapValue));}));}));})).catch((function(n){var o=t.data.events;e.errorReport.reportError(n.code?n.code.toString():"600",n.message),r&&r(t.data),o.forEach((function(t){e.store.insertEvent(t,(function(t,n){t&&e.errorReport.reportError("604","insertEvent fail!"),e.removeSendingId(f(n.mapValue));}));}));}));};var r=w();return e.isUnderIE8=r>0&&r<8,e.isUnderIE8||(e.isUnderIE=r>0,e.network=new Y(t),e.storage=new $(t.appkey),e.initCommonInfo(t),e.store=new T(t.appkey,e.storage),e.errorReport=new v(e.config,e.commonInfo,"web",e.network),e.strategy=new y(e.config,e.commonInfo,e.storage,e.network),e.logidStartTime=e.storage.getItem(W),e.logidStartTime||(e.logidStartTime=Date.now().toString(),e.storage.setItem(W,e.logidStartTime)),e.initSession(t),e.onDirectUserAction("rqd_js_init",{}),setTimeout((function(){return e.lifeCycle.emit("init")}),0),e.initDelayTime=t.delay?t.delay:1e3,e.cycleTask(e.initDelayTime)),e}return function(e,n){if("function"!=typeof n&&null!==n)throw new TypeError("Class extends value "+String(n)+" is not a constructor or null");function r(){this.constructor=e;}t(e,n),e.prototype=null===n?Object.create(n):(r.prototype=n.prototype,new r);}(r,n),r.prototype.initSession=function(t){var e=18e5;t.sessionDuration&&t.sessionDuration>3e4&&(e=t.sessionDuration),this.beaconSession=new m(this.storage,e,this);},r.prototype.initCommonInfo=function(t){var e=Number(this.storage.getItem(i));try{var n=JSON.parse(this.storage.getItem(s));(Date.now()-e>3e4||!n)&&this.storage.setItem(s,JSON.stringify([]));}catch(t){}var r=[window.screen.width,window.screen.height];window.devicePixelRatio&&r.push(window.devicePixelRatio),this.commonInfo={deviceId:this.storage.createDeviceId(),language:navigator&&navigator.language||"zh_CN",query:window.location.search,userAgent:navigator.userAgent,pixel:r.join("*"),channelID:t.channelID?String(t.channelID):"",openid:t.openid?String(t.openid):"",unid:t.unionid?String(t.unionid):"",sdkVersion:X},this.config.appVersion=t.versionCode?String(t.versionCode):"",this.config.strictMode=t.strictMode;},r.prototype.cycleTask=function(t){var e=this;setTimeout((function(){e.store.getEvents().then((function(t){var n=[],r=JSON.parse(e.storage.getItem(s));r||(r=[]),t&&t.forEach((function(t){var e=f(t.mapValue);-1==r.indexOf(e)&&(n.push(t),r.push(e));})),0!=n.length&&(e.storage.setItem(s,JSON.stringify(r)),e._normalLogPipeline(e.assembleData(n)));})).catch((function(t){})),e.cycleTask(0==e.delayTime?e.initDelayTime:e.delayTime);}),t);},r.prototype.onReport=function(t,e,n){var r=this;if(this.isUnderIE8)this.errorReport.reportError("601","UnderIE8");else {var o=this.generateData(t,e,n);if(n&&0==this.delayTime)this._normalLogPipeline(this.assembleData(o));else {var i=o.shift();i&&this.store.insertEvent(i,(function(t){t&&r.errorReport.reportError("604","insertEvent fail!");}));}}},r.prototype.onSendBeacon=function(t,e){if(this.isUnderIE)this.errorReport.reportError("605","UnderIE");else {var n=this.assembleData(this.generateData(t,e,!0));"function"==typeof navigator.sendBeacon&&navigator.sendBeacon(this.strategy.getUploadUrl(),JSON.stringify(n));}},r.prototype.generateData=function(t,n,r){var o=[],i="4.4.1-web_"+(r?"direct_log_id":"normal_log_id"),s=Number(this.storage.getItem(i));return s=s||1,n=e(e({},n),{A99:r?"Y":"N",A100:s.toString(),A72:X,A88:this.logidStartTime}),s++,this.storage.setItem(i,s.toString()),o.push({eventCode:t,eventTime:Date.now().toString(),mapValue:l(n,this.config.strictMode)}),o},r.prototype.assembleData=function(t){var n=this.beaconSession.getSession();return {appVersion:this.config.appVersion?p(this.config.appVersion):"",sdkId:"js",sdkVersion:X,mainAppKey:this.config.appkey,platformId:3,common:l(e(e({},this.additionalParams),{A2:this.commonInfo.deviceId,A8:this.commonInfo.openid,A12:this.commonInfo.language,A17:this.commonInfo.pixel,A23:this.commonInfo.channelID,A50:this.commonInfo.unid,A76:n.sessionId,A101:this.commonInfo.userAgent,A102:window.location.href,A104:document.referrer,A119:this.commonInfo.query}),!1),events:t}},r}(d)}));
});

var Beacon = /** @class */ (function () {
    function Beacon(options) {
        this.type = 'beacon';
        if (!isLegalBeacon(options.beacon)) {
            throw new Error("\n        [universalReport] beacon must be a beacon application appkey or a beacon instance");
        }
    }
    Beacon.prototype.init = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var _a;
            if (typeof options.beacon === 'object') {
                // 初始化传入灯塔实例直接使用
                _this.beacon = options.beacon;
                resolve();
            }
            else if (typeof options.beacon === 'string') {
                window.BeaconAction = (_a = window.BeaconAction) !== null && _a !== void 0 ? _a : beacon_web_min; // 优先使用已加载灯塔实例
                resolve(_this.initBeacon(options));
            }
            else {
                reject(new Error("\n          [universalReport] beacon must be a beacon application appkey or a beacon instance"));
            }
        });
    };
    Beacon.prototype.initBeacon = function (options) {
        var _a;
        try {
            this.beacon = new window.BeaconAction({
                appkey: options.beacon,
                versionCode: (_a = options.version) !== null && _a !== void 0 ? _a : '',
                delay: 1000,
                isDebug: options.debug,
                onReportFail: function (err) {
                    console.warn("[universalReport] Beacon report fail: " + err);
                },
            });
        }
        catch (err) {
            options === null || options === void 0 ? void 0 : options.beaconFailCallback({ err_message: err, result: 1, fail_case: 'beaconInitFail' });
        }
    };
    /**
     * onUserAction 会先存储上报, 等待一定时间合并上报
     * onDirectUserAction 会立即上报
     */
    Beacon.prototype.report = function (context) {
        if (!context.eventName)
            return;
        var params = formatData(context);
        if (context.isSendBeacon) { // 使用sendBeacon接口上报
            this.beacon.onSendBeacon(context.eventName, params);
            return;
        }
        if (~[STANDARD_EVENTS.PGIN, STANDARD_EVENTS.PGOUT].indexOf(context.eventName)
            && this.beacon.onDirectUserAction) {
            // 页面相关事件等重要数据使用 onDirectUserAction 上报
            this.beacon.onDirectUserAction(context.eventName, params);
        }
        else if (this.beacon.onUserAction) {
            // 其余事件使用 onUserAction 上报
            this.beacon.onUserAction(context.eventName, params);
        }
    };
    return Beacon;
}());
function beacon (options) {
    return new Beacon(options);
}

var NATIVE_SDK_VERSION_WITH_CALLBACK = 2100; // 终端大同支持callback版本
var REQUIRED_APP_VERSION = {
    qqvideo: {
        android: '8.3.40',
        ios: '8.3.60',
    },
};

var App = /** @class */ (function () {
    function App(options) {
        this.type = 'app';
        this.beaconReportPool = [];
        if (!isLegalBeacon(options.beacon)) {
            throw new Error("\n        [universalReport] beacon must be a beacon application appkey or a beacon instance");
        }
        this.appkey = typeof options.beacon === 'string'
            ? options.beacon : options.beacon.baseInfo.appkey;
        this.options = options;
        this.enableBeaconReportRetry = options.enableBeaconReportRetry;
        try {
            this.topWindow = window.top; // 访问最顶层window用于判断jsapi注入情况
        }
        catch (_a) {
            this.topWindow = window;
        }
    }
    App.prototype.init = function () {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function () {
            var _e, isSupport, _f;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0: return [4 /*yield*/, this.waitForDtJsReporterReady()];
                    case 1:
                        _g.sent(); // 等待jsapi加载完成
                        if (!((_b = (_a = this.topWindow) === null || _a === void 0 ? void 0 : _a.DtJsReporter) === null || _b === void 0 ? void 0 : _b.reportEvent)) { // 无reportEvent接口，降级为beacon
                            return [2 /*return*/, Promise.reject({ channel: 'beacon', reason: 'report_event_nil' })];
                        }
                        if (!!this.isAndroid) return [3 /*break*/, 3];
                        _e = this;
                        return [4 /*yield*/, this.getJsApiCallbackAccess()];
                    case 2:
                        _e.hasJsApiCallback = (_g.sent()) || false;
                        this.initFallbackChannel();
                        return [2 /*return*/, Promise.resolve()];
                    case 3:
                        isSupport = (_d = (_c = this.topWindow) === null || _c === void 0 ? void 0 : _c.DtJsReporter) === null || _d === void 0 ? void 0 : _d.isSupport;
                        if (!(isSupport === null || isSupport === void 0 ? void 0 : isSupport())) return [3 /*break*/, 5];
                        _f = this;
                        return [4 /*yield*/, this.getJsApiCallbackAccess()];
                    case 4:
                        _f.hasJsApiCallback = (_g.sent()) || false;
                        this.initFallbackChannel();
                        return [2 /*return*/, Promise.resolve()];
                    case 5: return [2 /*return*/, Promise.reject({ channel: 'beacon', reason: 'report_event_nil' })];
                }
            });
        });
    };
    App.prototype.initFallbackChannel = function () {
        this.initBeaconChannel(this.options); // 初始化灯塔通道用于补报与sendBeacon上报
        this.beaconChannelStatus = 'init';
    };
    App.prototype.getJsApiCallbackAccess = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var _a;
            setTimeout(function () {
                resolve(false);
            }, 500);
            (_a = _this.topWindow.DtJsReporter) === null || _a === void 0 ? void 0 : _a.getSdkVersion({
                onCallback: function (result) {
                    var data = result.data;
                    // 高于指定版本的nativesdk具有回调
                    resolve((data === null || data === void 0 ? void 0 : data.sdkVersion) > NATIVE_SDK_VERSION_WITH_CALLBACK);
                },
            });
        }).catch(function (error) {
            console.warn("[universalReport] " + error.message);
        });
    };
    App.prototype.fallbackReport = function (context) {
        if (this.beaconChannelStatus === 'ready') {
            this.beaconChannel.report(context); // 通过灯塔通道补报
            return;
        }
        this.beaconReportPool.push(context);
    };
    App.prototype.initBeaconChannel = function (options) {
        var _this = this;
        this.beaconChannel = beacon(options);
        return Promise.resolve(this.beaconChannel.init(options)).then(function () {
            _this.beaconChannelStatus = 'ready';
            var context = null;
            while (context = _this.beaconReportPool.shift()) {
                _this.beaconChannel.report(context);
            }
        })
            .catch(function (err) {
            var _a;
            console.error("[universalReport] beacon channel init error: \n        " + (((_a = err) === null || _a === void 0 ? void 0 : _a.message) || ''));
        });
    };
    App.prototype.waitForDtJsReporterReady = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var _a, _b;
            if ((_b = (_a = _this.topWindow) === null || _a === void 0 ? void 0 : _a.DtJsReporter) === null || _b === void 0 ? void 0 : _b.reportEvent) { // 具有reportEvent接口，jsapi已加载
                resolve();
            }
            else {
                var timer_1 = setTimeout(function () {
                    resolve();
                }, 1000);
                var handler_1 = function () {
                    _this.topWindow.document.removeEventListener('onDtJsReporterReady', handler_1);
                    clearTimeout(timer_1);
                    resolve();
                };
                _this.topWindow.document.addEventListener('onDtJsReporterReady', handler_1);
            }
        });
    };
    App.prototype.report = function (context) {
        var _this = this;
        var _a, _b;
        if (context.isSendBeacon && this.beaconChannelStatus === 'ready') { // 使用灯塔sendBeacon接口上报
            this.beaconChannel.report(context);
            return;
        }
        var reportEvent = (_b = (_a = this.topWindow) === null || _a === void 0 ? void 0 : _a.DtJsReporter) === null || _b === void 0 ? void 0 : _b.reportEvent;
        if (reportEvent) {
            var params = formatData(context);
            var timer_2;
            if (this.hasJsApiCallback) {
                timer_2 = setTimeout(function () {
                    var _a;
                    _this.enableBeaconReportRetry && _this.fallbackReport(context);
                    timer_2 = null;
                    (_a = _this.options) === null || _a === void 0 ? void 0 : _a.jsApiReportCallback({
                        code: '504',
                        msg: 'timeout',
                        step: 1,
                        event_type: context.eventName,
                    });
                }, 1000); // 超时后通过灯塔补报
            }
            reportEvent({
                params: params,
                eventId: context.eventName,
                appKey: this.appkey,
                onCallback: function (result) {
                    var _a;
                    if (!timer_2)
                        return;
                    clearTimeout(timer_2);
                    var ret = result.ret, msg = result.msg;
                    if (ret !== '200' && _this.enableBeaconReportRetry) { // jsapi上报失败，通过灯塔补报
                        _this.fallbackReport(context);
                    }
                    (_a = _this.options) === null || _a === void 0 ? void 0 : _a.jsApiReportCallback({
                        code: ret,
                        msg: msg,
                        step: 1,
                        event_type: context.eventName,
                    });
                },
            });
        }
    };
    return App;
}());
function app (options) {
    return new App(options);
}

/**
 * 写入 cookie
 */
var setCookie = function (key, value, expire, domain, path) {
    var sExpires = '';
    var type = typeof expire;
    if (type === 'string') {
        sExpires = "; expires=" + expire;
    }
    else if (expire instanceof Date) {
        sExpires = "; expires=" + expire.toUTCString();
    }
    else {
        var msWeek = 7 * 24 * 3600 * 1000;
        sExpires = "; expires=" + new Date(Date.now() + msWeek).toUTCString();
    }
    var $domain = domain || location.hostname;
    var $path = path || '/';
    document.cookie = [
        key, '=', escape(value), sExpires, ';domain=', $domain, ';path=', $path
    ]
        .join('');
};
/**
 * 获取 cookie
 */
var getCookie = function (key) {
    var cookies = {};
    var cookieStr = document.cookie.split(';');
    for (var i = 0, len = cookieStr.length; i < len; i++) {
        var pair = cookieStr[i].replace(/^\s+/, '').split('=');
        var firstItem = pair[0], secondItem = pair[1];
        cookies[firstItem] = secondItem;
    }
    if (key) {
        return cookies[key];
    }
    return cookies;
};

/**
 * 简易版xhr post请求，待扩展callback
 */
function xhr(url, data) {
    var xhr = new XMLHttpRequest();
    xhr.open('POST', url, true);
    xhr.timeout = 10000;
    xhr.setRequestHeader('content-type', 'application/x-www-form-urlencoded');
    xhr.onreadystatechange = function readyStateChange() {
        if (xhr.readyState === 4) {
            if (xhr.status !== 200 && xhr.status !== 304) {
                console.error("[universalReport] report fail: \n          " + url + " => " + xhr.status + ": " + JSON.stringify(data));
            }
        }
    };
    xhr.ontimeout = function timeout() {
        xhr.abort();
        console.warn('[universalReport] report timeout');
    };
    xhr.send(data);
}

var Boss = /** @class */ (function () {
    function Boss(options) {
        this.options = options;
        this.type = 'boss';
        if (!options.bossSet) {
            throw new Error('[universalReport] please specify the bossSet');
        }
        this.bossSet = options.bossSet;
    }
    Boss.prototype.init = function () {
        if (!getCookie('txv_boss_uuid')) {
            var msYear = 365 * 24 * 3600 * 1000;
            setCookie('txv_boss_uuid', uuid(), new Date(Date.now() + msYear));
        }
    };
    Boss.prototype.report = function (context) {
        var boss = this.bossSet[context.eventName];
        if (!boss || !(this.isBeehive(boss) || this.isAtta(boss)))
            return;
        var _a = this.formatBossData(boss, context), url = _a.url, data = _a.data;
        xhr(url, data);
    };
    Boss.prototype.formatBossData = function (boss, context) {
        var formData = [];
        var dc = Math.random()
            .toString(36)
            .substr(2, 8);
        var url = '';
        if (this.isBeehive(boss)) {
            url = Boss.bossUrl + "?BossId=" + boss.BossId + "&Pwd=" + boss.Pwd + "&_dc=" + dc;
        }
        else if (this.isAtta(boss)) {
            url = Boss.attaUrl + "?attaid=" + boss.AttaId + "&token=" + boss.token + "&_dc=" + dc;
        }
        var data = __assign(__assign(__assign({}, boss), formatData(context, 'kv')), { dc: dc });
        Object.keys(data).forEach(function (key) {
            formData.push(key + "=" + encodeURIComponent(data[key]));
        });
        return {
            url: url,
            data: formData.join('&'),
        };
    };
    Boss.prototype.isBeehive = function (arg) {
        return arg.BossId !== undefined && arg.Pwd !== undefined;
    };
    Boss.prototype.isAtta = function (arg) {
        return arg.AttaId !== undefined && arg.token !== undefined;
    };
    Boss.bossUrl = 'https://btrace.qq.com/kvcollect';
    Boss.attaUrl = 'https://h.trace.qq.com/kv';
    return Boss;
}());
function boss (options) {
    return new Boss(options);
}

/**
 * 上报通道表
 */
var CHANNEL_MAP = { app: app, beacon: beacon, boss: boss };
var CHANNEL_KEYS = Object.keys(CHANNEL_MAP);
function instanceOfIChannel(object) {
    return 'report' in object;
}
function isLegalChannel(obj) {
    return ((typeof obj === 'string' && !!~CHANNEL_KEYS.indexOf(obj))
        || typeof obj === 'function'
        || (typeof obj === 'object' && instanceOfIChannel(obj)));
}

/**
 * TVF-modules @tencent/tvf-utils
 * v1.0.19
 * @author lomoliang 2021-06-15 17:19:36
 */

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var e=function(){return (e=Object.assign||function(e){for(var t,n=1,i=arguments.length;n<i;n++)for(var r in t=arguments[n])Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e}).apply(this,arguments)};var o;!function(e){e[e.equal=0]="equal",e[e.low=-1]="low",e[e.high=1]="high";}(o||(o={}));var N=/^v?(?:\d+)(\.(?:[x*]|\d+)(\.(?:[x*]|\d+)(\.(?:[x*]|\d+))?(?:-[\da-z-]+(?:\.[\da-z-]+)*)?(?:\+[\da-z-]+(?:\.[\da-z-]+)*)?)?)?$/i;function P(e){var t,n,i=e.replace(/^v/,"").replace(/\+.*$/,""),r=(n="-",-1===(t=i).indexOf(n)?t.length:t.indexOf(n)),o=i.substring(0,r).split(".");return o.push(i.substring(r+1)),o}function A(e){return isNaN(Number(e))?e:Number(e)}function D(e){if("string"!=typeof e)throw new TypeError("Invalid argument expected string");if(!N.test(e))throw new Error("Invalid argument not valid semver ('"+e+"' received)")}function I(e,t){[e,t].forEach(D);for(var n=P(e),i=P(t),r=0;r<Math.max(n.length-1,i.length-1);r++){var a=parseInt(n[r]||"0",10),s=parseInt(i[r]||"0",10);if(a>s)return o.high;if(s>a)return o.low}var u=n[n.length-1],d=i[i.length-1];if(u&&d){var l=u.split(".").map(A),c=d.split(".").map(A);for(r=0;r<Math.max(l.length,c.length);r++){if(void 0===l[r]||"string"==typeof c[r]&&"number"==typeof l[r])return -1;if(void 0===c[r]||"string"==typeof l[r]&&"number"==typeof c[r])return 1;if(l[r]>c[r])return o.high;if(c[r]>l[r])return o.low}}else if(u||d)return u?o.low:o.high;return o.equal}var Y,z,L,Z;Y={func:"init",result:1},z=new Image(1,1),L=e({attaid:"0f400053130",token:"6552374442",comps:"@tencent/tvf-utils",version:"1.0.19",ua:navigator.userAgent,url:location.href,_dc:Math.random()},Y),Z=Object.keys(L).map((function(e){return e+"="+encodeURIComponent(L[e])})).join("&"),z.src="https://h.trace.qq.com/kv?"+Z;

var chunkTask_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
// 防止改名
var chunk = chunkTask;
/**
 * 任务分片执行
 *
 * @export
 * @param {Options} options
 */
function chunkTask(options) {
    var _this = this;
    var process = options.process, taskParams = options.taskParams, context = options.context, interval = options.interval, onTick = options.onTick;
    if (taskParams.length === 0)
        return;
    // console.log('-------chunkTask--------')
    interval = interval || 12; // 16ms 是fps为60fps, 预留4ms render
    onTick = onTick || (function () { });
    var startTime = Date.now();
    var tickFunction = setTimeout;
    do {
        var item = taskParams.shift();
        process.call(context, item);
    } while (taskParams.length > 0 && Date.now() - startTime < interval);
    if (taskParams.length > 0) {
        tickFunction(function () {
            chunk.call(_this, options);
            onTick.call(_this, options);
        }, 0);
    }
}
exports.default = chunkTask;
});

unwrapExports(chunkTask_1);

var env = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
var isNode = false;
if (typeof process === 'object') {
    if (typeof process.versions === 'object') {
        if (typeof process.versions.node !== 'undefined') {
            isNode = true;
        }
    }
}
exports.isNodeEnv = isNode;
});

unwrapExports(env);
var env_1 = env.isNodeEnv;

var EventInfo = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
var Event = /** @class */ (function () {
    function Event() {
    }
    return Event;
}());
exports.Event = Event;
var Listener = /** @class */ (function () {
    function Listener(callback, detail) {
        this.callback = callback;
        this.detail = detail || new ListenerDetail();
    }
    return Listener;
}());
exports.Listener = Listener;
var ListenerDetail = /** @class */ (function () {
    function ListenerDetail(priority) {
        /**
         * 建议小于 10000, 大于10000内部使用
         *
         * @type {number}
         * @memberof ListenerDetail
         */
        this.priority = 1;
        this.priority = priority || 1;
    }
    return ListenerDetail;
}());
exports.ListenerDetail = ListenerDetail;
/**
 * 要支持有序广播可以通过 emitAsyncParalle, emitAsyncSeries 来实现
 * 内部实现有无必要?
 * 1. 有序广播是否增加了依赖
 * 2. 是否大大添加了复杂度
 * 3. 但事件的优先级不会
*/
});

unwrapExports(EventInfo);
var EventInfo_1 = EventInfo.Event;
var EventInfo_2 = EventInfo.Listener;
var EventInfo_3 = EventInfo.ListenerDetail;

var lib = createCommonjsModule(function (module, exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (commonjsGlobal && commonjsGlobal.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var chunkTask_1$1 = __importDefault(chunkTask_1);


var deferHookEventPrefix = '__defer__';
var PluggableInnerEvent;
(function (PluggableInnerEvent) {
    PluggableInnerEvent["PluggableReady"] = "PluggableReady";
    PluggableInnerEvent["PluggableHookError"] = "PluggableHookError";
})(PluggableInnerEvent = exports.PluggableInnerEvent || (exports.PluggableInnerEvent = {}));
var Pluggable = /** @class */ (function () {
    /**
     *Creates an instance of Pluggable.
     * @param {boolean} [isPure=false] 纯净的实例不会生成eventBus, 不会注册默认插件，只提供基础的发布订阅能力
     * @memberof Pluggable
     */
    function Pluggable(isPure) {
        var _this = this;
        if (isPure === void 0) { isPure = false; }
        this.isNodeEnv = env.isNodeEnv;
        this.eventEmitedMap = {};
        this.events = {
            __ALL_EVENTS__: []
        };
        !isPure && (this.eventBus = new Pluggable(true));
        this.onAllEvent(function (eventName, args) {
            if (!_this.eventEmitedMap[eventName]) {
                _this.eventEmitedMap[eventName] = args;
            }
        });
        !isPure && this.onSync(PluggableInnerEvent.PluggableReady, function () {
            Pluggable.defaultPlugins.forEach(function (plugin) { return _this.use(plugin); });
        });
        this.emit(PluggableInnerEvent.PluggableReady);
    }
    /**
     * 注册默认的插件，在实例化前调用
     */
    Pluggable.registerDefaultPlugin = function (plugins) {
        Pluggable.defaultPlugins = Pluggable.defaultPlugins.concat(plugins);
    };
    /**
     *注册插件
     */
    Pluggable.prototype.registerPlugin = function (plugin, context) {
        if (typeof plugin === 'function') {
            return plugin.call(this, this, context);
        }
        else if (plugin.install && typeof plugin.install === 'function') {
            return plugin.install.call(plugin, this, context);
        }
    };
    /**
     * alias of registerPlugin
     *
     * @memberof Pluggable
     */
    Pluggable.prototype.use = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this.registerPlugin.apply(this, args);
    };
    /**
     * 注册事件
     * @param {string} events 支持多事件， 用逗号隔开， 比如on('eventA,eventB', f)
     * @param {Function} callback
     * @memberof Pluggable
     */
    Pluggable.prototype.on = function (events, callback, detail) {
        this.onSync(events.split(',').map(function (event) { return deferHookEventPrefix + event; }).join(','), callback, detail);
    };
    Pluggable.prototype.onSync = function (events, callback, detail) {
        var _this = this;
        var eventList = events.split(',');
        eventList.forEach(function (event) {
            if (typeof _this.events[event] !== 'object') {
                _this.events[event] = [];
            }
            _this.events[event].push(new EventInfo.Listener(callback, detail));
            _this.events[event] // 可能有性能损失, 但无影响 
                .sort(function (a, b) { return b.detail.priority - a.detail.priority; });
        });
    };
    Pluggable.prototype.removeListener = function (event, callback) {
        var idx;
        if (typeof this.events[event] === 'object') {
            idx = this.events[event].findIndex(function (l) { return l.callback == callback; });
            if (idx > -1) {
                this.events[event].splice(idx, 1);
            }
        }
    };
    Pluggable.prototype.off = function (events, callback) {
        var _this = this;
        events.split(',').forEach(function (event) {
            _this.removeListener(event, callback);
            _this.removeListener(deferHookEventPrefix + event, callback);
        });
    };
    Pluggable.prototype.onAllEvent = function (callbak) {
        this.events.__ALL_EVENTS__.push(new EventInfo.Listener(callbak));
    };
    Pluggable.prototype.notifyEvent = function (event, args) {
        var _this = this;
        this.notifyDeferEvent(event, args);
        if (this.events.__ALL_EVENTS__.length > 0) {
            this.events.__ALL_EVENTS__.forEach(function (listener) { return listener.callback.call(_this, event, args); });
        }
    };
    Pluggable.prototype.notifyDeferEvent = function (event, args) {
        var _this = this;
        setTimeout(function () {
            event = deferHookEventPrefix + event;
            var i, listeners, length;
            function execListener(listener) {
                try {
                    listener.callback.apply(this, args);
                }
                catch (error) {
                    this._processError(error, event.replace(deferHookEventPrefix, ''));
                }
            }
            if (typeof _this.events[event] === 'object') {
                listeners = _this.events[event].slice();
                if (_this.isNodeEnv || Pluggable.disableChunk) {
                    length = listeners.length;
                    for (i = 0; i < length; i++) {
                        execListener.call(_this, listeners[i]);
                    }
                }
                else {
                    chunkTask_1$1.default({
                        process: execListener,
                        context: _this,
                        taskParams: listeners
                    });
                }
            }
        }, 0);
    };
    Pluggable.prototype._processError = function (error, event) {
        console.error(event + " error", error);
        this.emitAsyncParalle(PluggableInnerEvent.PluggableHookError, { from: event, error: error });
    };
    Pluggable.prototype.emit = function (event) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var i, listeners, length;
        this.notifyEvent(event, args);
        var results = [];
        if (typeof this.events[event] === 'object') {
            listeners = this.events[event].slice();
            length = listeners.length;
            for (i = 0; i < length; i++) {
                var result = void 0;
                try {
                    result = listeners[i].callback.apply(this, args);
                }
                catch (error) {
                    results.push(null);
                    this._processError(error, event);
                }
            }
        }
        return results;
    };
    /**
     *异步并行执行事件, onSync生效
     *
     * @param {*} event
     * @returns
     * @memberof Pluggable
     */
    Pluggable.prototype.emitAsyncParalle = function (event) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return __awaiter(this, void 0, void 0, function () {
            var listeners;
            var _this = this;
            return __generator(this, function (_a) {
                this.notifyEvent(event, args);
                if (typeof this.events[event] === 'object') {
                    listeners = this.events[event].slice();
                    return [2 /*return*/, Promise.all(listeners.map(function (listener) { return __awaiter(_this, void 0, void 0, function () {
                            var error_1;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _a.trys.push([0, 2, , 3]);
                                        return [4 /*yield*/, listener.callback.apply(this, args)];
                                    case 1: return [2 /*return*/, _a.sent()];
                                    case 2:
                                        error_1 = _a.sent();
                                        this._processError(error_1, event);
                                        return [2 /*return*/, null];
                                    case 3: return [2 /*return*/];
                                }
                            });
                        }); }))];
                }
                return [2 /*return*/];
            });
        });
    };
    /**
     * 异步串行执行事件, , onSync生效
     *
     * @param {*} event
     * @memberof Pluggable
     */
    Pluggable.prototype.emitAsyncSeries = function (event) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return __awaiter(this, void 0, void 0, function () {
            var listeners;
            var _this = this;
            return __generator(this, function (_a) {
                this.notifyEvent(event, args);
                if (typeof this.events[event] === 'object') {
                    listeners = this.events[event].slice();
                    return [2 /*return*/, listeners.reduce(function (chain, listener) { return __awaiter(_this, void 0, void 0, function () {
                            var _this = this;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, chain.then(function () { return listener.callback.apply(_this, args); }, function (err) {
                                            _this._processError(err, event);
                                            return listener.callback.apply(_this, args);
                                        })];
                                    case 1: return [2 /*return*/, _a.sent()];
                                }
                            });
                        }); }, Promise.resolve({}))];
                }
                return [2 /*return*/];
            });
        });
    };
    Pluggable.prototype.once = function (event, callback, detail) {
        this.on(event, function g() {
            this.off(event, g);
            callback.apply(this, arguments);
        }, detail);
    };
    Pluggable.prototype.onceSync = function (event, callback, detail) {
        this.onSync(event, function g() {
            this.off(event, g);
            callback.apply(this, arguments);
        }, detail);
    };
    /**
     * 当events列表中所有事件发生时触发回调， 只触发一次
     *
     * @param {string[]} events
     * @param {Function} callback
     * @param {ListenerDetail} [detail]
     * @memberof Pluggable
     */
    Pluggable.prototype.onEveryOnce = function (events, callback, detail) {
        var _this = this;
        Promise.all(events.map(function (event) { return new Promise(function (rs) { return _this.once(event, rs, detail); }); }))
            .then(function (datas) { return callback.call(_this, datas); });
    };
    /**
     * 当events列表中任意事件发生时触发回调, 只触发一次
     *
     * @param {string[]} events
     * @param {Function} callback
     * @param {ListenerDetail} [detail]
     * @memberof Pluggable
     */
    Pluggable.prototype.onAnyOnce = function (events, callback, detail) {
        var _this = this;
        Promise.race(events.map(function (event) { return new Promise(function (rs) { return _this.once(event, rs, detail); }); }))
            .then(function (datas) { return callback.call(_this, datas); });
    };
    /**
     * 注册可能已触发的事件， 用于Ready, beforeReady等只触发一次的事件Hook
     *
     * @param {string} event
     * @param {*} callback
     * @memberof Pluggable
     */
    Pluggable.prototype.onAlready = function (event, callback, detail) {
        var _this = this;
        if (this.eventEmitedMap[event]) {
            setTimeout(function () { callback.apply(_this, _this.eventEmitedMap[event]); }, 0);
        }
        else {
            this.once(event, callback, detail);
        }
    };
    Pluggable.prototype.onAlreadySync = function (event, callback, detail) {
        if (this.eventEmitedMap[event]) {
            callback.apply(this, this.eventEmitedMap[event]);
        }
        else {
            this.onceSync(event, callback, detail);
        }
    };
    Pluggable.prototype.destroy = function () {
        this.events = {
            __ALL_EVENTS__: []
        };
    };
    Pluggable.disableChunk = false;
    Pluggable.defaultPlugins = [];
    return Pluggable;
}());
exports.default = Pluggable;
});

var Pluggable = unwrapExports(lib);
var lib_1 = lib.PluggableInnerEvent;

var noop = function () { };
var ChannelManager = /** @class */ (function (_super) {
    __extends(ChannelManager, _super);
    function ChannelManager(options, scenePlat, sceneVersion) {
        if (scenePlat === void 0) { scenePlat = ''; }
        if (sceneVersion === void 0) { sceneVersion = ''; }
        var _a;
        var _this = _super.call(this) || this;
        _this.options = options;
        _this.scenePlat = scenePlat;
        _this.sceneVersion = sceneVersion;
        _this.channelReady = false;
        _this.pool = [];
        _this.hardwareOS = (_a = CLIENT_INFO.os.name) === null || _a === void 0 ? void 0 : _a.toLowerCase();
        _this.loadChannel(options);
        return _this;
    }
    ChannelManager.prototype.loadChannel = function (options) {
        this.setChannel(options);
        this.initChannel(options);
    };
    /**
     * 设置上报通道
     */
    ChannelManager.prototype.setChannel = function (options) {
        var _a = options.channel, channel = _a === void 0 ? 'app' : _a;
        // 腾讯视频内根据终端版本判断是否强制走js上报
        if (this.scenePlat === 'qqvideo'
            && channel === 'app'
            && this.isLowerThanRequiredVersion()) {
            channel = 'beacon';
        }
        if (~CHANNEL_KEYS.indexOf(channel)) {
            this.curChannel = CHANNEL_MAP[channel](options);
        }
        else if (typeof channel === 'function') {
            this.curChannel = channel(options);
        }
        else if (typeof channel === 'object') {
            this.curChannel = channel;
        }
        else {
            throw new Error("[universalReport] channel must be " + CHANNEL_KEYS
                .map(function (name) { return "\"" + name + "\""; })
                .join(', ') + ", a function or a object");
        }
        if (channel === 'app') {
            this.curChannel.isAndroid = this.hardwareOS === 'android';
        }
        if (!this.curChannel.report) {
            throw new Error('[universalReport] no report function found in channel');
        }
    };
    /**
     * 判断是否低于要求终端版本
     */
    ChannelManager.prototype.isLowerThanRequiredVersion = function () {
        var _a;
        var requiredVersion = (_a = REQUIRED_APP_VERSION[this.scenePlat]) === null || _a === void 0 ? void 0 : _a[this.hardwareOS];
        if (!requiredVersion)
            return false;
        return I(this.sceneVersion, requiredVersion) < 0;
    };
    /**
     * 通道初始化
     */
    ChannelManager.prototype.initChannel = function (options) {
        var _this = this;
        var _a;
        var channel = options.channel;
        Object.assign(options, {
            beaconFailCallback: function (context) {
                var failCase = context.fail_case;
                _this.emit(failCase, context);
            },
            jsApiReportCallback: function (context) {
                _this.emit('jsApiReport', context);
            },
        });
        this.curChannel.init = (_a = this.curChannel.init) !== null && _a !== void 0 ? _a : noop;
        Promise.resolve(this.curChannel.init(options))
            .then(function () {
            var _a;
            _this.emit('initChannel', {
                report_type: channel,
                result: 0,
                deviceId: ((_a = _this.curChannel.beacon) === null || _a === void 0 ? void 0 : _a.getDeviceId()) || '',
            });
            _this.curChannel.type === 'app' && _this.emit('jsApiReport', {
                step: 0,
                result: 'success',
            });
            // 当前通道加载成功，执行上报缓存队列
            _this.channelReady = true;
            var fn = null;
            while ((fn = _this.pool.shift())) {
                fn.call(_this);
            }
        })
            .catch(function (err) {
            var _a = err, channel = _a.channel, reason = _a.reason;
            _this.curChannel.type === 'app' && _this.emit('jsApiReport', {
                step: 0,
                result: 'fail',
                reason: reason,
            });
            if (isLegalChannel(channel)) {
                // 当前通道加载失败，切换其他合法通道类型，切换通道类型由当前通道 reject 指定
                _this.loadChannel(__assign(__assign({}, _this.options), { channel: channel }));
            }
            else {
                throw err;
            }
        })
            .catch(function (err) {
            var _a;
            console.error("[universalReport] channel init error: " + (((_a = err) === null || _a === void 0 ? void 0 : _a.message) || ''));
            _this.emit('initChannel', {
                report_type: channel,
                result: 1,
                err_message: err,
            });
        });
    };
    ChannelManager.prototype.report = function (_a) {
        var _this = this;
        var uid = _a.uid, restContext = __rest(_a, ["uid"]);
        var context = __assign({ uid: uid }, restContext);
        var reportFunc = function () {
            var _a;
            _this.curChannel.report(restContext);
            _this.emit('report', context);
            if (restContext.monitoringReport) {
                _this.emit('monitoringReport', {
                    pageParams: restContext === null || restContext === void 0 ? void 0 : restContext.pageParams,
                    deviceId: (_a = _this.curChannel.beacon) === null || _a === void 0 ? void 0 : _a.getDeviceId(),
                    reportType: _this.curChannel.type,
                    eventName: (restContext === null || restContext === void 0 ? void 0 : restContext.eventName) || '',
                    publicParams: restContext === null || restContext === void 0 ? void 0 : restContext.publicParams,
                });
            }
        };
        if (this.channelReady) {
            reportFunc();
        }
        else {
            this.pool.push(reportFunc);
        }
    };
    return ChannelManager;
}(Pluggable));

var virtualNode = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VirtualNode = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var VirtualNode = /*#__PURE__*/function () {
  _createClass(VirtualNode, null, [{
    key: "childIterator",
    value: function childIterator(node, callback) {
      var uncalc = [node];

      while (uncalc.length > 0) {
        var n = uncalc.shift();
        var res = callback(n);

        if (res === true) {
          return res;
        } else if (res === false) {
          continue;
        }

        if (n.children.length > 0) {
          uncalc = n.children.concat(uncalc);
        }
      }
    }
  }, {
    key: "parentIterator",
    value: function parentIterator(node, callback, data) {
      while (node) {
        data = callback(node, data);
        node = node.parent;
        if (typeof data === 'boolean' && data) break;
      }
    }
  }, {
    key: "parentReverseIterator",
    value: function parentReverseIterator(node, callback, data, until) {
      var nodeArr = [];

      while (node) {
        nodeArr.push(node);
        if (node === until) break;
        node = node.parent;
      }

      for (var i = nodeArr.length - 1; i >= 0; i--) {
        data = callback(nodeArr[i], data);
        if (typeof data === 'boolean' && data) break;
      }
    }
  }]);

  function VirtualNode(data) {
    _classCallCheck(this, VirtualNode);

    this.data = data || {};
    this.parent = null;
    this.children = [];
  }

  _createClass(VirtualNode, [{
    key: "setData",
    value: function setData(data) {
      Object.assign(this.data, data);
    }
  }, {
    key: "mapParent",
    value: function mapParent(cb) {
      var mapArray = [];

      if (this.parent) {
        var parent = this.parent;

        while (parent) {
          var retData = parent;

          if (typeof cb === 'function') {
            retData = cb(parent);
          }

          if (typeof retData === 'boolean' && retData) {
            break;
          } else {
            mapArray.push(retData);
          }

          parent = parent.parent;
        }
      }

      return mapArray;
    }
  }, {
    key: "index",
    value: function index() {
      var parent = this.parent;

      if (parent) {
        return parent.children.indexOf(this);
      }

      return 0;
    }
  }, {
    key: "append",
    value: function append(node) {
      if (node) {
        node.remove();
        node.parent = this;
        this.children.push(node);
      }
    }
  }, {
    key: "insert",
    value: function insert(idx, nodeArr) {
      var _this = this;

      if (nodeArr) {
        nodeArr.forEach(function (node) {
          node.remove();
          node.parent = _this;
        });
        Array.prototype.splice.apply(this.children, [idx, 0].concat(nodeArr));
      }
    }
  }, {
    key: "remove",
    value: function remove() {
      var parent = this.parent;
      this.parent = null;

      if (parent) {
        parent.children = parent.children.filter(function (node) {
          return node.parent === parent;
        });
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      if (this.children.length > 0) {
        var children = this.children;
        this.children = [];

        for (var i = 0, len = children.length; i < len; i++) {
          var node = children[i];
          node.parent = null;
        }
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.remove();
    }
  }]);

  return VirtualNode;
}();

exports.VirtualNode = VirtualNode;
});

unwrapExports(virtualNode);
var virtualNode_1 = virtualNode.VirtualNode;

var domHelper = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.domIterator = domIterator;
exports.domReverseIterator = domReverseIterator;
exports.parentIterator = parentIterator;
exports.parentReverseIterator = parentReverseIterator;
exports.onlyElements = onlyElements;

function domIterator(dom, callback, data, selfinvoke) {

  var nextData = callback(dom, data);
  var children = dom.childNodes;
  if (typeof nextData === 'boolean') return nextData;

  for (var i = 0, len = children.length; i < len; i++) {
    var nextDom = children[i];

    if (nextDom && nextDom.nodeType === 1) {
      var ret = domIterator(nextDom, callback, nextData);
      if (ret) return true;
    }
  }
}

function domReverseIterator(dom, callback, data, selfinvoke) {

  var nextData = callback(dom, data);
  var children = dom.childNodes;
  if (typeof nextData === 'boolean') return nextData;

  for (var i = children.length - 1; i >= 0; i--) {
    var nextDom = children[i];

    if (nextDom && nextDom.nodeType === 1) {
      var ret = domReverseIterator(nextDom, callback, nextData);
      if (ret) return true;
    }
  }
}

function parentIterator(dom, callback, data) {
  while (dom) {
    data = callback(dom, data);
    dom = dom.parentNode;
    if (typeof data === 'boolean' && data) break;
  }
}

function parentReverseIterator(dom, callback, data, until) {
  var domArr = [];

  while (dom) {
    domArr.push(dom);
    if (dom === until) break;
    dom = dom.parentNode;
  }

  for (var i = domArr.length - 1; i >= 0; i--) {
    data = callback(domArr[i], data);
    if (typeof data === 'boolean' && data) break;
  }
}

function onlyElements(list) {
  var newList = [];

  if (list && list[0]) {
    for (var i = list.length - 1; i >= 0; i--) {
      var node = list[i];

      if (node.nodeType === 1) {
        newList.unshift(node);
      }
    }
  }

  return newList;
}
});

unwrapExports(domHelper);
var domHelper_1 = domHelper.domIterator;
var domHelper_2 = domHelper.domReverseIterator;
var domHelper_3 = domHelper.parentIterator;
var domHelper_4 = domHelper.parentReverseIterator;
var domHelper_5 = domHelper.onlyElements;

var utils = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.genHash = genHash;
exports.debounce = debounce;
exports.supportIntersectionObserver = void 0;
var id = 0;

function genHash() {
  return new Date().getTime() + '' + id++;
}

function debounce(cb, time) {
  var handle = 0;
  time = time || 0;
  return function () {
    var self = this;
    var args = arguments;
    clearTimeout(handle);
    handle = setTimeout(function () {
      cb.apply(self, args);
    }, time);
  };
}

var supportIntersectionObserver = false ;
exports.supportIntersectionObserver = supportIntersectionObserver;
});

unwrapExports(utils);
var utils_1 = utils.genHash;
var utils_2 = utils.debounce;
var utils_3 = utils.supportIntersectionObserver;

var emitter = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Emitter = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Emitter = /*#__PURE__*/function () {
  function Emitter(context) {
    _classCallCheck(this, Emitter);

    this.context = context;
    this.events = {};
  }

  _createClass(Emitter, [{
    key: "on",
    value: function on(event, callback) {
      var cbs = this.events[event] || [];
      cbs.push(callback);
      this.events[event] = cbs;
      return this;
    }
  }, {
    key: "off",
    value: function off(event, callback) {
      if (typeof callback === 'undefined') {
        this.events[event] = [];
      } else {
        var cbs = this.events[event] || [];

        for (var i = cbs.length - 1; i >= 0; i--) {
          if (cbs[i] === callback) {
            cbs[i] = null;
            break;
          }
        }
      }

      return this;
    }
  }, {
    key: "emit",
    value: function emit(event, data, lazy) {
      var isLazy = true;
      var cbs = this.events[event] || [];

      if (typeof lazy === 'boolean') {
        isLazy = lazy;
      }

      for (var i = cbs.length - 1; i >= 0; i--) {
        var cb = cbs[i];

        if (typeof cb === 'function') {
          if (isLazy) {
            setTimeout(function (callback, context, data) {
              callback.call(context, data);
            }, 0, cb, this.context, data);
          } else {
            try {
              cb.call(this.context, data);
            } catch (e) {}
          }
        }
      }

      return this;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.events = {};
    }
  }, {
    key: "listeners",
    value: function listeners(eventName) {
      return this.events[eventName] || [];
    }
  }]);

  return Emitter;
}();

exports.Emitter = Emitter;
});

unwrapExports(emitter);
var emitter_1 = emitter.Emitter;

var virtualElNode = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWindowNode = getWindowNode;
exports.VirtualElNode = void 0;









function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var DOM_KEY = '__doid';
var store = {};
var autoId = 1;
var sessionId = Math.random().toString(36).substring(2);
var domNativeEvents = {
  click: true,
  scroll: true
};
var fastTriggeredEvents = {
  click: true
};
/**
 * todo 全局滚动要带动整个节点触发是否可视的事件
 * todo 父节点的遮盖逻辑如何处理calcVisible
 * 这是个特殊的节点，是window的虚拟节点，由于计算方式与其他节点不同，所以这里做特殊处理
 * scrollTop = window.scrollY
 * scrollLeft = window.scrollX
 * top = 0
 * left = 0
 * width = window.innerWidth
 * height = window.innerHeight
 * isScroller = true
 * tree = null
 * el = null
 * data = null
 * getScrollParent() == null
 */

var windowNode = null;

function getWindowNode() {
  if (windowNode) {
    return windowNode;
  }

  windowNode = new VirtualElNode();
  windowNode.scrollLeft = window.scrollX;
  windowNode.scrollTop = window.scrollY;
  windowNode.top = 0;
  windowNode.left = 0;
  windowNode.width = window.innerWidth;
  windowNode.height = window.innerHeight;
  windowNode.isScroller = true;
  windowNode.viewport = windowNode.rect = {
    top: 0,
    left: 0,
    right: window.innerWidth,
    bottom: window.innerHeight
  };

  windowNode.getScrollParent = function () {
    return null;
  };

  windowNode.attachScroller = function (dom, config) {
    dom = dom || window;
    config = config || {};
    var debounceTime = config.throttle;

    var scrollCallback = function scrollCallback() {
      var dx = dom.scrollX - windowNode.scrollLeft;
      var dy = dom.scrollY - windowNode.scrollTop;
      windowNode.scrollLeft = dom.scrollX;
      windowNode.scrollTop = dom.scrollY;
      windowNode.moveTree(dx, dy, true);
      windowNode.scrolling = false;
      windowNode.emitter.emit('scrollend');
    };

    if (debounceTime > 0) {
      var debouncer = (0, utils.debounce)(scrollCallback, debounceTime);

      scrollCallback = function scrollCallback() {
        windowNode.scrolling = true;
        debouncer();
      };
    }

    dom.addEventListener('scroll', scrollCallback);
  };

  window.addEventListener('resize', function () {
    windowNode.width = window.innerWidth;
    windowNode.height = window.innerHeight;
    windowNode.viewport = windowNode.rect = {
      top: 0,
      left: 0,
      right: window.innerWidth,
      bottom: window.innerHeight
    };
    windowNode.emit('resize');
  });
  return windowNode;
} // 支持IntersectionObserver的场景使用IntersectionObserver来判断曝光逻辑


var iobserver = null;

if (utils.supportIntersectionObserver) {
  iobserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var dom = entry.target;
      var node = VirtualElNode.getNode(dom);

      if (node && node.visible !== entry.isIntersecting) {
        node.visible = entry.isIntersecting;
        node.width = entry.boundingClientRect.width;
        node.height = entry.boundingClientRect.height;
        node.emit('visibilityChanged', entry.isIntersecting);
      }
    });
  }, {
    threshold: 0.0001
  });
}

var VirtualElNode = /*#__PURE__*/function (_VirtualNode) {
  _inherits(VirtualElNode, _VirtualNode);

  var _super = _createSuper(VirtualElNode);

  _createClass(VirtualElNode, null, [{
    key: "shouldBeNode",
    value: function shouldBeNode(el) {
      return el && el.dataset.v;
    }
  }, {
    key: "getNode",
    value: function getNode(el) {
      return store[el[DOM_KEY]];
    }
  }]);

  function VirtualElNode(tree, el, data) {
    var _this;

    _classCallCheck(this, VirtualElNode);

    _this = _super.call(this, data);
    _this.uid = 0;
    _this.emitter = new emitter.Emitter(_assertThisInitialized(_this));
    _this.unbinds = {};
    _this.width = 0;
    _this.height = 0;
    _this.effectiveWidth = 0; // 记录元素宽高值，避免元素 display: none 无法获取元素宽高

    _this.effectiveHeight = 0;
    _this.top = 0; // scrollTop = 0时，距离最近的一个scroller的top

    _this.left = 0; // scrollLeft = 0时，距离最近的一个scroller的left

    _this.scrollTop = 0;
    _this.scrollLeft = 0;
    _this.maxScrollTop = 0;
    _this.maxScrollLeft = 0;
    _this.maxIntersectArea = 0; // 单次曝光声明周期内最大相交面积

    _this.tree = tree;
    _this.el = el;
    _this.lazy = true; // 事件是否延迟触发

    _this.overflowHide = true; // overflow:hidden

    _this.isScroller = false; // 是否是滚动元素

    _this.scrolling = false; // 是否正在滚动中

    _this.delegates = {}; // 代理事件

    _this.pt = 0; // 计算绝对位置的中间量

    _this.pl = 0; // 计算绝对位置的中间量

    _this.visible = false;
    _this.rect = {
      // 当前节点的绝对位置
      top: 0,
      left: 0,
      right: 0,
      bottom: 0
    };
    _this.viewport = {
      // 当前节点所处的可视区域（叠加父节点的rect计算出来的）
      top: 0,
      left: 0,
      right: 0,
      bottom: 0
    };

    _this.attach(el);

    return _this;
  }

  _createClass(VirtualElNode, [{
    key: "attach",
    value: function attach(dom) {
      var firstAttach = false;
      this.detach();

      if (dom) {
        var id = dom[DOM_KEY];
        firstAttach = !id;
        this.el = dom;

        if (firstAttach) {
          id = sessionId + '_' + autoId++;
          this.uid = dom[DOM_KEY] = id;
          store[id] = this;
        }

        this.updateData(dom);
      }

      return firstAttach;
    }
  }, {
    key: "detach",
    value: function detach() {
      var dom = this.el;
      var unbinds = this.unbinds;
      this.unbinds = {};

      if (dom) {
        var id = dom[DOM_KEY];

        if (id) {
          store[id] = null;
        }
      }

      this.emitter.clear();
      Object.keys(unbinds).forEach(function (event) {
        try {
          unbinds[event]();
        } catch (e) {}
      });
    }
  }, {
    key: "updateData",
    value: function updateData(dom, attr) {
      dom = dom || this.el;

      if (dom) {
        if (attr) {
          //单个属性更新了
          var results = /data-([\w-]+)/.exec(attr);
          var key = results && results[1];

          if (key) {
            var data = {};
            data[key] = dom.dataset[key];
            this.setData(data);
          }
        } else {
          this.setData(dom.dataset);

          if (dom.dataset.scroller) {
            this.attachScroller(dom);
          }
        }
      }
    }
  }, {
    key: "attachScroller",
    value: function attachScroller(dom, config) {
      var _this2 = this;

      if (utils.supportIntersectionObserver) return;

      var scrollCallback = function scrollCallback() {
        var dx = dom.scrollLeft - _this2.scrollLeft;
        var dy = dom.scrollTop - _this2.scrollTop;
        _this2.scrollTop = dom.scrollTop;
        _this2.scrollLeft = dom.scrollLeft;
        _this2.maxScrollTop = Math.max(_this2.maxScrollTop, _this2.scrollTop);
        _this2.maxScrollLeft = Math.max(_this2.maxScrollLeft, _this2.scrollLeft);

        _this2.moveTree(dx, dy, true);

        _this2.scrolling = false;

        _this2.emitter.emit('scrollend');
      };

      config = config || {};
      var debounceTime = config.throttle;

      if (debounceTime > 0) {
        var debouncer = (0, utils.debounce)(scrollCallback, debounceTime);

        scrollCallback = function scrollCallback() {
          _this2.scrolling = true;
          debouncer();
        };
      }

      this.scrollTop = dom.scrollTop;
      this.scrollLeft = dom.scrollLeft;
      this.isScroller = true;
      this.on('scroll', scrollCallback);
    }
  }, {
    key: "getScrollParent",
    value: function getScrollParent() {
      var curNode = this.parent;

      while (curNode) {
        if (curNode.isScroller) {
          break;
        }

        curNode = curNode.parent;
      }

      return curNode || getWindowNode();
    }
  }, {
    key: "getScrollingParent",
    value: function getScrollingParent() {
      var parent = this.getScrollParent();

      while (parent && !parent.scrolling) {
        parent = parent.getScrollParent();
      }

      return parent && parent.scrolling ? parent : void 0;
    }
  }, {
    key: "getRect",
    value: function getRect() {
      return this.rect;
    }
  }, {
    key: "recalc",
    value: function recalc() {
      var _this3 = this;

      var el = this.el;

      if (el) {
        var scrollParent = this.getScrollParent();
        var scrollingParent = this.getScrollingParent();

        if (scrollingParent) {
          if (this.scrollEndHandle) {
            scrollingParent.emitter.off('scrollend', this.scrollEndHandle);
          }

          this.scrollEndHandle = function () {
            _this3.recalc();

            scrollingParent.emitter.off('scrollend', _this3.scrollEndHandle);
            _this3.scrollEndHandle = null;
          };

          scrollingParent.emitter.on('scrollend', this.scrollEndHandle);
          return;
        }

        var rect = el.getBoundingClientRect();
        var parentRect = scrollParent.getRect();
        var top = this.top = rect.top - parentRect.top + scrollParent.scrollTop;
        var left = this.left = rect.left - parentRect.left + scrollParent.scrollLeft;
        this.width = rect.width;
        this.height = rect.height;

        if (this.isScroller) {
          this.scrollTop = this.el.scrollTop;
          this.scrollLeft = this.el.scrollLeft;
          this.pt = scrollParent.pt + top - this.scrollTop;
          this.pl = scrollParent.pl + left - this.scrollLeft;
          this.effectiveWidth = el.scrollWidth || this.effectiveWidth;
          this.effectiveHeight = el.scrollHeight || this.effectiveHeight;
        } else {
          this.effectiveWidth = rect.width || this.effectiveWidth;
          this.effectiveHeight = rect.height || this.effectiveHeight;
        }

        var changed = this.rect.top !== rect.top || this.rect.left !== rect.left || this.rect.right !== rect.right || this.rect.bottom !== rect.bottom;
        this.rect.top = rect.top;
        this.rect.left = rect.left;
        this.rect.right = rect.right;
        this.rect.bottom = rect.bottom;
        this.calcViewPort();
        this.syncVisible();
        return changed;
      }
    }
  }, {
    key: "move",
    value: function move(dx, dy) {
      if (this.isScroller) {
        this.pt = this.pt - dy;
        this.pl = this.pl - dx;
      }

      var rect = this.rect;
      rect.top = rect.top - dy;
      rect.left = rect.left - dx;
      rect.right = rect.right - dx;
      rect.bottom = rect.bottom - dy;
      this.calcViewPort();
      this.syncVisible();
    }
  }, {
    key: "calcViewPort",
    value: function calcViewPort() {
      if (utils.supportIntersectionObserver) return;
      var rect = this.rect;
      var parent = this.parent || getWindowNode();
      var viewport = this.viewport;
      var parentViewport = parent.viewport;

      if (this.overflowHide) {
        viewport.top = Math.max(rect.top, parentViewport.top);
        viewport.left = Math.max(rect.left, parentViewport.left);
        viewport.right = Math.min(rect.right, parentViewport.right);
        viewport.bottom = Math.min(rect.bottom, parentViewport.bottom);
      } else {
        viewport.top = parentViewport.top;
        viewport.left = parentViewport.left;
        viewport.right = parentViewport.right;
        viewport.bottom = parentViewport.bottom;
      }
    }
  }, {
    key: "calcExposeArea",
    value: function calcExposeArea() {
      var rect = this.rect;
      var viewport = this.viewport;
      var intersectLeft = Math.max(rect.left, viewport.left);
      var intersectRight = Math.min(rect.right, viewport.right);
      var maxIntersectHeight = Math.max(viewport.bottom - rect.top, 0);
      return Math.max(maxIntersectHeight * (intersectRight - intersectLeft), 0);
    } // 更新节点信息

  }, {
    key: "updateNode",
    value: function updateNode() {
      this.maxScrollTop = this.scrollTop;
      this.maxScrollLeft = this.scrollLeft;
      this.effectiveWidth = this.width;
      this.effectiveHeight = this.height;
      this.maxIntersectArea = this.calcExposeArea();
    }
  }, {
    key: "syncVisible",
    value: function syncVisible() {
      if (utils.supportIntersectionObserver) return;
      var visible = this.calcVisible();

      if (visible !== this.visible) {
        this.visible = visible;

        if (visible) {
          // 每次曝光更新节点信息
          this.updateNode();
        }

        this.emitter.emit('visibilityChanged', visible);
        return true;
      }
    }
  }, {
    key: "moveTree",
    value: function moveTree(dx, dy, ignoreRoot) {
      var _this4 = this;

      if (this.el && !ignoreRoot) {
        // 被滚动元素不需要判断position
        var fixedDom;
        (0, domHelper.parentIterator)(this.el, function (parentDom) {
          // 遍历父元素检查position是否为fixed或sticky
          if (_this4.el !== parentDom) {
            // 若parent为reportNode则停止
            var parentNode = VirtualElNode.getNode(parentDom);

            if (parentNode) {
              return true;
            }
          }

          if (parentDom.nodeType !== 1) {
            // 元素为非Element元素时返回
            return true;
          }

          var style = getComputedStyle(parentDom);

          if (style.position === 'fixed' || style.position === 'sticky') {
            fixedDom = parentDom;
            return true;
          }

          return false;
        });

        if (fixedDom) {
          // position为fixed和sticky的不需要移动，直接return
          return;
        }
      }

      if (!ignoreRoot) {
        this.move(dx, dy);
      }

      for (var i = this.children.length - 1; i >= 0; i--) {
        this.children[i].moveTree(dx, dy);
      }
    }
  }, {
    key: "calcVisible",
    value: function calcVisible() {
      var rect = this.rect;
      var viewport = (this.parent || getWindowNode()).viewport; // 计算最大有效曝光面积

      var maxImpArea = Math.max(this.calcExposeArea(), this.maxIntersectArea || 0);
      this.maxIntersectArea = Math.max(maxImpArea, 0); // 默认露出一部分算visible

      return !(rect.left >= viewport.right || rect.right <= viewport.left || rect.top >= viewport.bottom || rect.bottom <= viewport.top);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var id = this.el[DOM_KEY];
      this.el[DOM_KEY] = null;
      store[id] = null;

      _get(_getPrototypeOf(VirtualElNode.prototype), "destroy", this).call(this);

      this.detach();
    }
  }, {
    key: "on",
    value: function on(event, callback) {
      var _this5 = this;

      var emitter = this.emitter;
      emitter.on(event, callback);

      if (domNativeEvents[event]) {
        // dom原生事件
        var unbinds = this.unbinds;
        var dom = this.el;

        if (!unbinds[event]) {
          if (fastTriggeredEvents[event]) {
            var root = this.tree.root;

            if (root && !root.delegates[event] && root.el) {
              var delegateHandle = root.delegates[event] = function (evt) {
                var el = evt.target;
                var clickNode = VirtualElNode.getNode(el);

                if (clickNode && !clickNode.lazy && !evt['_vn_id_' + clickNode.uid]) {
                  clickNode.emitter.emit(event, evt, clickNode.lazy);
                  evt['_vn_id_' + clickNode.uid] = true;
                }
              };

              root.el.addEventListener(event, delegateHandle, true);
            }
          }

          var handle = function handle(evt) {
            if (!evt['_vn_id_' + _this5.uid]) {
              emitter.emit(event, evt, _this5.lazy);
              evt['_vn_id_' + _this5.uid] = true;
            }
          };

          dom.addEventListener(event, handle, true);

          unbinds[event] = function () {
            dom.removeEventListener(event, handle);
          };
        }
      } else if (utils.supportIntersectionObserver && event === 'visibilityChanged') {
        var _unbinds = this.unbinds;

        if (!_unbinds[event]) {
          var _dom = this.el;
          iobserver.observe(_dom);

          _unbinds[event] = function () {
            iobserver.unobserve(_dom);
          };
        }
      }

      return this;
    }
  }, {
    key: "off",
    value: function off(event, callback) {
      this.emitter.off(event, callback);
      return this;
    }
  }, {
    key: "emit",
    value: function emit(event, data) {
      this.emitter.emit(event, data);
      return this;
    }
  }]);

  return VirtualElNode;
}(virtualNode.VirtualNode);

exports.VirtualElNode = VirtualElNode;
});

unwrapExports(virtualElNode);
var virtualElNode_1 = virtualElNode.getWindowNode;
var virtualElNode_2 = virtualElNode.VirtualElNode;

var virtualElTree = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VirtualElTree = exports.ATTR_MUT_HASH = exports.RECALC_HASH = exports.TMP_ID = void 0;









function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var TMP_ID = '__tmpid';
exports.TMP_ID = TMP_ID;
var RECALC_HASH = '__rechash';
exports.RECALC_HASH = RECALC_HASH;
var ATTR_MUT_HASH = '__atmhash';
exports.ATTR_MUT_HASH = ATTR_MUT_HASH;
var vTreeMap = new WeakMap(); // 虚拟树实例 map

var VirtualElTree = /*#__PURE__*/function () {
  _createClass(VirtualElTree, null, [{
    key: "getVtreeMap",
    value: function getVtreeMap() {
      return vTreeMap;
    }
  }]);

  function VirtualElTree(NodeClass) {
    _classCallCheck(this, VirtualElTree);

    this.NodeClass = NodeClass || virtualElNode.VirtualElNode;
    this.root = null;
    this.observer = null;
    this.rootDom = null;
  }
  /**
   * @method
   * @description 把虚拟树和实际的dom树关联起来
   * @param {Element} root 虚拟树所绑定的根节点
   */


  _createClass(VirtualElTree, [{
    key: "attach",
    value: function attach(root) {
      var _this = this;

      var self = this;
      /**
       * 关联包含两个部分
       * 1.初次关联需要遍历整个dom树生成对应的虚拟树
       * 2.dom树发生更新则利用MutationObserver更新对应的虚拟树
       */
      // Part.1

      var NodeClass = this.NodeClass;

      if (!NodeClass.shouldBeNode(root)) {
        throw new Error('root should be a node');
      }

      this.rootDom = root;
      this.root = NodeClass.getNode(root) || new NodeClass(this, root);
      self.update({
        el: root
      });
      self.reflow({
        el: root
      }); // Part.2

      this.observer = new MutationObserver(function (mutationsList) {
        var _this$mut = _this.mut(mutationsList),
            updateArr = _this$mut.updateArr,
            reflowArr = _this$mut.reflowArr;

        if (updateArr && updateArr.length > 0) {
          _this.update(updateArr);
        }

        if (reflowArr && reflowArr.length > 0) {
          _this.reflow(reflowArr);
        }
      });
      this.observer.observe(root, {
        characterData: true,
        attributes: true,
        childList: true,
        subtree: true
      });
    }
  }, {
    key: "detach",
    value: function detach() {
      VirtualElTree.getVtreeMap()["delete"](this.rootDom);
      this.remove({
        all: [this.root.el]
      }, Date.now());
    }
    /**
     * @description 更新虚拟树
     * @param {Element} domRoot 需要同步的dom根节点
     */

  }, {
    key: "update",
    value: function update(domRoot) {
      var _this2 = this;

      var updateHash = (0, utils.genHash)(); // 本次更新的时间戳，用来防止一次更新中某个dom触发了多次更新

      var domRoots = null;

      if (domRoot instanceof Array) {
        domRoots = domRoot;
      } else {
        domRoots = [domRoot];
      }

      domRoots.forEach(function (domConfig) {
        _this2[domConfig.action || 'add'](domConfig, updateHash);
      });
    }
    /**
     * @description 生成虚拟dom树
     * @param {Element} domRoot 生成虚拟树的根dom节点
     * @param {String} updateHash 某次同步的哈希值，防止重复更新，浪费资源
     * @return {Array} 无父节点的节点数组
     */

  }, {
    key: "createTree",
    value: function createTree(domRoot, updateHash, nodeParent) {
      var _this3 = this;

      var NodeClass = this.NodeClass;
      var noParentNodes = [];
      (0, domHelper.domIterator)(domRoot, function (dom, parent) {
        // 命中生成节点的条件则加入节点
        if (NodeClass.shouldBeNode(dom)) {
          var node = NodeClass.getNode(dom);

          if (node) {
            node.clear();
          } else {
            node = new NodeClass(_this3, dom);
          }

          if (parent) {
            parent.append(node);
          } else {
            noParentNodes.push(node);
          }

          return node;
        }

        return parent;
      }, nodeParent);
      return noParentNodes;
    }
  }, {
    key: "add",
    value: function add(domConfig, updateHash) {
      var NodeClass = this.NodeClass;
      var domRoot = domConfig.el;
      var noParentNodes = []; // 一次append多个节点的时候，这里可以考虑合并，即多次createTree，但只需查找一次距离最近的上一个虚拟节点的

      domConfig.all = domConfig.all || [domConfig.el];

      for (var i = 0, len = domConfig.all.length; i < len; i++) {
        var dom = domConfig.all[i];
        noParentNodes = noParentNodes.concat(this.createTree(dom, updateHash));
      }

      if (noParentNodes.length === 0) {
        return;
      } // 把生成的虚拟dom树插入到正确的位置
      // 查找距离最近的上一个虚拟节点


      var parentNode = null;
      var targetNode = null;
      (0, domHelper.parentIterator)(domRoot, function (parentDom) {
        if (domRoot !== parentDom) {
          parentNode = NodeClass.getNode(parentDom);

          if (parentNode) {
            return true;
          }
        }

        var lastNode = parentDom.previousElementSibling;

        while (lastNode) {
          (0, domHelper.domReverseIterator)(lastNode, function (dom) {
            targetNode = NodeClass.getNode(dom);
            if (targetNode) return true;
          });
          if (targetNode) break;
          lastNode = lastNode.previousElementSibling;
        }

        return !!targetNode;
      });

      if (!targetNode && parentNode) {
        parentNode.insert(0, noParentNodes);
      } else if (targetNode) {
        parentNode = parentNode || targetNode.parent;

        if (parentNode) {
          parentNode.insert(parentNode.children.indexOf(targetNode) + 1, noParentNodes);
        }
      }
    }
  }, {
    key: "remove",
    value: function remove(domConfig) {
      var NodeClass = this.NodeClass;
      domConfig.all = domConfig.all || [domConfig.el];

      for (var i = 0, len = domConfig.all.length; i < len; i++) {
        var domRoot = domConfig.all[i];
        (0, domHelper.domIterator)(domRoot, function (dom) {
          var node = NodeClass.getNode(dom);

          if (node) {
            node.destroy(); // return false;
          }
        });
      }
    }
  }, {
    key: "reflow",
    value: function reflow(domRoot) {
      var _this4 = this;

      if (utils.supportIntersectionObserver) return;
      /**
       * reflow 步骤如下
       * 1.更新domRoot的虚拟节点信息，若节点大小有变化，则更新domRoot同级之后的节点及其子节点的虚拟节点信息
       * 2.domRoot=domRoot.parentNode,并重复步骤1，直到domRoot对应的虚拟节点不再有父节点
       * 3.更新domRoot的所有子节点的虚拟节点信息
       */

      var domRoots = null;
      var updateHash = (0, utils.genHash)(); // 本次更新的时间戳，用来防止一次更新中某个dom触发了多次更新

      var NodeClass = this.NodeClass;

      if (domRoot instanceof Array) {
        domRoots = domRoot;
      } else {
        domRoots = [domRoot];
      } // let nodeArray = this.getNearReportNodes(domRoots);  // 需要变化的埋点节点列表


      var nearNode = domRoots.length === 1 && NodeClass.getNode(domRoots[0]);

      if (!nearNode) {
        var tmpIdMap = {};
        var autoId = 0;
        var idPrefix = Math.floor(10000 * Math.random()) + '';
        domRoots.forEach(function (domConfig) {
          var rDom = domConfig.el;
          var tmpId = idPrefix + autoId++;
          rDom[TMP_ID] = tmpId;
          tmpIdMap[tmpId] = domConfig;
        });
        var uncalc = [this.root.el];

        while (uncalc.length > 0) {
          var n = uncalc.shift();
          nearNode = NodeClass.getNode(n) || nearNode;

          if (tmpIdMap[n[TMP_ID]] && nearNode) {
            break;
          }

          if (n.children.length > 0) {
            uncalc = Array.from(n.children).concat(uncalc);
          }
        }
      }

      if (!nearNode) {
        return;
      } // Part.1 & Part.2


      virtualNode.VirtualNode.parentReverseIterator(nearNode, function (parentNode) {
        if (!parentNode.el || parentNode.el[RECALC_HASH] === updateHash) {
          return;
        }

        parentNode.el[RECALC_HASH] = updateHash;
        parentNode.recalc(); // let changed = parentNode.recalc();
        // nodeArray = nodeArray.filter((node) => node !== parentNode);
        // if (!changed && nodeArray.length === 0) {
        //   return;
        // }

        if (_this4.root === parentNode) {
          return;
        } // 更新后面兄弟元素的虚拟节点信息


        var sibling = parentNode.parent.children;
        var index = sibling.indexOf(parentNode);
        var len = sibling.length;

        while (index < len) {
          var nextNode = sibling[index];

          if (virtualNode.VirtualNode.childIterator(nextNode, function (node) {
            if (node.el[RECALC_HASH] !== updateHash) {
              node.el[RECALC_HASH] = updateHash;
              node.recalc(); // let changed = node.recalc();
              // nodeArray = nodeArray.filter((_node) => node !== _node);
              // if (!changed && nodeArray.length === 0) {
              //   return true;
              // }
            }
          })) {
            break;
          }

          index++;
        }
      }, null, this.root);

      virtualNode.VirtualNode.childIterator(nearNode, function (node) {
        if (nearNode === node) {
          return;
        }

        if (node.el[RECALC_HASH] !== updateHash) {
          node.el[RECALC_HASH] = updateHash;
          node.recalc();
        }
      });
    }
    /** 获取最接近待更新节点的埋点节点
     * 
     * @param {Array} nodeArray 待更新节点数组
     */

  }, {
    key: "getNearReportNodes",
    value: function getNearReportNodes(nodeArray) {
      var _this5 = this;

      return nodeArray.map(function (node) {
        var el = node.el;

        var reportNode = _this5.getSiblingReportNode(el);

        if (!reportNode) {
          (0, domHelper.parentIterator)(el, function (parentNode) {
            reportNode = _this5.getSiblingReportNode(parentNode);

            if (reportNode) {
              return true;
            }
          });
        }

        return reportNode || node;
      });
    }
    /** 获取同层中最接近待更新元素的埋点节点
     * 
     * @param {Element} el 待更新元素
     */

  }, {
    key: "getSiblingReportNode",
    value: function getSiblingReportNode(el) {
      var nextElement = el;
      var reportNode = null;

      while (nextElement) {
        reportNode = this.NodeClass.getNode(nextElement);
        if (reportNode) break;
        nextElement = nextElement.nextElementSibling;
      }

      return reportNode;
    }
  }, {
    key: "mut",
    value: function mut(mutationsList) {
      /**
       * 多个mutation要合并起来触发一次更新
       */
      var updateArr = [];
      var reflowArr = [];
      var reflowHash = (0, utils.genHash)();
      var NodeClass = this.NodeClass;

      for (var i = mutationsList.length - 1; i >= 0; i--) {
        var mutation = mutationsList[i];
        var changedDom = mutation.target;

        if (mutation.type === 'childList') {
          var addedNodes = (0, domHelper.onlyElements)(mutation.addedNodes);
          var removedNodes = (0, domHelper.onlyElements)(mutation.removedNodes);
          var previousElementSibling = mutation.previousSibling;

          if (addedNodes[0]) {
            updateArr.push({
              el: addedNodes[0],
              action: 'add',
              all: addedNodes
            });
          }

          if (removedNodes[0]) {
            updateArr.push({
              el: removedNodes[0],
              action: 'remove',
              all: removedNodes
            });
          } // mutation 返回的是previousSibling，这里要处理一下保证是Element


          if (previousElementSibling && previousElementSibling.nodeType !== 1) {
            previousElementSibling = previousElementSibling.previousElementSibling;
          }

          if (previousElementSibling) {
            var mayReflowElement = previousElementSibling.nextElementSibling;

            if (mayReflowElement) {
              reflowArr.push({
                el: mayReflowElement
              });
            } else {
              reflowArr.push({
                el: changedDom,
                ignoreChild: true
              });
            }
          } else {
            reflowArr.push({
              el: changedDom
            });
          }
        } else if (mutation.type === 'attributes') {
          /**
           * 属性变化分为几种
           * 1.class变化，认为引起样式的变化，触发reflow
           * 2.todo:暂定为data-v为虚拟节点必要属性，如果是此属性变化，要触发makeTree
           * 3.todo:其他属性变化认为是数据变化，更新虚拟节点数据即可
           */
          var attributeName = mutation.attributeName;

          if (changedDom[ATTR_MUT_HASH] !== reflowHash && (attributeName === 'class' || attributeName === 'style')) {
            changedDom[ATTR_MUT_HASH] = reflowHash;
            reflowArr.push({
              el: changedDom
            });
          }

          var node = NodeClass.getNode(changedDom);
          var shouldBeNode = NodeClass.shouldBeNode(changedDom);

          if (node && !shouldBeNode) ; else if (!node && shouldBeNode && changedDom[ATTR_MUT_HASH] !== reflowHash) {
            updateArr.push({
              el: changedDom,
              action: 'add',
              all: [changedDom]
            });
            changedDom[ATTR_MUT_HASH] = reflowHash;
            reflowArr.push({
              el: changedDom
            });
          }

          if (node) {
            node.updateData(changedDom, attributeName, reflowHash);
          }
        } else {
          if (changedDom.nodeType !== 1) {
            changedDom = changedDom.parentNode;
          }

          reflowArr.push({
            el: changedDom
          });
        }
      }

      return {
        updateArr: updateArr,
        reflowArr: reflowArr
      };
    }
  }]);

  return VirtualElTree;
}();

exports.VirtualElTree = VirtualElTree;
});

unwrapExports(virtualElTree);
var virtualElTree_1 = virtualElTree.VirtualElTree;
var virtualElTree_2 = virtualElTree.ATTR_MUT_HASH;
var virtualElTree_3 = virtualElTree.RECALC_HASH;
var virtualElTree_4 = virtualElTree.TMP_ID;

var virtualTree = {
  VirtualNode: virtualNode.VirtualNode,
  VirtualElTree: virtualElTree.VirtualElTree,
  VirtualElNode: virtualElNode.VirtualElNode,
  ATTR_MUT_HASH: virtualElTree.ATTR_MUT_HASH,
  getWindowNode: virtualElNode.getWindowNode,
  Emitter: emitter.Emitter,
  domHelper: domHelper
};

var utils$1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.kvStringToObject = kvStringToObject;
exports.objectToKvString = objectToKvString;
exports.isDom = isDom;

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function kvStringToObject(kvString) {
  var ret = {};

  if (typeof kvString === 'string') {
    var pairs = kvString.split('&');

    for (var i = 0, len = pairs.length; i < len; i++) {
      var pair = pairs[i];
      var splitRes = /^([^=]+)=(.*)$/.exec(pair);

      if (splitRes) {
        ret[splitRes[1]] = decodeURIComponent(splitRes[2]);
      }
    }
  }

  return ret;
}

function objectToKvString(object) {
  return Object.keys(object).map(function (key) {
    return key + '=' + encodeURIComponent(object[key]);
  }).join('&');
}

function isDom(dom) {
  return (typeof HTMLElement === "undefined" ? "undefined" : _typeof(HTMLElement)) === 'object' ? dom instanceof HTMLElement : dom && _typeof(dom) === 'object' && dom.nodeType === 1 && typeof dom.nodeName === 'string';
}
});

unwrapExports(utils$1);
var utils_1$1 = utils$1.kvStringToObject;
var utils_2$1 = utils$1.objectToKvString;
var utils_3$1 = utils$1.isDom;

var reportNode = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReportNode = void 0;





function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var globalConfigs = [];
var attrs = [];
var overflowHideAttr = 'data-ofhide';
var isScrollerAttr = 'data-scroller';
var lazyAttr = 'data-lazy';

var ReportNode = /*#__PURE__*/function (_VirtualElNode) {
  _inherits(ReportNode, _VirtualElNode);

  var _super = _createSuper(ReportNode);

  function ReportNode(tree, dom, data) {
    var _this;

    _classCallCheck(this, ReportNode);

    _this = _super.call(this, tree, dom, data);
    _this.lazy = false;
    _this.lastHash = 0;
    return _this;
  }

  _createClass(ReportNode, [{
    key: "updateData",
    value: function updateData(dom, attr, hash) {
      var _this2 = this;

      var attributes = dom.attributes;

      var handle = function handle(attrConfig) {
        var attribute = attributes[attrConfig.name];

        if (attribute) {
          return attrConfig.func.call(_this2, attribute.value, dom);
        }
      };

      globalConfigs.forEach(function (config) {
        var changed = false; // 数据更新

        if (typeof attr == 'undefined') {
          config.arr.forEach(handle);
        } else {
          var attrConfig = config.map[attr];

          if (attrConfig) {
            changed = handle(attrConfig);
          }
        } // 事件的绑定和解绑


        config.events.forEach(function (eventConfig) {
          var eventName = eventConfig.name;

          _this2.off(eventName, eventConfig.action);

          if (eventConfig.condition.call(_this2, attributes, dom)) {
            _this2.on(eventName, eventConfig.action);
          }

          var keyAttrs = eventConfig.keyAttrs;

          if (keyAttrs instanceof Array && attr && changed && keyAttrs.indexOf(attr) > -1 && (!hash || hash != _this2.lastHash)) {
            _this2.lastHash = hash;

            _this2.emit(eventName);
          }
        });
      }); // 特殊属性的操作

      if (typeof attr == 'undefined') {
        this.updateOfData(attributes, dom);
        this.updateScrollData(attributes, dom);
        this.updateLazyData(attributes, dom);
      } else if (attr == overflowHideAttr) {
        this.updateOfData(attributes, dom);
      } else if (attr == isScrollerAttr) {
        this.updateScrollData(attributes, dom);
      } else if (attr == lazyAttr) {
        this.updateLazyData(attributes, dom);
      }

      this.update(dom, attr, hash);
    } // 提供数据更新方法，方便使用方自定义功能

  }, {
    key: "update",
    value: function update(dom, attr, hash) {}
  }, {
    key: "updateOfData",
    value: function updateOfData(attributes, dom) {
      var attribute = attributes[overflowHideAttr];
      this.overflowHide = !(attribute && attribute.value === 'false');
    }
  }, {
    key: "updateScrollData",
    value: function updateScrollData(attributes, dom) {
      var attribute = attributes[isScrollerAttr];

      if (attribute) {
        this.attachScroller(dom);
      } else {
        this.off('scroll');
      }
    }
  }, {
    key: "updateLazyData",
    value: function updateLazyData(attributes, dom) {
      var attribute = attributes[lazyAttr];
      this.lazy = !!(attribute && attribute.value === 'true');
    }
  }, {
    key: "on",
    value: function on(event, callback) {
      var _this3 = this;

      var firstBindExposeEvent = event == 'expose' && this.emitter.listeners('expose').length <= 0;

      _get(_getPrototypeOf(ReportNode.prototype), "on", this).call(this, event, callback);

      if (firstBindExposeEvent) {
        _get(_getPrototypeOf(ReportNode.prototype), "on", this).call(this, 'visibilityChanged', function (visible) {
          if (visible) {
            _this3.emit('expose');
          } else {
            _this3.emit('hide');
          }
        });
      }

      return this;
    }
  }, {
    key: "getParam",
    value: function getParam(props, extData) {
      var _this4 = this;

      var data = extData || {};
      var unGotProps = [];
      props.forEach(function (prop) {
        var value = data[prop] = data[prop] || _this4.data[prop];
        if (!value) unGotProps.push(prop);
      });

      if (unGotProps.length >= 0) {
        this.mapParent(function (parentNode) {
          var pData = parentNode.data || {};
          unGotProps = unGotProps.filter(function (prop) {
            var value = data[prop] = pData[prop];
            return !value;
          });
          return unGotProps.length === 0;
        });
      }

      return data;
    }
  }], [{
    key: "addConfig",
    value: function addConfig(configs) {
      if (!(configs instanceof Array)) {
        configs = [configs];
      }

      var exists = {};
      var configArr = [];
      var configMap = {};
      globalConfigs = globalConfigs.concat(configs.map(function (config) {
        var configAttrs = config.attrs;
        var configEvents = config.events;
        var newConfigEvents = []; // 特殊属性的预处理

        if (config.overflowHide) {
          overflowHideAttr = config.overflowHide;
        }

        if (config.isScroller) {
          isScrollerAttr = config.isScroller;
        }

        if (config.lazy) {
          lazyAttr = config.lazy;
        } // attrs的预处理


        if (configAttrs) {
          var keys = Object.keys(configAttrs);
          keys.forEach(function (attr) {
            if (!exists[attr]) {
              exists[attr] = true;
              attrs.push(attr);
            }

            var newAttrConfigFunc;
            var attrConfig = configAttrs[attr];

            if (typeof attrConfig == 'boolean') {
              newAttrConfigFunc = function newAttrConfigFunc(value) {
                var changed = false;

                if (attrConfig) {
                  changed = this.data[attr] !== value;
                  this.data[attr] = value;
                }

                return changed;
              };
            } else if (attrConfig == 'JSON') {
              newAttrConfigFunc = function newAttrConfigFunc(value) {
                try {
                  this.setData(JSON.parse(value));
                } catch (e) {}

                return true;
              };
            } else if (attrConfig == 'KV') {
              newAttrConfigFunc = function newAttrConfigFunc(value) {
                this.setData((0, utils$1.kvStringToObject)(value));
                return true;
              };
            } else if (typeof attrConfig == 'string') {
              newAttrConfigFunc = function newAttrConfigFunc(value) {
                var changed = this.data[attrConfig] !== value;
                this.data[attrConfig] = value;
                return changed;
              };
            } else if (_typeof(attrConfig) == 'object') {
              newAttrConfigFunc = function newAttrConfigFunc(value) {
                var key = attrConfig.prop || attr;
                var dataType = attrConfig.dataType;
                var data;

                if (dataType == 'JSON') {
                  try {
                    data = JSON.parse(value);
                  } catch (e) {}
                } else if (dataType == 'KV') {
                  data = (0, utils$1.kvStringToObject)(value);
                } else {
                  data = value;
                }

                this.data[key] = data || {};
                return true;
              };
            } else if (typeof attrConfig == 'function') {
              newAttrConfigFunc = attrConfig;
            }

            if (newAttrConfigFunc) {
              var newAttrConfig = {
                name: attr,
                func: newAttrConfigFunc
              };
              configArr.push(newAttrConfig);
              configMap[attr] = newAttrConfig;
            }
          });
        } // events的预处理


        if (configEvents) {
          newConfigEvents = Object.keys(configEvents).map(function (eventName) {
            var eventConfig = configEvents[eventName];
            var newEventConfig = {
              name: eventName,
              action: eventConfig.action
            };
            var condition = eventConfig.condition;

            if (typeof condition == 'string') {
              newEventConfig.condition = function (attributes) {
                return attributes[condition];
              };

              if (eventName != 'click') {
                newEventConfig.keyAttrs = [condition];
              }
            } else if (condition instanceof Array) {
              newEventConfig.condition = function (attributes) {
                var i = 0;

                while (condition[i]) {
                  if (attributes[condition[i]]) {
                    return true;
                  }

                  i++;
                }

                return false;
              };

              if (eventName != 'click') {
                newEventConfig.keyAttrs = condition;
              }
            } else if (typeof condition == 'function') {
              newEventConfig.condition = condition;
            } else {
              newEventConfig.condition = function () {
                return true;
              };
            }

            if (eventConfig.keyAttrs) {
              newEventConfig.keyAttrs = eventConfig.keyAttrs;
            }

            return newEventConfig;
          });
        }

        return {
          arr: configArr,
          map: configMap,
          events: newConfigEvents
        };
      }));
    }
  }, {
    key: "shouldBeNode",
    value: function shouldBeNode(dom) {
      var attributes = dom.attributes;
      if (virtualTree.VirtualElTree.getVtreeMap().get(dom)) return true;
      if (attributes[overflowHideAttr] || attributes[isScrollerAttr] || attributes[lazyAttr]) return true;
      return attrs.some(function (attr) {
        return attributes[attr];
      });
    }
  }]);

  return ReportNode;
}(virtualTree.VirtualElNode);

exports.ReportNode = ReportNode;
});

unwrapExports(reportNode);
var reportNode_1 = reportNode.ReportNode;

var reportTree = createCommonjsModule(function (module, exports) {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReportTree = void 0;







function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var globalTree = null;

var ReportTree = /*#__PURE__*/function (_VirtualElTree) {
  _inherits(ReportTree, _VirtualElTree);

  var _super = _createSuper(ReportTree);

  _createClass(ReportTree, null, [{
    key: "attachGlobal",
    value: function attachGlobal(NodeClass) {
      globalTree = this.attachDom(document.body, NodeClass);
      return globalTree;
    }
  }, {
    key: "attachDom",
    value: function attachDom() {
      var dom = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
      var NodeClass = arguments.length > 1 ? arguments[1] : undefined;

      if (!(0, utils$1.isDom)(dom)) {
        throw new Error('parameter 1 is not of type "Node"');
      }

      var vtree = _get(_getPrototypeOf(ReportTree), "getVtreeMap", this).call(this).get(dom) || null;

      if (vtree) {
        return vtree;
      } else {
        vtree = new this(NodeClass);

        _get(_getPrototypeOf(ReportTree), "getVtreeMap", this).call(this).set(dom, vtree);

        vtree.attach(dom);
        (0, virtualTree.getWindowNode)().on('resize', function () {
          vtree.reflow(vtree.root);
        });
        (0, virtualTree.getWindowNode)().attachScroller(window, {
          throttle: 200
        });
        (0, virtualTree.getWindowNode)().append(vtree.root);
        return vtree;
      }
    }
  }, {
    key: "detachDom",
    value: function detachDom(dom) {
      if (!(0, utils$1.isDom)(dom)) {
        throw new Error('parameter 1 is not of type "Node"');
      }

      var vtree = _get(_getPrototypeOf(ReportTree), "getVtreeMap", this).call(this).get(dom) || null;
      if (!vtree) return;
      vtree.observer.disconnect();
      vtree.detach();
    }
  }, {
    key: "getGlobalTree",
    value: function getGlobalTree() {
      return globalTree;
    }
  }]);

  function ReportTree(NodeClass) {
    var _this;

    _classCallCheck(this, ReportTree);

    _this = _super.call(this, NodeClass || reportNode.ReportNode); // 登录态相关

    _this.commonData = {};
    _this.pageData = {};
    _this.lastPageData = {};
    return _this;
  }

  _createClass(ReportTree, [{
    key: "pv",
    value: function pv() {}
  }, {
    key: "setCommon",
    value: function setCommon(data) {
      Object.assign(this.commonData, data);
    }
  }, {
    key: "setPage",
    value: function setPage(data) {
      Object.assign(this.pageData, data);
    }
  }, {
    key: "setLastPage",
    value: function setLastPage(data) {
      Object.assign(this.lastPageData, data);
    }
  }]);

  return ReportTree;
}(virtualTree.VirtualElTree);

exports.ReportTree = ReportTree;
});

unwrapExports(reportTree);
var reportTree_1 = reportTree.ReportTree;

var ReportTree = reportTree.ReportTree;
var ReportNode = reportNode.ReportNode;

var h5reporter = {
  ReportTree: ReportTree,
  ReportNode: ReportNode,
  getWindowNode: virtualTree.getWindowNode,
  init: function (config) {
    ReportNode.addConfig(config);
    ReportTree.attachGlobal();
  }
};

/**
 * 深度优先遍历上报树
 * 触发可视区域元素曝光事件
 */
var traverse = function (nodeArr) {
    if (!nodeArr || !nodeArr.length)
        return;
    nodeArr.forEach(function (node) {
        if (!node || !node.visible)
            return;
        node.emit('expose');
        traverse(node.children);
    });
};
var rectChanged = function (newRect) {
    return {
        top: Math.round(newRect.top),
        bottom: Math.round(newRect.bottom),
        left: Math.round(newRect.left),
        right: Math.round(newRect.right),
    };
};
function mutationEmitter (reporter) {
    var observer = reporter.observer, isEnablePlugin = reporter.isEnablePlugin;
    if (!observer)
        return;
    var reportNodeProto = observer.ReportNode.prototype;
    // 属性变化通知
    var update = reportNodeProto.update;
    reportNodeProto.update = function (dom, attr, _hash) {
        var _a, _b;
        update.call(this, dom, attr, _hash);
        var pgid = this.data.pgid || '';
        var hold = (_b = (_a = this.data) === null || _a === void 0 ? void 0 : _a.cmd) === null || _b === void 0 ? void 0 : _b.hold;
        if (attr === "dt-pgid" /* PAGE */ && this.oldPgid && pgid !== this.oldPgid) {
            // `dt-pgid` 属性修改重新初始化页面
            reporter.emit('pageIdChange', dom, this.oldPgid);
        }
        else if (attr === "dt-params" /* PARAMS */ && pgid) {
            // `dt-params` 属性修改同步更新 `pagaManager` 页面信息
            reporter.emit('pageParamsChange', dom, pgid);
        }
        else if (attr === "dt-cmd" /* COMMAND */ && hold === 'false' && hold !== this.oldHold) {
            // 判断控制命令是否发生变化
            // 如果本次 hold 为 false 且上次 hold 为 true，遍历元素以及子元素进行曝光
            traverse([this]);
        }
        this.oldPgid = pgid;
        this.oldHold = hold || 'false';
    };
    if (!isEnablePlugin)
        return;
    var mutationRecords = []; // 变动缓冲数组
    var isViewPluginReady = false; // 可视化插件是否 ready
    // 可视化插件 ready 通知已存储变动记录
    reporter.eventBus.on('viewPluginReady', function () {
        isViewPluginReady = true;
        var fn = null;
        while ((fn = mutationRecords.shift())) {
            fn();
        }
    });
    // 可视化插件 ready 立即通知
    // 可视化插件未 ready 存储变动记录
    var notify = function (fn) {
        if (isViewPluginReady) {
            fn();
        }
        else {
            mutationRecords.push(fn);
        }
    };
    // DOM 插入
    var append = reportNodeProto.append;
    reportNodeProto.append = function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var ret = append.apply(this, args);
        notify(function () {
            reporter.emit('mutation', {
                action: 'append',
                node: _this,
            });
        });
        return ret;
    };
    var insert = reportNodeProto.insert;
    reportNodeProto.insert = function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var ret = insert.apply(this, args);
        var nodes = args[1] || [];
        notify(function () {
            reporter.emit('mutation', {
                action: 'insert',
                node: _this,
                data: nodes,
            });
        });
        return ret;
    };
    // 数据更新
    var updateData = reportNodeProto.updateData;
    reportNodeProto.updateData = function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var ret = updateData.apply(this, args);
        notify(function () {
            var emitter = _this.emitter;
            var hasClickEvent = emitter.events.click;
            var hasExposeEvent = emitter.events.expose;
            reporter.emit('mutation', {
                action: 'updateData',
                node: _this,
                data: {
                    data: _this.data,
                    exp: hasExposeEvent ? 1 : undefined,
                    cli: hasClickEvent ? 1 : undefined,
                    of: _this.overflowHide ? undefined : 1,
                },
            });
        });
        return ret;
    };
    // 元素可视区域变化
    var calcViewPort = reportNodeProto.calcViewPort;
    reportNodeProto.calcViewPort = function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var ret = calcViewPort.apply(this, args);
        notify(function () {
            reporter.emit('mutation', {
                action: 'calcViewPort',
                node: _this,
                data: {
                    viewport: rectChanged(_this.viewport),
                },
            });
        });
        return ret;
    };
    // 重新计算元素大小
    var recalc = reportNodeProto.recalc;
    reportNodeProto.recalc = function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var ret = recalc.apply(this, args);
        notify(function () {
            reporter.emit('mutation', {
                action: 'recalc',
                node: _this,
                data: {
                    viewport: rectChanged(_this.viewport),
                },
            });
        });
        return ret;
    };
    // 元素移动
    var move = reportNodeProto.move;
    reportNodeProto.move = function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var ret = move.apply(this, args);
        notify(function () {
            reporter.emit('mutation', {
                action: 'move',
                node: _this,
                data: {
                    viewport: rectChanged(_this.viewport),
                    rect: rectChanged(_this.rect),
                },
            });
        });
        return ret;
    };
    // 元素删除
    var remove = reportNodeProto.remove;
    reportNodeProto.remove = function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        notify(function () {
            reporter.emit('mutation', {
                action: 'remove',
                node: _this,
            });
        });
        return remove.apply(this, args);
    };
    // 元素清空
    var clear = reportNodeProto.clear;
    reportNodeProto.clear = function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        notify(function () {
            reporter.emit('mutation', {
                action: 'clear',
                node: _this,
            });
        });
        return clear.apply(this, args);
    };
}

/**
 * 判断上报节点是页面还是元素
 * 上报节点对应的 DOM 元素拥有 `dt-pgid` 属性则为页面
 */
var isPageNode = function (node) {
    var _a;
    var $el = node === null || node === void 0 ? void 0 : node.el;
    return (_a = $el === null || $el === void 0 ? void 0 : $el.hasAttribute) === null || _a === void 0 ? void 0 : _a.call($el, "dt-pgid" /* PAGE */);
};
/**
 * 获取元素参数
 * 如果元素自身拥有该属性值则直接返回属性值，
 * 否则继续查找同一个页面内父元素对应属性值
 */
var getNodeParam = function (node, name) {
    var _a, _b, _c, _d;
    if (!node)
        return;
    var data = null;
    var $node = node;
    while (!data && $node) {
        data = (_b = (_a = $node.data) === null || _a === void 0 ? void 0 : _a[name]) !== null && _b !== void 0 ? _b : '';
        $node = $node.parent;
        if (!data && isPageNode($node)) {
            data = (_d = (_c = $node.data) === null || _c === void 0 ? void 0 : _c[name]) !== null && _d !== void 0 ? _d : '';
            break;
        }
    }
    return data;
};
/**
 * 获取元素上报虚拟节点
 */
var getReportNode = function (element) {
    if (!element)
        return null;
    return h5reporter.ReportNode.getNode(element);
};
/**
 * 获取页面中元素最近的父元素上报节点
 */
var getClosestParentNode = function (element) {
    var $ele = element;
    var reportNode = null;
    while (!reportNode && $ele && $ele.hasAttribute && !$ele.hasAttribute("dt-pgid" /* PAGE */)) {
        $ele = $ele.parentNode;
        reportNode = getReportNode($ele);
    }
    return reportNode;
};
function observer (reporter) {
    var _a;
    Object.assign(reporter, { observer: h5reporter });
    // DOM 变动、属性变动等通知
    mutationEmitter(reporter);
    var clickAction = function () {
        var pgid = getNodeParam(this, 'pgid');
        var eid = this.data.eid;
        var command = getNodeParam(this, 'cmd') || {};
        var hasClckIgnore = this.data.clckIgnore === 'true';
        var isSendBeacon = this.data.sendBeacon === 'true';
        if (!pgid || !eid || command.hold === 'true' || hasClckIgnore)
            return;
        reporter.reportElement(this.el, {
            pgid: pgid,
            eventName: STANDARD_EVENTS.CLCK,
            eventTime: Date.now(),
            businessParams: __assign({ eid: eid }, this.data.params),
            isSendBeacon: isSendBeacon,
        });
    };
    var exposeAction = function () {
        var pgid = getNodeParam(this, 'pgid');
        var command = getNodeParam(this, 'cmd') || {};
        if (!pgid || command.hold === 'true')
            return;
        if (isPageNode(this)) {
            // 页面曝光
            var hasPgIgnore = this.data.pgIgnore === 'true';
            var hasPginIgnore = this.data.pginIgnore === 'true';
            if (hasPgIgnore || hasPginIgnore)
                return;
            var firstPVReportFlag = reporter.firstPVReportMap[pgid];
            reporter.setFirstPVFlag(pgid, 'reported');
            if (firstPVReportFlag === 'first_reported')
                return; // 页面首次已曝光
            reporter.reportPV(pgid);
        }
        else {
            // 元素曝光
            var eid = this.data.eid;
            var hasImpIgnore = this.data.impIgnore === 'true';
            if (!eid || hasImpIgnore)
                return;
            reporter.reportElement(this.el, {
                pgid: pgid,
                eventName: STANDARD_EVENTS.IMP,
                eventTime: Date.now(),
                businessParams: __assign({ eid: eid }, this.data.params),
            });
        }
    };
    var hideAction = function () {
        var pgid = getNodeParam(this, 'pgid');
        var command = getNodeParam(this, 'cmd') || {};
        if (!pgid || command.hold === 'true')
            return;
        if (isPageNode(this)) {
            // 页面结束曝光
            var hasPgIgnore = this.data.pgIgnore === 'true';
            var hasPgoutIgnore = this.data.pgoutIgnore === 'true';
            if (hasPgIgnore || hasPgoutIgnore)
                return;
            reporter.reportPgOut(pgid);
        }
        else {
            // 元素结束曝光
            var eid = this.data.eid;
            var hasImpIgnore = this.data.impIgnore === 'true';
            if (!eid || hasImpIgnore)
                return;
            var elementArea = this.effectiveWidth * this.effectiveHeight; // 面积（全长），单位 px²
            var eleImpArea = this.isScroller
                ? (this.maxScrollLeft + this.width) * (this.maxScrollTop + this.height) // 曝光面积，单位 px²
                : this.maxIntersectArea;
            var impRate = elementArea ? Math.min(eleImpArea / elementArea, 1) : 0; // 曝光周期内最大曝光比例
            var showTime = this.el.showTime;
            var impEndParams = {
                dt_element_area: elementArea.toFixed(2),
                dt_ele_imp_area: eleImpArea.toFixed(2),
                dt_element_lvtm: showTime ? Date.now() - this.el.showTime : 0,
                dt_ele_imp_rate: impRate.toFixed(2),
            };
            reporter.reportElement(this.el, {
                pgid: pgid,
                eventName: STANDARD_EVENTS.IMPEND,
                eventTime: Date.now(),
                publicParams: __assign({}, impEndParams),
                businessParams: __assign(__assign({ eid: eid }, renameParams(impEndParams)), this.data.params),
            });
        }
    };
    // 埋点属性、回调事件配置
    h5reporter.ReportNode.addConfig({
        isScroller: "dt-scroll" /* SCROLLER */,
        overflowHide: "dt-overflow-hide" /* OVERFLOW_HIDE */,
        lazy: "dt-lazy" /* LAZY */,
        attrs: (_a = {},
            _a["dt-pgid" /* PAGE */] = 'pgid',
            _a["dt-eid" /* ELEMENT */] = 'eid',
            // 元素参数
            _a["dt-params" /* PARAMS */] = {
                prop: 'params',
                dataType: 'KV',
            },
            // 控制属性
            _a["dt-cmd" /* COMMAND */] = {
                prop: 'cmd',
                dataType: 'KV',
            },
            _a["dt-pg-ignore" /* PG_IGNORE */] = 'pgIgnore',
            _a["dt-pgin-ignore" /* PGIN_IGNORE */] = 'pginIgnore',
            _a["dt-pgout-ignore" /* PGOUT_IGNORE */] = 'pgoutIgnore',
            _a["dt-imp-ignore" /* IMP_IGNORE */] = 'impIgnore',
            _a["dt-clck-ignore" /* CLCK_IGNORE */] = 'clckIgnore',
            _a["dt-send-beacon" /* USE_BEACON */] = 'sendBeacon',
            _a),
        events: {
            click: {
                condition: ["dt-eid" /* ELEMENT */],
                action: clickAction,
            },
            expose: {
                condition: ["dt-pgid" /* PAGE */, "dt-eid" /* ELEMENT */],
                action: exposeAction,
            },
            hide: {
                condition: ["dt-pgid" /* PAGE */, "dt-eid" /* ELEMENT */],
                action: hideAction,
            },
        },
    });
}

var has = Object.prototype.hasOwnProperty
  , undef;

/**
 * Decode a URI encoded string.
 *
 * @param {String} input The URI encoded string.
 * @returns {String|Null} The decoded string.
 * @api private
 */
function decode(input) {
  try {
    return decodeURIComponent(input.replace(/\+/g, ' '));
  } catch (e) {
    return null;
  }
}

/**
 * Simple query string parser.
 *
 * @param {String} query The query string that needs to be parsed.
 * @returns {Object}
 * @api public
 */
function querystring(query) {
  var parser = /([^=?&]+)=?([^&]*)/g
    , result = {}
    , part;

  while (part = parser.exec(query)) {
    var key = decode(part[1])
      , value = decode(part[2]);

    //
    // Prevent overriding of existing properties. This ensures that build-in
    // methods like `toString` or __proto__ are not overriden by malicious
    // querystrings.
    //
    // In the case if failed decoding, we want to omit the key/value pairs
    // from the result.
    //
    if (key === null || value === null || key in result) continue;
    result[key] = value;
  }

  return result;
}

/**
 * Transform a query string to an object.
 *
 * @param {Object} obj Object that should be transformed.
 * @param {String} prefix Optional prefix.
 * @returns {String}
 * @api public
 */
function querystringify(obj, prefix) {
  prefix = prefix || '';

  var pairs = []
    , value
    , key;

  //
  // Optionally prefix with a '?' if needed
  //
  if ('string' !== typeof prefix) prefix = '?';

  for (key in obj) {
    if (has.call(obj, key)) {
      value = obj[key];

      //
      // Edge cases where we actually want to encode the value to an empty
      // string instead of the stringified value.
      //
      if (!value && (value === null || value === undef || isNaN(value))) {
        value = '';
      }

      key = encodeURIComponent(key);
      value = encodeURIComponent(value);

      //
      // If we failed to encode the strings, we should bail out as we don't
      // want to add invalid strings to the query.
      //
      if (key === null || value === null) continue;
      pairs.push(key +'='+ value);
    }
  }

  return pairs.length ? prefix + pairs.join('&') : '';
}

//
// Expose the module.
//
var stringify = querystringify;
var parse = querystring;

var querystringify_1 = {
	stringify: stringify,
	parse: parse
};

var PageManager = /** @class */ (function () {
    function PageManager() {
        this.pageMap = {};
    }
    PageManager.prototype.hasPage = function (pgid) {
        return pgid && this.pageMap[pgid];
    };
    PageManager.prototype.addPage = function (pageOptions) {
        var _a;
        var pgid = (_a = pageOptions === null || pageOptions === void 0 ? void 0 : pageOptions.pageParams) === null || _a === void 0 ? void 0 : _a.pgid;
        var $pageRoot = getDom(pageOptions === null || pageOptions === void 0 ? void 0 : pageOptions.pageRoot);
        if (!pgid || !$pageRoot) {
            var message = !pgid
                ? '[universalReport] pageParams must contain pgid'
                : '[universalReport] pageRoot is neither not of type "Node" nor a valid selector';
            console.error(message);
            return;
        }
        var refPg = querystringify_1.parse(getUrlParameter('ref_pg') || '');
        var refEle = querystringify_1.parse(getUrlParameter('ref_ele') || '');
        this.pageMap[pgid] = __assign(__assign({}, pageOptions), { pageParams: __assign({ 
                // 来源页面信息默认解析 URL 中的 ref_pg与ref_ele 参数
                ref_pg: (refPg['pgid'] ? refPg : {}), ref_ele: refEle['eid'] ? refEle : {} }, pageOptions.pageParams), pageRoot: $pageRoot });
    };
    PageManager.prototype.getPage = function (pgid) {
        return this.hasPage(pgid) ? this.pageMap[pgid] : null;
    };
    PageManager.prototype.setPage = function (pageOptions) {
        var _a;
        var pgid = (_a = pageOptions === null || pageOptions === void 0 ? void 0 : pageOptions.pageParams) === null || _a === void 0 ? void 0 : _a.pgid;
        var page = this.pageMap[pgid];
        if (!this.hasPage(pgid)) {
            console.error("[universalReport] the page does not exist and can not be set " + pgid);
            return;
        }
        this.pageMap[pgid] = __assign(__assign(__assign({}, page), pageOptions), { pageParams: __assign(__assign({}, page.pageParams), pageOptions.pageParams) });
    };
    PageManager.prototype.removePage = function (pgid) {
        if (!this.hasPage(pgid))
            return;
        this.pageMap[pgid] = null;
    };
    /**
     * 更新页面状态
     * @description 页面曝光需要记录页面开始曝光时间，
     * 重置页面是否有点击，页面跳转数递增
     */
    PageManager.prototype.updatePage = function (pgid) {
        var _a, _b;
        if (!this.hasPage(pgid))
            return;
        var pgstp = Number((_b = (_a = this.getPage(pgid).pageParams) === null || _a === void 0 ? void 0 : _a.pg_stp) !== null && _b !== void 0 ? _b : 0) + 1;
        this.setPage({
            pageParams: {
                pgid: pgid,
                pg_stp: pgstp,
            },
            showTime: Date.now(),
            clckFlag: '0',
        });
    };
    /**
     * 补充 `pgid`
     * @description 应用只有一个上报页面可以不指定 pgid，
     * 函数指定 pgid 则直接返回，未指定如果为单页面返回单页面 `pgid`，否则返回空字符串
     * @return {string}
     */
    PageManager.prototype.fixPgid = function (pgid) {
        if (pgid)
            return pgid;
        var pages = Object.keys(this.pageMap);
        return pages.length === 1 ? pages[0] : '';
    };
    return PageManager;
}());

var _a;
var PUBLIC_PARAMS_WHITELIST = ['dt_omgid']; // 公参白名单
var PublicParams = /** @class */ (function () {
    function PublicParams(options) {
        if (options === void 0) { options = {}; }
        // 初始化公共参数
        this.init();
        var sceneInfo = getScenePlat(options.scenePlat);
        // 合并初始化传入公参
        this.set(__assign(__assign({}, options.publicParams), { web_version: options.version || '', scenes_plat: sceneInfo.scenePlat, scenes_version: sceneInfo.sceneVersion }), "publicParams" /* PUBLIC_PARAMS */).set(options.accountInfo || defAccountInfo, "accountInfo" /* ACCOUNT_INFO */);
    }
    PublicParams.prototype.init = function () {
        var _a, _b, _c, _d, _e;
        this.publicParams = {
            // 终端信息
            platform: getPlatform(CLIENT_INFO),
            hardware_os: ((_a = CLIENT_INFO.os.name) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || '',
            os_version: CLIENT_INFO.os.version || '',
            target_sdk: parseInt(CLIENT_INFO.os.version, 10) || 0,
            resolution: window.screen.width * window.devicePixelRatio,
            dpi: getDPI(),
            brand: ((_b = CLIENT_INFO.device.vendor) === null || _b === void 0 ? void 0 : _b.toLowerCase()) || '',
            mf: ((_c = CLIENT_INFO.device.vendor) === null || _c === void 0 ? void 0 : _c.toLowerCase()) || '',
            model: ((_d = CLIENT_INFO.device.model) === null || _d === void 0 ? void 0 : _d.toLowerCase()) || '',
            // Web 信息
            web_version: '',
            web_core_type: ((_e = CLIENT_INFO.engine.name) === null || _e === void 0 ? void 0 : _e.toLowerCase()) || '',
            web_core_version: CLIENT_INFO.engine.version || '',
            web_channel: getUrlParameter('web_channel') || '',
            scenes_plat: '',
            // 环境信息
            network_type: getNetworkType(),
            gps_longitude: '',
            gps_latitude: '',
            // 版本信息
            dt_sdkversion_h5: "3.2.1",
            // 用户信息
            dt_omgid: getCookie('video_omgid') || '',
            dt_omgbzid: '',
            // session信息
            dt_sessionid_h5: new Date().getTime() + Math.random().toString()
                .slice(2, 5),
        };
    };
    PublicParams.prototype.get = function (name) {
        if (name) {
            return this.publicParams[name];
        }
        return this.publicParams;
    };
    PublicParams.prototype.set = function (publicParams, type) {
        var _this = this;
        if (publicParams === void 0) { publicParams = {}; }
        if (type === void 0) { type = "publicParams" /* PUBLIC_PARAMS */; }
        var check = PublicParams.checkRules[type];
        if (!check)
            return;
        Object.keys(publicParams)
            .filter(function (key) { return check(key); })
            .forEach(function (key) {
            _this.publicParams[key] = publicParams[key];
        });
        return this;
    };
    PublicParams.prototype.remove = function (name) {
        var _this = this;
        if (name === void 0) { name = ''; }
        var check = PublicParams.checkRules["publicParams" /* PUBLIC_PARAMS */];
        var $name = Array.isArray(name) ? name : [name];
        $name.forEach(function (key) {
            if (check(key, "[universalReport] \"" + key + "\" cannot be deleted")) {
                delete _this.publicParams[key];
            }
        });
    };
    /**
     * 页面信息需要同步到公参中，方便 ETL 解析
     */
    PublicParams.prototype.getPublicPageParams = function (pageParams) {
        var _a, _b, _c, _d;
        return {
            url: window.location.href,
            ref_url: document.referrer,
            dt_pgid: (_a = pageParams.pgid) !== null && _a !== void 0 ? _a : '',
            dt_ref_pgid: (_c = (_b = pageParams.ref_pg) === null || _b === void 0 ? void 0 : _b.pgid) !== null && _c !== void 0 ? _c : '',
            dt_pgstp: (_d = pageParams.pg_stp) !== null && _d !== void 0 ? _d : 1,
        };
    };
    // 公参校验方法
    PublicParams.checkRules = (_a = {},
        _a["publicParams" /* PUBLIC_PARAMS */] = function (key, tips) {
            var isInvalid = String(key).indexOf('dt_') !== -1
                && PUBLIC_PARAMS_WHITELIST.indexOf(key) < 0; // 允许设置白名单内参数
            if (isInvalid) {
                console.warn(tips || "\n          [universalReport] Public parameters cannot start with \"dt_\", \"" + key + "\"");
            }
            return !isInvalid;
        },
        _a["accountInfo" /* ACCOUNT_INFO */] = function (key) { return Object.keys(defAccountInfo).includes(key); },
        _a);
    return PublicParams;
}());

/**
 * 私有参数
 * 部分事件才有的参数
 */
var PrivateParams = /** @class */ (function () {
    function PrivateParams() {
        this.privateParams = {};
    }
    /**
     * 设置私有参数
     * @param {string} key         参数名
     * @param {any}    [value='']  参数值
     * @param {array}  [events=[]] 事件类型
     */
    PrivateParams.prototype.set = function (key, value, events) {
        if (value === void 0) { value = ''; }
        if (events === void 0) { events = []; }
        if (!key || !events.length)
            return this;
        this.privateParams[key] = {
            value: value,
            events: events,
        };
        return this;
    };
    PrivateParams.prototype.get = function (key) {
        if (key) {
            return this.privateParams[key];
        }
        return this.privateParams;
    };
    PrivateParams.prototype.remove = function (key) {
        if (key) {
            delete this.privateParams[key];
        }
    };
    /**
     * 获取事件所有私有参数
     */
    PrivateParams.prototype.getEventPrivateParams = function (eventName) {
        return Object.entries(this.privateParams)
            .filter(function (param) { return param[1].events.includes(eventName); })
            .reduce(function (res, item) {
            var _a;
            return Object.assign(res, (_a = {}, _a[item[0]] = item[1].value, _a));
        }, {});
    };
    return PrivateParams;
}());

/**
 * 腾讯视频 APP 参数装饰器
 * VR 公参包括设备信息，设备信息依赖 `jsBridge` 获取
 * 所以 APP 内的页面上报需要等待设备信息获取完成后开始上报
 */
var isTenVideo = !!(navigator.userAgent.match(/TADChid/i)
    ? false
    : navigator.userAgent.match(/QQLiveBrowser\/([\d.]+)/));
var loadTenvideoJSBridge = function () { return new Promise(function (resolve, reject) {
    // 非 APP 内
    if (!isTenVideo)
        return reject();
    // APP 内一些特殊场景没有 `JSBridge`，或者加载失败等场景兜底
    var timer = setTimeout(function () {
        reject();
    }, 500);
    if (window.TenvideoJSBridge) {
        clearTimeout(timer);
        resolve();
    }
    else {
        document.addEventListener('onTenvideoJSBridgeReady', function () {
            clearTimeout(timer);
            resolve();
        }, false);
    }
}); };
var getDeviceInfo = function () { return new Promise(function (resolve) {
    if (!window.TenvideoJSBridge)
        return resolve(null);
    window.TenvideoJSBridge.invoke('getDeviceInfo', null, function (data) {
        var _a, _b, _c, _d;
        var res = '';
        try {
            res = JSON.parse(data);
        }
        catch (error) {
            console.error("[universalReport] " + error);
        }
        if (!res.result)
            resolve(null);
        resolve({
            os_vrsn: (_a = res.result.systemVersion) !== null && _a !== void 0 ? _a : '',
            imei: (_b = res.result.imei) !== null && _b !== void 0 ? _b : '',
            imei_q3: (_c = res.result.imei_q3) !== null && _c !== void 0 ? _c : '',
            idfa: (_d = res.result.idfa) !== null && _d !== void 0 ? _d : '',
        });
    });
}); };
var waitTenvideoReady = function (jsBridgePromise) {
    var isReady = false;
    var deviceInfo = null;
    var store = []; // 暂存区
    var clearStore = function () {
        var item = null;
        while ((item = store.shift())) {
            item(deviceInfo);
        }
        isReady = true;
    };
    jsBridgePromise
        .then(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getDeviceInfo()];
                case 1:
                    deviceInfo = _a.sent();
                    clearStore();
                    return [2 /*return*/];
            }
        });
    }); })
        .catch(function () {
        clearStore();
    });
    return function (target, propertyKey, descriptor) { return (__assign(__assign({}, descriptor), { value: function () {
            var _this = this;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var fn = descriptor.value;
            if (isReady) {
                fn.apply(this, args);
            }
            else {
                store.push(function (deviceInfo) {
                    fn.apply(_this, __spreadArrays(args, [deviceInfo]));
                });
            }
        } })); };
};
var tenvideoReady = waitTenvideoReady(loadTenvideoJSBridge());

var VideoReport = /** @class */ (function () {
    function VideoReport(options, dtPublicParams) {
        this.options = options;
        this.channel = new ChannelManager(__assign(__assign({}, this.options), { channel: 'boss' }));
        this.init(dtPublicParams);
    }
    VideoReport.prototype.init = function (dtPublicParams, deviceInfo) {
        if (deviceInfo === void 0) { deviceInfo = {}; }
        this.convertPublicParams(dtPublicParams, __assign(__assign({}, deviceInfo), this.options.publicParams));
    };
    VideoReport.prototype.report = function (context) {
        var vrContext = this.convertContext(context);
        this.channel.report(vrContext);
    };
    VideoReport.prototype.convertContext = function (context) {
        var _a;
        var dtPublicParams = context.publicParams;
        var publicParams = this.publicParams;
        var pageParams = {};
        var businessParams = (_a = context.businessParams) !== null && _a !== void 0 ? _a : {};
        // 公参转换
        publicParams = __assign(__assign({}, publicParams), { url: dtPublicParams.url, ref_url: dtPublicParams.ref_url, ei: context.eventName.replace('dt_', ''), ctime: context.eventTime, eventid: dtPublicParams.dt_eventid_h5 });
        // 业务参数格式转换
        if (!this.options.formatMode && businessParams.element_params) {
            businessParams = businessParams.element_params.reduce(function (res, obj) { return (__assign(__assign({}, obj), res)); }, {});
        }
        // 页面参数转换
        pageParams = reject(context.pageParams, ['pg_stp']);
        return __assign(__assign({}, context), { publicParams: publicParams,
            pageParams: pageParams,
            businessParams: businessParams });
    };
    /**
     * 公参转换
     * @param {IPublicParams} dtPublicParams 大同公共参数
     * @param {object} publicParams          业务自定义公共参数
     */
    VideoReport.prototype.convertPublicParams = function (dtPublicParams, publicParams) {
        var os = ['android', 'ios'].indexOf(dtPublicParams.hardware_os) + 1;
        this.publicParams = __assign({ os: os || '', os_vrsn: os ? dtPublicParams.os_version : '', imei: '', imei_q3: '', idfa: '', jlbrk: '', network_type: ['wifi', '2g', '3g', '4g'].indexOf(dtPublicParams.network_type) + 1 || 5, pt: this.transformPlatform(dtPublicParams.platform, dtPublicParams.hardware_os), qq: dtPublicParams.dt_qq_h5, qq_openid: dtPublicParams.dt_qqopenid_h5, wx_openid: dtPublicParams.dt_wxopenid_h5, wx_commid: '', omgid: dtPublicParams.dt_omgid || getCookie('video_omgid') || '', omgbizid: '', vuserid: getCookie('main_login') === 'qq'
                ? getCookie('vqq_vuserid') || getCookie('vuserid') || ''
                : getCookie('vuserid') || '', guid: getCookie('guid') || getCookie('video_guid') || '', uuid: getCookie('txv_boss_uuid') || '', qimei: '', main_login: ['wx', 'qq'].indexOf(dtPublicParams.dt_mainlogin_h5) + 1, ptag: getUrlParameter('ptag') || '', sharesource: getUrlParameter('sharesource') || getUrlParameter('shareSource') || '', second_share: getUrlParameter('second_share') || '', bucket_id: getCookie('plat_bucketid') || '', h5_ver: dtPublicParams.web_version, lm_experiment_id: '', sessionid: dtPublicParams.dt_sessionid_h5 }, publicParams);
    };
    /**
     * 终端枚举类型映射
     */
    VideoReport.prototype.transformPlatform = function (platform, os) {
        var pt = 0;
        if (platform === 'phone') {
            if (os === 'android') {
                pt = 8;
            }
            else if (os === 'ios') {
                pt = 7;
            }
        }
        else if (platform === 'tablet') {
            if (os === 'android') {
                pt = 6;
            }
            else if (os === 'ios') {
                pt = 5;
            }
        }
        if (os === 'android' && pt === 0) {
            pt = 8; // 若判断为android但platform不是phone和tablet，先归类为android phone
        }
        return pt;
    };
    __decorate([
        tenvideoReady,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", void 0)
    ], VideoReport.prototype, "init", null);
    __decorate([
        tenvideoReady,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], VideoReport.prototype, "report", null);
    return VideoReport;
}());
function compatVideoReport (reporter) {
    var $reporter = reporter;
    if ($reporter.options.videoReport) {
        $reporter.videoReport = new VideoReport($reporter.options, $reporter.getPublicParams());
    }
}

var ATTA = {
    attaUrl: 'https://h.trace.qq.com/kv',
    attaId: '0b300050665',
    token: '6554817333',
};
var JS_API_ATTA = {
    attaUrl: 'https://h.trace.qq.com/kv',
    attaId: '01600053974',
    token: '9671122527',
};
var path = encodeURIComponent(("" + window.location.host + window.location.pathname)
    .replace(/\./g, '_'));
function formatAttaData(context, attaInfo) {
    var formData = [];
    var dc = Math.random()
        .toString(36)
        .substr(2, 8);
    var url = '';
    url = attaInfo.attaUrl + "?attaid=" + attaInfo.attaId + "&token=" + attaInfo.token + "&_dc=" + dc;
    var data = __assign(__assign({ Attaid: attaInfo.attaId, token: attaInfo.token, url: encodeURIComponent(window.location.href), path: path }, context), { dc: dc });
    Object.keys(data).forEach(function (key) {
        formData.push(key + "=" + encodeURIComponent(data[key]));
    });
    return {
        url: url,
        data: formData.join('&'),
    };
}
function attaReport(context, attaInfo) {
    if (attaInfo === void 0) { attaInfo = ATTA; }
    try {
        var _a = formatAttaData(context, attaInfo), url = _a.url, data = _a.data;
        xhr(url, data);
    }
    catch (e) {
        throw new Error('[universalReport] atta report fail');
    }
}

/* eslint-disable */
if (!Array.prototype.includes) {
    Object.defineProperty(Array.prototype, 'includes', {
        value: function (valueToFind, fromIndex) {
            if (this == null) {
                throw new TypeError('"this" is null or not defined');
            }
            // 1. Let O be ? ToObject(this value).
            var o = Object(this);
            // 2. Let len be ? ToLength(? Get(O, "length")).
            var len = o.length >>> 0;
            // 3. If len is 0, return false.
            if (len === 0) {
                return false;
            }
            // 4. Let n be ? ToInteger(fromIndex).
            //    (If fromIndex is undefined, this step produces the value 0.)
            var n = fromIndex | 0;
            // 5. If n ≥ 0, then
            //  a. Let k be n.
            // 6. Else n < 0,
            //  a. Let k be len + n.
            //  b. If k < 0, let k be 0.
            var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);
            function sameValueZero(x, y) {
                return x === y || (typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y));
            }
            // 7. Repeat, while k < len
            while (k < len) {
                // a. Let elementK be the result of ? Get(O, ! ToString(k)).
                // b. If SameValueZero(valueToFind, elementK) is true, return true.
                if (sameValueZero(o[k], valueToFind)) {
                    return true;
                }
                // c. Increase k by 1.
                k++;
            }
            // 8. Return false
            return false;
        }
    });
}
if (!Object.entries)
    Object.entries = function (obj) {
        var ownProps = Object.keys(obj);
        var i = ownProps.length;
        var resArray = new Array(i); // preallocate the Array
        while (i--)
            resArray[i] = [ownProps[i], obj[ownProps[i]]];
        return resArray;
    };
if (!Array.isArray) {
    Array.isArray = function (arg) {
        return Object.prototype.toString.call(arg) === '[object Array]';
    };
}
if (typeof Object.assign != 'function') {
    // Must be writable: true, enumerable: false, configurable: true
    Object.defineProperty(Object, 'assign', {
        value: function assign(target) {
            if (target == null) {
                // TypeError if undefined or null
                throw new TypeError('Cannot convert undefined or null to object');
            }
            var to = Object(target);
            for (var index = 1; index < arguments.length; index++) {
                var nextSource = arguments[index];
                if (nextSource != null) {
                    // Skip over if undefined or null
                    for (var nextKey in nextSource) {
                        // Avoid bugs when hasOwnProperty is shadowed
                        if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                            to[nextKey] = nextSource[nextKey];
                        }
                    }
                }
            }
            return to;
        },
        writable: true,
        configurable: true
    });
}
// Simple Array.from polyfill
if (!Array.from) {
    Array.from = (function () {
        return [].slice.call(arguments);
    }());
}
// WeakMap polyfill
(function (self) {
    if (self.WeakMap) {
        return;
    }
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var defineProperty = function (object, name, value) {
        if (Object.defineProperty) {
            Object.defineProperty(object, name, {
                configurable: true,
                writable: true,
                value: value
            });
        }
        else {
            object[name] = value;
        }
    };
    self.WeakMap = (function () {
        // ECMA-262 23.3 WeakMap Objects
        function WeakMap() {
            if (this === void 0) {
                throw new TypeError("Constructor WeakMap requires 'new'");
            }
            defineProperty(this, '_id', genId('_WeakMap'));
            // ECMA-262 23.3.1.1 WeakMap([iterable])
            if (arguments.length > 0) {
                // Currently, WeakMap `iterable` argument is not supported
                throw new TypeError('WeakMap iterable is not supported');
            }
        }
        // ECMA-262 23.3.3.2 WeakMap.prototype.delete(key)
        defineProperty(WeakMap.prototype, 'delete', function (key) {
            checkInstance(this, 'delete');
            if (!isObject(key)) {
                return false;
            }
            var entry = key[this._id];
            if (entry && entry[0] === key) {
                delete key[this._id];
                return true;
            }
            return false;
        });
        // ECMA-262 23.3.3.3 WeakMap.prototype.get(key)
        defineProperty(WeakMap.prototype, 'get', function (key) {
            checkInstance(this, 'get');
            if (!isObject(key)) {
                return void 0;
            }
            var entry = key[this._id];
            if (entry && entry[0] === key) {
                return entry[1];
            }
            return void 0;
        });
        // ECMA-262 23.3.3.4 WeakMap.prototype.has(key)
        defineProperty(WeakMap.prototype, 'has', function (key) {
            checkInstance(this, 'has');
            if (!isObject(key)) {
                return false;
            }
            var entry = key[this._id];
            if (entry && entry[0] === key) {
                return true;
            }
            return false;
        });
        // ECMA-262 23.3.3.5 WeakMap.prototype.set(key, value)
        defineProperty(WeakMap.prototype, 'set', function (key, value) {
            checkInstance(this, 'set');
            if (!isObject(key)) {
                throw new TypeError('Invalid value used as weak map key');
            }
            var entry = key[this._id];
            if (entry && entry[0] === key) {
                entry[1] = value;
                return this;
            }
            defineProperty(key, this._id, [key, value]);
            return this;
        });
        function checkInstance(x, methodName) {
            if (!isObject(x) || !hasOwnProperty.call(x, '_id')) {
                throw new TypeError(methodName + ' method called on incompatible receiver ' +
                    typeof x);
            }
        }
        function genId(prefix) {
            return prefix + '_' + rand() + '.' + rand();
        }
        function rand() {
            return Math.random().toString().substring(2);
        }
        defineProperty(WeakMap, '_polyfill', true);
        return WeakMap;
    })();
    function isObject(x) {
        return Object(x) === x;
    }
})(typeof self !== 'undefined' ? self :
    typeof window !== 'undefined' ? window :
        typeof global !== 'undefined' ? global : undefined);

function ready (listenerResolve) {
    var pool = [];
    var isReady = false;
    listenerResolve.then(function () {
        isReady = true;
        var item;
        while ((item = pool.shift())) {
            item === null || item === void 0 ? void 0 : item();
        }
    });
    return function decorator(target, name, descriptor) {
        return __assign(__assign({}, descriptor), { value: function () {
                var _this = this;
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var fn = descriptor.value;
                if (isReady) {
                    return fn.apply(this, args);
                }
                pool.push(function () {
                    fn.apply(_this, args);
                });
                return this;
            } });
    };
}

var domReadyPromise = new Promise(function (resolve) {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            resolve();
        });
    }
    else {
        resolve();
    }
});
var domReady = (function () { return ready(domReadyPromise); });

var doAfterDomReady = domReady();
var Reporter = /** @class */ (function (_super) {
    __extends(Reporter, _super);
    function Reporter(options) {
        var _this = _super.call(this) || this;
        _this.options = options;
        _this.videoReport = null; // VR 上报
        _this.deviceId = ''; // 灯塔设备id
        _this.monitoringReportId = ''; // 监控上报业务Id
        _this.monitoringReport = false; // 监控上报开关
        _this.monitoringJsApiReport = false; // 监控jsapi质量上报开关
        _this.enableBeaconReportRetry = false; // 灯塔补报开关
        _this.isEnablePlugin = false; // 控制是否启用插件
        _this.firstPVReportMap = {}; // 记录首次曝光pgid
        _this.eventId = 0; // 自增事件ID
        if (!_this.checkBrowserEnvironment())
            return _this;
        _this.monitoringReportId = options.monitoringReportId;
        _this.monitoringReport = options.monitoringReport;
        _this.monitoringJsApiReport = options.monitoringJsApiReport;
        _this.monitoringReport && attaReport({
            step: 4,
            monitoring_report_id: _this.monitoringReportId,
        });
        _this.setEventHandler(); // 设置监听事件回调
        detectVideoReport(); // 检测旧 VR 上报是否存在
        _this.init()
            .initPlugin()
            .initObserver()
            .initPage()
            .onPageAttrChange()
            .onChannelReport()
            .addPageVisibilityChangeListener();
        if (_this.monitoringReport) {
            _this.bindSdkMonitoringEvent();
            attaReport(__assign({ step: 5 }, _this.attaPublicParams));
        }
        if (_this.monitoringJsApiReport) {
            _this.bindJsApiMonitoringEvent();
        }
        return _this;
    }
    Reporter.prototype.init = function () {
        this.publicParams = new PublicParams(this.options); // 创建公参
        this.attaPublicParams = this.getAttaReportPublicParams(); // 创建质量监控参数
        this.privateParams = new PrivateParams(); // 创建私参
        this.pageManager = new PageManager(); // 创建页面管理器
        this.channel = new ChannelManager(this.options, this.publicParams.get('scenes_plat'), this.publicParams.get('scenes_version')); // 创建上报通道实例
        this.use(compatVideoReport); // VR 上报兼容
        this.monitoringReport && attaReport(__assign({ step: 1 }, this.attaPublicParams));
        return this;
    };
    /**
     * sdk质量监控
     */
    Reporter.prototype.bindSdkMonitoringEvent = function () {
        var _this = this;
        if (this.channel) {
            this.channel.on('initChannel', function (context) {
                attaReport(__assign(__assign({ step: 0 }, _this.attaPublicParams), context));
                var deviceId = context.deviceId;
                _this.deviceId = deviceId;
                _this.emit('initChannel', context);
            });
            this.channel.on('beaconInitFail', function (context) {
                attaReport(__assign(__assign({ step: 2 }, _this.attaPublicParams), context));
            });
            this.channel.on('monitoringReport', function (context) {
                var _a, _b, _c;
                attaReport(__assign(__assign({ step: 6 }, _this.attaPublicParams), { page_params: JSON.stringify((context === null || context === void 0 ? void 0 : context.pageParams) || {}), device_id: context.deviceId || '', report_type: context.reportType || '', event_type: context.eventName || '', is_return: (_a = context === null || context === void 0 ? void 0 : context.publicParams) === null || _a === void 0 ? void 0 : _a.dt_pg_isreturn, hc_pvid: (_b = context === null || context === void 0 ? void 0 : context.publicParams) === null || _b === void 0 ? void 0 : _b.hc_pvid, eid: (_c = context === null || context === void 0 ? void 0 : context.publicParams) === null || _c === void 0 ? void 0 : _c.dt_eid }));
            });
        }
        return this;
    };
    /**
     * jsapi质量上报监控
     */
    Reporter.prototype.bindJsApiMonitoringEvent = function () {
        var _this = this;
        this.channel.on('jsApiReport', function (context) {
            attaReport(__assign(__assign(__assign({}, context), _this.attaPublicParams), { appkey: _this.options.beacon }), JS_API_ATTA);
        });
    };
    /**
     * 获取质量监控上报参数
     */
    Reporter.prototype.getAttaReportPublicParams = function () {
        return {
            platform: this.publicParams.get('platform'),
            hardware_os: this.publicParams.get('hardware_os'),
            os_version: this.publicParams.get('os_version'),
            session_id: this.publicParams.get('dt_sessionid_h5'),
            sdk_version: this.publicParams.get('dt_sdkversion_h5'),
            omgid: this.publicParams.get('dt_omgid'),
            monitoring_report_id: this.monitoringReportId,
        };
    };
    /**
     * 浏览器环境检查
     */
    Reporter.prototype.checkBrowserEnvironment = function () {
        if (!navigator.cookieEnabled) { // 灯塔强依赖localStorage，若cookie被禁用则无法上报
            console.error('[universalReport] universal report init fail: cookie is disabled');
            return false;
        }
        return true;
    };
    /**
     * 设置首次曝光标志
     */
    Reporter.prototype.setFirstPVFlag = function (pgid, flag) {
        this.firstPVReportMap[pgid] = flag;
    };
    /**
     * 初始化插件
     */
    Reporter.prototype.initPlugin = function () {
        var isDisableDtPlugin = this.options.isDisableDtPlugin; // 控制是否加载插件
        if (isDisableDtPlugin)
            return this;
        if (getUrlParameter('reportView') === '1') { // 带有reportView参数直接加载
            this.loadDtPlugin();
            this.setPluginTokenByParam();
            return this;
        }
        this.loadDtPluginByToken(); // 根据token有效期判断是否加载
        return this;
    };
    /**
     * 设置插件token
     */
    Reporter.prototype.setPluginTokenByParam = function () {
        if (getUrlParameter('setToken') === '1') { // 同时带有reportView及setToken参数
            var time = Date.now() + 1000 * 86400 * 7; // 过期时间为7天
            localStorage.setItem('pluginToken', "" + time);
        }
    };
    /**
     * 根据标志位加载数据校验插件
     */
    Reporter.prototype.loadDtPluginByToken = function () {
        var expired = localStorage.getItem('pluginToken'); // 根据localStorage标志判断
        if (!expired)
            return;
        var now = Date.now();
        if (now < parseInt(expired, 10)) { // 未过期，加载插件
            this.loadDtPlugin();
        }
        else {
            localStorage.removeItem('pluginToken');
        }
    };
    /**
     * 加载数据校验插件
     */
    Reporter.prototype.loadDtPlugin = function () {
        var _this = this;
        var _a;
        this.monitoringReport = true;
        this.isEnablePlugin = true; // 设置启用plugin标志
        var beacon = this.options.beacon;
        if (typeof beacon === 'string') {
            this.beaconAppkey = beacon; // 灯塔appkey供数据校验插件使用
        }
        else if (typeof beacon === 'object') {
            this.beaconAppkey = (_a = beacon === null || beacon === void 0 ? void 0 : beacon.baseInfo) === null || _a === void 0 ? void 0 : _a.appkey; // 从灯塔实例中获取appkey
        }
        loadScript('https://vm.gtimg.cn/tencentvideo/script/universal-report-plugin-view.min.js')
            .then(function () {
            _this.use(window.universalReportPluginView);
        })
            .catch(function (err) {
            console.error("[universalReport] universalReportPluginView failed to initialize: \n        " + (err.message || ''));
        });
    };
    Reporter.prototype.initObserver = function () {
        this.use(observer);
        return this;
    };
    /**
     * 初始化埋点页面
     * 获取埋点页面元素，观察元素以及子元素，开始上报
     */
    Reporter.prototype.initPage = function (dom) {
        var _this = this;
        var $pages = dom ? [dom] : document.querySelectorAll("[" + "dt-pgid" /* PAGE */ + "]");
        if (!$pages.length)
            return this;
        var contentidSet = this.options.contentidSet;
        Array.from($pages).forEach(function ($page) {
            var _a, _b;
            var pgid = (_a = $page.getAttribute("dt-pgid" /* PAGE */)) === null || _a === void 0 ? void 0 : _a.trim();
            if (!pgid || _this.pageManager.hasPage(pgid))
                return;
            var contentid = contentidSet ? contentidSet[pgid] : '';
            var params = querystringify_1.parse((_b = $page.getAttribute("dt-params" /* PARAMS */)) !== null && _b !== void 0 ? _b : '');
            if (params.ref_pg) {
                var refPg = querystringify_1.parse(params.ref_pg);
                params.ref_pg = refPg.pgid ? refPg : {};
            }
            if (params.ref_ele) {
                var refEle = querystringify_1.parse(params.ref_ele);
                params.ref_ele = refEle.eid ? refEle : {};
            }
            if (contentid) {
                params.contentid = contentid;
            }
            var pageParams = __assign({ pgid: pgid }, params);
            _this.setPage(pageParams, $page);
            _this.observe(pgid);
        });
        return this;
    };
    /**
     * 监听页面属性变化
     * 页面 `dt-pgid` 属性修改需要重新初始化页面
     * 页面 `dt-params` 属性修改需要同步更新 `pageParams`
     */
    Reporter.prototype.onPageAttrChange = function () {
        var _this = this;
        this.on('pageIdChange', function (dom, oldPgid) {
            _this.pageManager.removePage(oldPgid);
            _this.observer.ReportTree.detachDom(dom);
            _this.initPage(dom);
        });
        this.on('pageParamsChange', function (dom, pgid) {
            var _a;
            var params = querystringify_1.parse((_a = dom.getAttribute("dt-params" /* PARAMS */)) !== null && _a !== void 0 ? _a : '');
            var refPg = params.ref_pg;
            var refEle = params.ref_ele;
            if (refPg) {
                params.ref_pg = querystringify_1.parse(refPg);
            }
            if (refEle) {
                params.ref_ele = querystringify_1.parse(refEle);
            }
            _this.setPageParams(__assign({ pgid: pgid }, params));
        });
        return this;
    };
    /**
     * SDK设置事件监听回调
     */
    Reporter.prototype.setEventHandler = function () {
        var _this = this;
        this.pageVisibilityHandler = function () {
            if (document.visibilityState === 'hidden') {
                _this.reportPgOut('', true);
            }
            if (document.visibilityState === 'visible') {
                _this.reportPV();
            }
        };
    };
    /**
     * 浏览器标签页隐藏或显示监听
     * 应用只有一个 `pgid` 的时候才会上报，多 `pgid` 应用需要自己监听
     * FIXME: hold=1时，不应该上报
     */
    Reporter.prototype.addPageVisibilityChangeListener = function () {
        var isDisableVisibilitychangeListener = this.options.isDisableVisibilitychangeListener;
        !isDisableVisibilitychangeListener
            && document.addEventListener('visibilitychange', this.pageVisibilityHandler);
        return this;
    };
    /**
     * 移除浏览器标签页隐藏或显示监听
     */
    Reporter.prototype.removePageVisibilityChangeListener = function () {
        document.removeEventListener('visibilitychange', this.pageVisibilityHandler);
        return this;
    };
    /**
     * 监听通道管理器上报事件
     * 然后通知可视化插件上报事件
     */
    Reporter.prototype.onChannelReport = function () {
        var _this = this;
        this.channel.on('report', function (context) {
            _this.emit('report', {
                type: 'dt',
                event: context.eventName,
                data: formatData(context),
                uid: context.uid,
                eventTime: context.eventTime,
            });
        });
        if (this.videoReport) {
            this.videoReport.channel.on('report', function (context) {
                _this.emit('report', {
                    type: 'vr',
                    event: context.eventName,
                    data: formatData(context, 'kv'),
                    uid: context.uid,
                    eventTime: context.eventTime,
                });
            });
        }
        return this;
    };
    /**
     * 设置页面
     * @param {object} pageParams               页面参数
     * @param {object} pageParams.pgid          页面 ID
     * @param {HTMLElement | string} [pageRoot] 页面根节点
     */
    Reporter.prototype.setPage = function (pageParams, pageRoot) {
        var pgid = pageParams === null || pageParams === void 0 ? void 0 : pageParams.pgid;
        if (this.pageManager.hasPage(pgid))
            return this;
        this.pageManager.addPage({
            pageParams: pageParams,
            pageRoot: pageRoot,
        });
        return this;
    };
    /**
     * 页面曝光
     * @param {string} pgid 页面 ID
     */
    Reporter.prototype.reportPV = function (pgid) {
        var _a, _b, _c;
        var fixPgid = this.pageManager.fixPgid(pgid);
        var $pageRoot = (_a = this.pageManager.getPage(fixPgid)) === null || _a === void 0 ? void 0 : _a.pageRoot;
        var reportNode = getReportNode($pageRoot);
        var pgIgnore = (_b = reportNode === null || reportNode === void 0 ? void 0 : reportNode.data) === null || _b === void 0 ? void 0 : _b.pgIgnore;
        var pginIgnore = (_c = reportNode === null || reportNode === void 0 ? void 0 : reportNode.data) === null || _c === void 0 ? void 0 : _c.pginIgnore;
        var uid = reportNode === null || reportNode === void 0 ? void 0 : reportNode.uid;
        this.monitoringReport && attaReport(__assign({ step: 8, pgid: fixPgid, report_node: !!reportNode, pg_ignore: pgIgnore }, this.attaPublicParams));
        if (!fixPgid || !reportNode || pgIgnore || pginIgnore)
            return this;
        reportNode.updateNode(); // 更新上报节点
        this.pageManager.updatePage(fixPgid); // 更新页面状态
        var _d = this.pageManager.getPage(fixPgid).pageParams, contentid = _d.contentid, lastContentid = _d.last_contentid;
        if (contentid) {
            var pgIsReturn = 0;
            if (lastContentid === contentid) { // 页面ID相同，判断为重复曝光，标志位为1
                pgIsReturn = 1;
            }
            else {
                this.pageManager.setPage({
                    pageParams: {
                        pgid: fixPgid,
                        last_contentid: contentid,
                    },
                });
            }
            this.privateParams.set('dt_pg_isreturn', pgIsReturn, [
                STANDARD_EVENTS.PGIN,
            ]); // 设置页面
        }
        else {
            this.privateParams.remove('dt_pg_isreturn');
        }
        this.reportEvent({
            pgid: fixPgid,
            uid: uid,
            eventName: STANDARD_EVENTS.PGIN,
            eventTime: Date.now(),
        });
        return this;
    };
    /**
     * 页面结束曝光
     * @param {string} pgid 页面 ID
     * @param {boolean} isSendBeacon 是否使用sendBeacon上报
     * @param {number} [pageInfo.area]    页面面积，单位为 px²
     * @param {number} [pageInfo.impArea] 页面最大曝光面积，单位 px²
     */
    Reporter.prototype.reportPgOut = function (pgid, isSendBeacon, pageInfo) {
        var _a, _b, _c, _d, _e;
        if (pageInfo === void 0) { pageInfo = {}; }
        if (typeof pageInfo !== 'object') {
            console.warn('[universalReport] reportPgOut pageInfo is invalid.');
        }
        var fixPgid = this.pageManager.fixPgid(pgid);
        var page = this.pageManager.getPage(fixPgid);
        var reportNode = getReportNode(page === null || page === void 0 ? void 0 : page.pageRoot);
        var pgIgnore = (_a = reportNode === null || reportNode === void 0 ? void 0 : reportNode.data) === null || _a === void 0 ? void 0 : _a.pgIgnore;
        var pgoutIgnore = (_b = reportNode === null || reportNode === void 0 ? void 0 : reportNode.data) === null || _b === void 0 ? void 0 : _b.pgoutIgnore;
        var uid = reportNode === null || reportNode === void 0 ? void 0 : reportNode.uid;
        if (!fixPgid || !page || !reportNode || pgIgnore || pgoutIgnore)
            return this;
        // 页面总面积
        var pgArea = (_c = pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.area) !== null && _c !== void 0 ? _c : reportNode.effectiveWidth * reportNode.effectiveHeight;
        // 页面最大曝光面积
        var pgImpArea = (_d = pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.impArea) !== null && _d !== void 0 ? _d : reportNode.maxIntersectArea;
        // 曝光周期内页面最大曝光比例
        var impRate = pgArea ? Math.min(pgImpArea / pgArea, 1) : 0;
        var pgOutParams = {
            dt_pg_area: pgArea.toFixed(2),
            dt_pg_imp_area: pgImpArea.toFixed(2),
            dt_lvtm: page.showTime ? Date.now() - page.showTime : 0,
            dt_clck_flag: (_e = page.clckFlag) !== null && _e !== void 0 ? _e : '0',
            dt_pg_imp_rate: impRate.toFixed(2),
        };
        this.reportEvent({
            pgid: fixPgid,
            uid: uid,
            eventName: STANDARD_EVENTS.PGOUT,
            eventTime: Date.now(),
            publicParams: pgOutParams,
            pageParams: renameParams(pgOutParams),
            isSendBeacon: isSendBeacon,
        });
        return this;
    };
    /**
     * 元素上报
     * @description 元素上报包括元素点击、元素曝光、元素结束曝光事件，
     * 元素上报需要记录页面是否有点击，开始曝光时间，以及上报元素路径
     * @param {HTMLElement | string} element      必填参数，上报元素
     * @param {string} context                    上报对象
     * @param {string} context.pgid               必填参数，页面 ID
     * @param {string} context.eventName          必填参数，事件名称
     * @param {object} context.businessParams     业务参数
     * @param {object} context.businessParams.eid 必填参数，元素 ID
     */
    Reporter.prototype.reportElement = function (element, context) {
        var _a;
        var $ele = getDom(element);
        var eid = (_a = context === null || context === void 0 ? void 0 : context.businessParams) === null || _a === void 0 ? void 0 : _a.eid;
        if (!eid || !$ele)
            return this;
        var fixPgid = this.pageManager.fixPgid(context === null || context === void 0 ? void 0 : context.pgid);
        var eventName = context === null || context === void 0 ? void 0 : context.eventName;
        var hasPage = this.pageManager.hasPage(fixPgid);
        var isValidEvent = [
            STANDARD_EVENTS.IMP,
            STANDARD_EVENTS.IMPEND,
            STANDARD_EVENTS.CLCK,
        ].includes(eventName);
        var impEndParams = {};
        if (!hasPage || !isValidEvent) {
            console.error(!hasPage
                ? "[universalReport] the page does not exist " + fixPgid + " " + eid + " " + eventName
                : '[universalReport] eventName can only be `dt_imp` and `dt_imp_end` or `dt_clck`');
            return this;
        }
        // 元素路径参数
        var reportNode = getClosestParentNode($ele);
        var businessParams = getElementPath(reportNode, this.options.formatMode, __assign({}, context.businessParams));
        if (eventName === STANDARD_EVENTS.CLCK) {
            var page_1 = this.pageManager.getPage(fixPgid);
            page_1.clckFlag = '1'; // 记录当前页面有埋点元素点击
        }
        else if (eventName === STANDARD_EVENTS.IMP) {
            $ele.showTime = Date.now(); // 记录元素开始曝光时间
        }
        else {
            impEndParams = calculateImpEndParams($ele); // 计算元素结束曝光参数
        }
        // 获取当前元素uid
        var curReportNode = getReportNode($ele);
        var uid = curReportNode === null || curReportNode === void 0 ? void 0 : curReportNode.uid;
        this.reportEvent(__assign(__assign({ pgid: fixPgid, uid: uid, eventTime: Date.now() }, context), { publicParams: __assign(__assign({ dt_eid: eid }, impEndParams), context.publicParams), businessParams: __assign(__assign({}, renameParams(impEndParams)), businessParams) }));
        return this;
    };
    /**
     * 上报事件
     * @param {string} context.pgid             页面 ID
     * @param {string} context.eventName        事件名称
     * @param {object} [context.pageParams]     页面参数
     * @param {object} [context.publicParams]   公共参数
     * @param {object} [context.businessParams] 业务参数
     */
    Reporter.prototype.reportEvent = function (context) {
        var _a, _b;
        if (context === void 0) { context = {}; }
        var $context = context;
        if (this.monitoringReport) {
            attaReport(__assign(__assign({ step: 3 }, this.attaPublicParams), { page_params: JSON.stringify(($context === null || $context === void 0 ? void 0 : $context.pageParams) || {}), event_type: $context === null || $context === void 0 ? void 0 : $context.eventName }));
            Object.assign($context, {
                monitoringReport: true,
            });
        }
        var eventName = $context === null || $context === void 0 ? void 0 : $context.eventName;
        $context.eventTime = ($context === null || $context === void 0 ? void 0 : $context.eventTime) || Date.now();
        $context.publicParams = (_a = $context.publicParams) !== null && _a !== void 0 ? _a : {};
        $context.publicParams.dt_eventid_h5 = this.eventId; // 自增事件ID
        this.eventId += 1;
        if (!eventName) {
            console.error('[universalReport] eventName cannot be empty');
            return this;
        }
        var reportContext = this.formatContext($context);
        this.channel.report(reportContext);
        (_b = this.videoReport) === null || _b === void 0 ? void 0 : _b.report(reportContext);
        return this;
    };
    /**
     * 使用sendBeacon进行上报
     * @param {string} context.pgid             页面 ID
     * @param {string} context.eventName        事件名称
     * @param {object} [context.pageParams]     页面参数
     * @param {object} [context.publicParams]   公共参数
     * @param {object} [context.businessParams] 业务参数
     */
    Reporter.prototype.reportBeaconEvent = function (context) {
        if (context === void 0) { context = {}; }
        this.monitoringReport && attaReport(__assign(__assign({ step: 3 }, this.attaPublicParams), { page_params: JSON.stringify((context === null || context === void 0 ? void 0 : context.pageParams) || {}) }));
        Object.assign(context, {
            isSendBeacon: true,
        });
        return this.reportEvent(context);
    };
    /**
     * 开始观察页面
     * @description 观察页面根节点下的埋点元素，开始上报
     * @param {string} pgid 页面 ID
     */
    Reporter.prototype.observe = function (pgid) {
        var _a;
        var fixPgid = this.pageManager.fixPgid(pgid);
        var $pageRoot = (_a = this.pageManager.getPage(fixPgid)) === null || _a === void 0 ? void 0 : _a.pageRoot;
        if (!fixPgid || !$pageRoot)
            return this;
        if (!$pageRoot.hasAttribute("dt-pgid" /* PAGE */)) {
            $pageRoot.setAttribute("dt-pgid" /* PAGE */, fixPgid);
        }
        this.observer.ReportTree.attachDom($pageRoot);
        if (!this.firstPVReportMap[fixPgid] // 将首次曝光时机提前
            && $pageRoot.getAttribute("dt-pg-ignore" /* PG_IGNORE */) !== 'true'
            && $pageRoot.getAttribute("dt-pgin-ignore" /* PGIN_IGNORE */) !== 'true'
            && $pageRoot.getAttribute("dt-cmd" /* COMMAND */) !== 'hold=true') { // 判断是否忽略曝光或延迟上报
            this.setFirstPVFlag(fixPgid, 'first_reported');
            this.reportPV(fixPgid);
        }
        return this;
    };
    /**
     * 停止观察页面
     * @description 停止观察页面根节点下的埋点元素，不再上报
     * @param {string} pgid 页面 ID
     */
    Reporter.prototype.unobserve = function (pgid) {
        var _a;
        var fixPgid = this.pageManager.fixPgid(pgid);
        var $pageRoot = (_a = this.pageManager.getPage(fixPgid)) === null || _a === void 0 ? void 0 : _a.pageRoot;
        if (!fixPgid || !$pageRoot)
            return this;
        $pageRoot.removeAttribute("dt-pgid" /* PAGE */);
        this.pageManager.removePage(fixPgid);
        this.observer.ReportTree.detachDom($pageRoot);
        this.firstPVReportMap[fixPgid] = null;
        return this;
    };
    /**
     * 格式化上报对象
     * @description 完整的上报对象需要整合事件公共参数、事件私有参数、页面参数
     * @param {IContext} context 上报对象
     */
    Reporter.prototype.formatContext = function (context) {
        var fixPgid = this.pageManager.fixPgid(context === null || context === void 0 ? void 0 : context.pgid);
        var eventName = context === null || context === void 0 ? void 0 : context.eventName;
        // 页面参数
        var pageParams = this.getPageParams(fixPgid);
        // 事件公共参数，所有事件参数
        var publicParams = this.getPublicParams();
        // 事件私有参数，部分事件参数
        var privateParams = this.privateParams.getEventPrivateParams(eventName);
        // 公参同步页面参数，方便 ETL 解析
        var publicPageParams = this.publicParams.getPublicPageParams(pageParams);
        return __assign(__assign({}, context), { publicParams: __assign(__assign(__assign(__assign({}, publicParams), privateParams), publicPageParams), context.publicParams), pageParams: __assign(__assign({}, pageParams), context.pageParams), businessParams: context.businessParams || {} });
    };
    /**
     * 获取元素上报参数
     * @description 获取上报信息中 `udf_kv` 参数
     * @param {HTMLElement | string} element 上报元素
     * @param {0 | 1} [formatMode]           数据打平模式
     */
    Reporter.prototype.getReportParams = function (element, formatMode) {
        if (formatMode === void 0) { formatMode = this.options.formatMode; }
        var $ele = getDom(element);
        if (!$ele)
            return '';
        var reportNode = getReportNode($ele);
        if (!reportNode)
            return '';
        var pgid = getNodeParam(reportNode, 'pgid');
        var eid = reportNode.data.eid;
        if (!pgid || !eid)
            return '';
        // 元素路径参数
        var businessParams = getElementPath(reportNode, formatMode, __assign({ eid: eid }, reportNode.data.params));
        var context = this.formatContext({
            pgid: pgid,
            businessParams: businessParams,
        });
        return formatData(context).udf_kv;
    };
    /**
     * 设置页面参数
     * @param {object} pageParams.pgid 页面 pgid
     */
    Reporter.prototype.setPageParams = function (pageParams) {
        this.pageManager.setPage({
            pageParams: pageParams,
        });
        return this;
    };
    /**
     * 获取页面参数
     * @param {string} pgid   页面 ID
     * @param {string} [name] 页面参数 key
     */
    Reporter.prototype.getPageParams = function (pgid, name) {
        var _a, _b, _c;
        var fixPgid = this.pageManager.fixPgid(pgid);
        if (!fixPgid)
            return {};
        var pageParams = (_b = (_a = this.pageManager.getPage(fixPgid)) === null || _a === void 0 ? void 0 : _a.pageParams) !== null && _b !== void 0 ? _b : {};
        if (name) {
            return (_c = pageParams[name]) !== null && _c !== void 0 ? _c : '';
        }
        return pageParams;
    };
    /**
     * 获取公共参数
     * @param name {string} [name] 公共参数 key
     * @return {string|object} 如果指定参数名，返回特定参数；否则返回全部参数
     */
    Reporter.prototype.getPublicParams = function (name) {
        return this.publicParams.get(name);
    };
    /**
     * 设置公共参数
     * @param {object} publicParams 公共参数
     */
    Reporter.prototype.setPublicParams = function (publicParams, type) {
        var _a;
        if (publicParams === void 0) { publicParams = {}; }
        if (type === void 0) { type = "publicParams" /* PUBLIC_PARAMS */; }
        this.publicParams.set(publicParams, type);
        (_a = this.videoReport) === null || _a === void 0 ? void 0 : _a.convertPublicParams(this.getPublicParams(), type === "publicParams" /* PUBLIC_PARAMS */ ? publicParams : {});
        return this;
    };
    /**
     * 删除公共参数
     * @param {string | string[]} paramName 删除参数名
     */
    Reporter.prototype.removePublicParams = function (paramName) {
        if (paramName === void 0) { paramName = ''; }
        this.publicParams.remove(paramName);
        return this;
    };
    /**
     * 设置账号信息
     * @param {string} accountInfo.dt_qq_h5        QQ
     * @param {string} accountInfo.dt_qqopenid_h5  QQ OPENID
     * @param {string} accountInfo.dt_wxopenid_h5  微信 OPENID
     * @param {string} accountInfo.dt_wbopenid_h5  微博 OPENID
     * @param {string} accountInfo.dt_mainlogin_h5 登录类型
     */
    Reporter.prototype.setAccountInfo = function (accountInfo) {
        this.setPublicParams(accountInfo, "accountInfo" /* ACCOUNT_INFO */);
        return this;
    };
    /**
     * 清空账号信息
     */
    Reporter.prototype.clearAccountInfo = function () {
        this.setPublicParams(defAccountInfo, "accountInfo" /* ACCOUNT_INFO */);
        return this;
    };
    /**
     * 设置元素控制命令
     * @param {HTMLElement | string} element 元素
     * @param {boolean} command.hold         是否延迟上报
     */
    Reporter.prototype.setCommand = function (element, command) {
        var _a;
        var $ele = getDom(element);
        if (!$ele || !command)
            return this;
        var originCommand = querystringify_1.parse((_a = $ele.getAttribute("dt-cmd" /* COMMAND */)) !== null && _a !== void 0 ? _a : '');
        $ele.setAttribute("dt-cmd" /* COMMAND */, querystringify_1.stringify(__assign(__assign({}, originCommand), command)));
    };
    /**
     * 设置页面内容 ID
     * @description dt_pgin dt_pgout dt_imp dt_imp_end dt_clck 事件增加私参 dt_pg_contentid
     * @param {string} contentid 内容 ID
     */
    Reporter.prototype.setPageContentId = function (contentid) {
        if (!contentid)
            return;
        this.privateParams.set('dt_pg_contentid', contentid, [
            STANDARD_EVENTS.PGIN,
            STANDARD_EVENTS.PGOUT,
            STANDARD_EVENTS.IMP,
            STANDARD_EVENTS.IMPEND,
            STANDARD_EVENTS.CLCK,
        ]);
        return this;
    };
    /**
     * 设置多页面内容 ID, 用于判断是否重复曝光
     * @description 设置页面contentid参数
     * @param {IContentidSet} contentidSet 页面内容 ID集
     */
    Reporter.prototype.setMultiPageContentids = function (contentidSet) {
        var _this = this;
        if (!contentidSet)
            return;
        var pgidSet = Object.keys(contentidSet);
        pgidSet.forEach(function (pgid) {
            if (_this.pageManager.hasPage(pgid)) {
                var contentid = contentidSet[pgid];
                _this.pageManager.setPage({
                    pageParams: {
                        pgid: pgid,
                        contentid: contentid,
                    },
                });
            }
        });
        return this;
    };
    __decorate([
        doAfterDomReady,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Object)
    ], Reporter.prototype, "initObserver", null);
    __decorate([
        doAfterDomReady,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Object)
    ], Reporter.prototype, "initPage", null);
    __decorate([
        doAfterDomReady,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Object)
    ], Reporter.prototype, "reportPV", null);
    __decorate([
        doAfterDomReady,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Object)
    ], Reporter.prototype, "reportEvent", null);
    __decorate([
        doAfterDomReady,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Object)
    ], Reporter.prototype, "reportBeaconEvent", null);
    __decorate([
        doAfterDomReady,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Object)
    ], Reporter.prototype, "observe", null);
    __decorate([
        doAfterDomReady,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Object)
    ], Reporter.prototype, "unobserve", null);
    return Reporter;
}(Pluggable));

removeProxy(); // 服务器端兼容

export default Reporter;
